export type Language = "ar" | "en";

export function servingsLabel(lang: Language, count: number): string {
  if (lang === "ar") {
    return `عدد الحصص: ${count}`;
  }
  return count === 1 ? "1 serving" : `${count} servings`;
}

export const languages: { code: Language; label: string; dir: "rtl" | "ltr" }[] = [
  { code: "ar", label: "العربية", dir: "rtl" },
  { code: "en", label: "English", dir: "ltr" },
];

export const translations: Record<Language, Record<string, string>> = {
  ar: {
    appTitle: "بيور لايف",
    appSubtitle: "اكتشف وصفات رائعة من مكونات ثلاجتك",
    bannerTitle: "حياتك الصحية",
    bannerSubtitle: "حياتك الصحية",
    helpFridgeLabel: "الثلاجة الذكية",
    helpScanLabel: "مسح الطعام بالذكاء",
    helpBarcodeLabel: "ماسح الباركود",
    helpRecipesLabel: "البحث عن الوصفات",
    helpMenuLabel: "قائمة الطعام",
    helpSavedLabel: "الوصفات المحفوظة",
    helpWLLabel: "برنامج إنقاص الوزن",
    helpStepsLabel: "عداد الخطوات",
    helpHealthScoreLabel: "تقييم صحة الطعام",
    helpAllergyLabel: "فحص الحساسية الغذائية",
    helpWaterLabel: "تتبع شرب الماء",
    helpNutritionLabel: "مخطط القيم الغذائية",
    helpCalorieCompareLabel: "مقارنة السعرات",
    helpMusicLabel: "مشغل الموسيقى",
    prepareDishes: "تحضير الأطباق",
    nutritionCompare: "مقارنة غذائية",
    dietFilters: "الفلاتر الغذائية",
    categories: "التصنيفات",
    noFilterResults: "لا توجد نتائج بهذا الفلتر",
    savedAiRecipes: "وصفات محفوظة من الذكاء الاصطناعي",
    recentSearches: "عمليات البحث السابقة",
    clearAll2: "مسح الكل",
    noResultsFound: "لا توجد نتائج",
    glutenFreeEmptyState: "تظهر هنا الوصفات المؤكدة الكاملة المكونات فقط. الوصفات غير مكتملة المكونات أو غير المؤكدة لا تُحتسب ضمن الخيارات الخالية من الجلوتين.",
    nutritionBasisUnverified: "بيانات المكونات غير مكتملة — القيم الغذائية المعروضة تقديرية ولم يتم التحقق من أساس الحصة. لا تعتمد عليها كحقائق مؤكدة لكل حصة.",
    pickIngredientsHint: "اختار مكونات تجهيز الطبق",
    noIngredientsMatch: "لا توجد مكونات تطابق",
    waterReminderEnabled: "تم تفعيل تذكير شرب الماء",
    waterReminderDisabled: "تم إيقاف تذكير شرب الماء",
    greetingHi: "مرحباً، ",
    fridgeTab: "مكونات الثلاجة",
    fridgeTabDesc: "اعرف مكونات طعامك وقيمها الغذائية بالتفصيل",
    recipesTab: "الأطباق الرئيسية",
    recipesTabDesc: "ابحث عن وصفات صحية ولذيذة تناسب هدفك الغذائي",
    menuTab: "قائمة الطعام",
    nutritionTab: "القيم الغذائية",
    selectIngredients: "اختر المكونات المتوفرة لديك",
    findRecipes: "ابحث عن الوصفات",
    availableIngredients: "المكونات المتوفرة",
    suggestedRecipes: "الوصفات المقترحة",
    ingredients: "المكونات",
    steps: "طريقة التحضير",
    ovenTemp: "درجة حرارة الفرن/الطباخ",
    cookingTips: "نصائح الطهي والبهارات",
    servingTips: "طريقة التقديم",
    servings: "عدد الحصص",
    time: "وقت التحضير",
    calories: "السعرات الحرارية",
    protein: "البروتين",
    carbs: "الكربوهيدرات",
    fat: "الدهون",
    fiber: "الألياف",
    sodium: "الصوديوم",
    calcium: "الكالسيوم",
    noRecipes: "اختر مكونات لاكتشاف الوصفات",
    selectCategory: "اختر نوع الطعام",
    allCategories: "جميع الأصناف",
    soups: "الشوربات",
    salads: "السلطات",
    desserts: "الحلويات",
    breakfast: "الفطور",
    grilled: "المشويات",
    seafood: "المأكولات البحرية",
    athletes: "وجبات الرياضيين",
    juices: "العصائر والمشروبات",
    minutes: "دقيقة",
    persons: "أشخاص",
    personSingular: "شخص",
    nutritionTitle: "جدول القيم الغذائية لكل ١٠٠ جرام",
    food: "الغذاء",
    perHundredG: "لكل ١٠٠ جرام",
    selectAll: "تحديد الكل",
    clearAll: "إلغاء التحديد",
    matchPercent: "نسبة التطابق",
    viewRecipe: "عرض الوصفة",
    close: "إغلاق",
    saveRecipe: "حفظ الوصفة",
    savedRecipe: "تم الحفظ",
    shareRecipe: "مشاركة الوصفة",
    shareTitle: "وصفة رائعة من بيور لايف",
    shareCopied: "تم نسخ الرابط!",
    savedTab: "الوصفات",
    noSaved: "لا توجد وصفات محفوظة بعد",
    noSavedHint: "احفظ وصفاتك المفضلة لتجدها هنا",
    pastries: "المعجنات والحلويات",
    removeFromSaved: "إزالة من المحفوظات",
    optional: "اختياري",
    aiGenerate: "✨ وصفة بالذكاء الاصطناعي",
    aiGenerating: "جاري الإبداع...",
    aiRecipeTitle: "وصفة مولّدة بالذكاء الاصطناعي",
    aiError: "فشل التوليد، حاول مرة أخرى",
    aiDisclaimer: "وصفة أُنشئت بالذكاء الاصطناعي بناءً على مكوناتك",
    sugar: "السكر",
    perServing: "لكل حصة",
    aiFromCache: "من الذاكرة المخزنة",
    dishSearch: "ابحث عن أي طبق بالاسم...",
    dishSearchBtn: "بحث",
    aiIngredientsList: "المكونات والكميات",
    clearSearch: "مسح",
    dishNotFoundAi: "لم يُجد في الوصفات، جاري التوليد بالذكاء الاصطناعي...",
    scanTab: "مسح الطعام",
    scanTabDesc: "امسح أي طعام أو منتج للحصول على معلوماته الغذائية",
    scanTitle: "تعرف على طعامك بالذكاء الاصطناعي",
    scanSubtitle: "صوّر وجبتك وسيقدّر الذكاء الاصطناعي مكوناتها وقيمها الغذائية",
    takePhoto: "التقاط صورة",
    uploadPhoto: "رفع صورة",
    analyzeFood: "تحليل الطعام",
    retake: "إعادة التصوير",
    analyzing: "جاري تحليل الصورة...",
    analysisStep1: "تشغيل نموذج الرؤية...",
    analysisStep2: "التعرف على المكونات...",
    analysisStep3: "توليد الوصفة...",
    aiAnalyzerTitle: "محلل الطعام بالذكاء الاصطناعي",
    aiAnalyzingMeal: "جاري تحليل وجبتك...",
    aiCompleteMsg: "اكتمل التحليل!",
    aiStep1: "كشف الطعام", aiStep2: "تحديد المكونات", aiStep3: "تحليل التغذية",
    aiStep4: "حساب السعرات", aiStep5: "فحص السكر", aiStep6: "حساب البروتين",
    aiStatus1: "جاري كشف الطعام...", aiStatus2: "جاري مسح الوجبة...", aiStatus3: "جاري تحديد المكونات...",
    aiStatus4: "جاري تحليل القيم الغذائية...", aiStatus5: "جاري حساب السعرات...", aiStatus6: "جاري فحص السكر...",
    aiStatus7: "جاري تقدير البروتين...", aiStatus8: "جاري تجهيز تقرير التغذية...",
    aiBrainStatus: "الذكاء الاصطناعي يحلل وجبتك...",
    aiBrainDesc: "يحدد المكونات ويحسب القيم الغذائية بدقة عالية",
    aiComplete: "مكتمل",
    aiFewSeconds: "هذا يستغرق عادةً بضع ثوانٍ",
    aiTipTitle: "نصيحة صحية",
    aiTip1: "إضافة خضروات ملونة لوجباتك يزيد تنوع العناصر الغذائية التي تحصل عليها.",
    aiTip2: "البروتين يساعد على الشعور بالشبع ودعم العضلات أثناء خسارة الوزن.",
    aiTip3: "شرب كمية كافية من الماء خلال اليوم يدعم الصحة العامة ويساعد على التحكم بالشهية.",
    aiPrivacy: "بياناتك خاصة وآمنة",
    aiErrorTitle: "تعذر تحليل هذه الوجبة",
    aiRetryBtn: "حاول مرة أخرى",
    aiNewPhotoBtn: "التقاط صورة جديدة",
    confirmDish: "ما الطبق الذي تراه؟",
    confirmSubtitle: "اختر الخيار الصحيح أو عدّله",
    confidence: "دقة التعرف",
    generateRecipe: "توليد الوصفة",
    typeManually: "أدخل الاسم يدوياً",
    notFood: "لم يتم التعرف على طعام في الصورة",
    cropTitle: "اقتصاص الصورة",
    cropHint: "اسحب لتحديد المنطقة",
    cropApply: "تطبيق الاقتصاص",
    cropCancel: "إلغاء",
    cropBtn: "اقتصاص",
    lowConfidenceTitle: "الكشف غير واضح — اختر الأقرب",
    lowConfidenceSubtitle: "لم يتمكن الذكاء الاصطناعي من التأكد، اختر أحد الاحتمالات أو أدخل الاسم يدوياً",
    selectCandidate: "اختر هذا",
    selectedCandidate: "تم الاختيار",
    addManuallyBtn: "إضافة طعام يدوياً",
    manualEntryTitle: "أضف طعاماً يدوياً",
    manualEntryPlaceholder: "مثال: شاورما دجاج، سلطة، فلافل...",
    manualEntryBtn: "توليد الوصفة",
    scanError: "فشل التحليل، حاول مرة أخرى",
    scanHistory: "السجل اليومي",
    scanHistoryEmpty: "لا توجد وجبات مسجلة اليوم",
    todayCalories: "مجموع سعرات اليوم",
    saveToDiary: "حفظ في السجل",
    savedToDiary: "تم الحفظ في السجل",
    scanAnother: "مسح وجبة أخرى",
    cuisine: "المطبخ",
    alternatives: "أسماء بديلة",
    clearHistory: "مسح السجل",
    genderLabel: "الجنس", male: "ذكر", female: "أنثى",
    ageLabel: "العمر (سنة)", weightLabel: "الوزن (كجم)", heightLabel: "الطول (سم)",
    goalLabel: "هدفك", goalLose: "خسارة الوزن", goalMaintain: "الحفاظ على الوزن", goalGain: "زيادة الوزن",
    activityLabel: "مستوى النشاط", sedentary: "خامل", activityLight: "خفيف", activityModerate: "معتدل", activityActive: "نشيط",
    bmiLabel: "مؤشر كتلة الجسم", underweight: "نقص الوزن", normalWeight: "وزن طبيعي", overweight: "زيادة الوزن", obese: "سمنة",
    healthyRange: "النطاق الصحي", dailyCaloriesTarget: "هدف السعرات اليومية", macroTargets: "توزيع العناصر الغذائية",
    saveProfile: "حفظ الملف الشخصي", profileSaved: "تم الحفظ!",
    mealCompatibility: "ملاءمة الوجبة لهدفك", suitable: "مناسبة تماماً", moderatelySuitable: "مناسبة جزئياً", unsuitable: "غير مناسبة",
    betterOption: "خيار أفضل", noProfileSet: "أدخل بياناتك أولاً للتوصيات المخصصة",
    perMealTarget: "لكل وجبة",
    recommendedFoods: "الأطعمة الموصى بها", foodsToAvoid: "يُنصح بتجنبها",
    goalDesc_lose: "غنية بالبروتين، منخفضة السعرات", goalDesc_maintain: "نظام غذائي متوازن", goalDesc_gain: "غنية بالسعرات والبروتين",
    suitabilityScore: "نسبة الملاءمة",
    weightTab: "إنقاص الوزن", nutritionChartTitle: "مخطط التغذية",
    weightTabDesc: "تابع وزنك وتقدمك نحو هدفك بسهولة",
    helpBtn: "دليل الاستخدام",
    helpFridgeDesc: "اختر المكونات الموجودة في ثلاجتك وسيقترح التطبيق تلقائياً وصفات تناسب ما لديك",
    helpScanDesc: "صوّر أي وجبة أو طبق وسيحاول الذكاء الاصطناعي تحديدها وإعطاؤك الوصفة والقيمة الغذائية التقريبية — قد تكون النتائج غير دقيقة",
    helpRecipesDesc: "ابحث عن أي وصفة بالاسم، وإن لم تكن موجودة سيولّدها الذكاء الاصطناعي — يتطلب تسجيل الدخول وقد يستغرق وقتاً",
    helpMenuDesc: "اختر مكوناتك وسيبتكر الذكاء الاصطناعي وصفة جديدة مخصصة لك",
    helpWLDesc: "تتبع وزنك وسعراتك والعناصر الغذائية الكبرى اليومية، وتحدث مع المساعد الذكي المخصص لبرنامج إنقاص وزنك",
    helpNutritionDesc: "يعرض التطبيق قيمة غذائية تقريبية لكل وجبة بمخطط دائري يوضح نسب البروتين والدهون والكربوهيدرات — القيم تقديرية",
    beveragesTab: "المشروبات والعصائر", helpBeveragesDesc: "تصفح أكثر من 20 مشرباً وعصيراً حلالاً في الثلاجة — أضفها لوصفاتك أو قارن سعراتها", goalHealthy: "نمط حياة صحي",
    dietaryPrefsLabel: "التفضيلات الغذائية", allergensLabel: "الحساسية الغذائية",
    prefStandard: "عادي", prefVegetarian: "نباتي", prefVegan: "نباتي صرف", prefKeto: "كيتو", prefLowCarb: "قليل الكربوهيدرات", prefMediterranean: "متوسطي", prefHalal: "حلال", prefGlutenFree: "بدون جلوتين", prefDairyFree: "بدون ألبان",
    allergenGluten: "الجلوتين", allergenDairy: "منتجات الألبان", allergenLactose: "اللاكتوز", allergenEggs: "البيض", allergenPeanuts: "الفول السوداني", allergenTreeNuts: "المكسرات", allergenSoy: "الصويا", allergenFish: "السمك", allergenShellfish: "المحار والقشريات", allergenSesame: "السمسم", allergenMustard: "الخردل", allergenCelery: "الكرفس", allergenSulfites: "الكبريتيت", allergenLupin: "الترمس", allergenMollusks: "الرخويات",
    safeLabel: "آمن", warningLabel: "تحذير", dangerLabel: "خطر",
    allergenAlert: "تنبيه الحساسية", noAllergensDetected: "لم تُكتشف مسببات حساسية",
    healthScore: "نقاط الصحة", healthScoreExcellent: "ممتاز", healthScoreGood: "جيد", healthScoreFair: "مقبول", healthScorePoor: "ضعيف",
    getHealthScore: "احصل على تقييم الصحة (1 رصيد)",
    substituteLabel: "بدائل مقترحة",
    weightLossTab: "برنامج الوزن",
    wlSetupTitle: "إعداد برنامج إنقاص الوزن",
    wlSetupStep1: "بيانات الجسم",
    wlSetupStep2: "الهدف والموعد",
    wlSetupStep3: "المراجعة",
    wlTargetWeight: "الوزن المستهدف (كجم)",
    wlStartWeight: "وزن البداية (كجم)",
    wlTargetDate: "تاريخ الهدف",
    wlWeeklyLoss: "خسارة أسبوعية مستهدفة",
    wlDashboard: "لوحة التحكم",
    wlProgress: "التقدم",
    wlMeals: "وجبات مقترحة",
    wlLogMeal: "تسجيل وجبة",
    wlCaloriesIn: "مستهلك",
    wlCaloriesRemaining: "متبق",
    wlCaloriesBurned: "محروق",
    wlWater: "الماء",
    wlWaterGlasses: "أكواب الماء",
    wlSteps: "الخطوات",
    wlExercise: "تمرين",
    wlWeightHistory: "سجل الوزن",
    wlAddWeight: "تسجيل الوزن",
    wlBMI: "مؤشر كتلة الجسم",
    wlBMR: "معدل الأيض الأساسي",
    wlTDEE: "إجمالي إنفاق الطاقة اليومي",
    wlLostSoFar: "تم إنقاصه",
    wlToGo: "المتبقي للهدف",
    wlDaysLeft: "يوم متبق",
    wlGoalDate: "موعد الهدف",
    wlProgression: "نسبة الإنجاز",
    wlEstCompletion: "الإنجاز المتوقع",
    wlAchievements: "الإنجازات والشارات",
    wlWarningDeficit: "تحذير: العجز الكبير في السعرات قد يكون ضاراً بصحتك",
    wlWarningGoal: "الهدف قد يكون غير واقعي، ينصح بخسارة 0.5–1 كجم أسبوعياً",
    wlDisclaimer: "هذا التطبيق لأغراض تعليمية فقط وليس بديلاً عن الاستشارة الطبية المتخصصة",
    wlStartProgram: "بدء البرنامج",
    wlMealTime: "وقت الوجبة",
    wlBreakfast: "الإفطار",
    wlLunch: "الغداء",
    wlDinner: "العشاء",
    wlSnack: "وجبة خفيفة",
    wlMealName: "اسم الوجبة",
    wlSaveEntry: "حفظ",
    wlScore: "نقاط اللياقة",
    wlScoreExcellent: "ممتاز للرجيم",
    wlScoreGood: "جيد للرجيم",
    wlScoreFair: "مقبول",
    wlScorePoor: "غير مناسب",
    wlNext: "التالي",
    wlBack: "رجوع",
    wlEditGoal: "تعديل الهدف",
    wlAddGlass: "كوب ماء",
    wlAddSteps: "إضافة خطوات",
    wlMotivation: "رسالة اليوم",
    wlWeightKg: "الوزن (كجم)",
    wlWaistCm: "الخصر (سم) — اختياري",
    wlRecommendedCalories: "السعرات المُوصى بها",
    scoreTab: "تقييم الصحة",
    scoreTitle: "تقييم صحة الطعام بالذكاء الاصطناعي",
    scoreSubtitle: "حلل أي وجبة واحصل على نقاط صحية فورية",
    scoreFoodInput: "اكتب الطعام أو الوجبة (مثال: برجر + بطاطس + كولا)...",
    scoreAnalyze: "حلل الآن",
    scoreAnalyzing: "جاري التحليل...",
    scoreHealthy: "صحي جداً",
    scoreGood: "جيد",
    scoreFair: "مقبول",
    scorePoor: "غير صحي",
    scoreWarnings: "تحذيرات",
    scoreSuggestions: "اقتراحات للتحسين",
    scoreAnalysis: "التحليل السريع",
    scoreCompare: "مقارنة الوجبات",
    scoreAddMeal: "إضافة وجبة",
    scoreCompareMeals: "قارن الآن",
    scoreWinner: "الأصح",
    scoreHistory: "السجل السابق",
    scoreNoHistory: "لا توجد تحليلات سابقة",
    scoreGoalNote: "مُضبط حسب هدفك الصحي",
    scoreMeal: "وجبة",
    vitaminsSectionLabel: "الفيتامينات والمعادن",
    barcodeBtn: "قارئ الباركود",
    barcodeTitle: "مسح الباركود",
    barcodeSubtitle: "وجّه الكاميرا نحو الباركود للتعرف التلقائي",
    barcodeScanning: "جاري المسح...",
    barcodeNotSupported: "المتصفح لا يدعم قارئ الباركود",
    barcodeManualHint: "أدخل رقم الباركود يدوياً",
    barcodeSearch: "بحث",
    barcodeNotFound: "لم يُعثر على المنتج في قاعدة البيانات",
    barcodeBrand: "العلامة التجارية",
    barcodeNutritionPer100g: "القيم الغذائية / 100 غم",
    barcodeScanAgain: "مسح مرة أخرى",
    stepsTab: "عداد الخطوات", helpStepsDesc: "عدّ خطواتك اليومية واحسب السعرات المحروقة والمسافة المقطوعة — يعتمد على مستشعرات الجهاز والمتصفح",
    stepsTabDesc: "تتبع خطواتك اليومية والسعرات المحروقة والنشاط",
    walkTab: "المشي", walkTabDesc: "تتبع المشي بنظام GPS بدقة عالية — المسار والسرعة والسعرات والارتفاع",
    reportTab: "تقرير اليوم", reportTabDesc: "تقييم صحي شامل لإنجازاتك اليومية ونصائح لغدٍ أفضل",
    medsTab: "مركز الأدوية", medsTabDesc: "إدارة أدويتك وتذكيرات الجرعات بسهولة وأمان",
    helpReportDesc: "في نهاية كل يوم، احصل على تقييم شامل: كم شربت من الماء، كم مشيت، كم تناولت من البروتين والسكريات، مع نصائح ذكية لتحسين أدائك غداً",
    stepsToday: "خطوات اليوم", stepsGoal: "الهدف اليومي", stepsBurned: "سعرات محروقة", stepsDistance: "المسافة",
    stepsStart: "بدء العد", stepsStop: "إيقاف", stepsHistory: "آخر 7 أيام",
    stepsPermission: "اضغط للسماح باستخدام حساس الحركة", stepsPermissionBtn: "السماح بالوصول",
    stepsUnit: "خطوة", stepsActiveTime: "وقت النشاط", stepsGoalSet: "تحديد الهدف",
    stepsNotSupported: "هذا الجهاز لا يدعم حساس الحركة", stepsReset: "إعادة ضبط", stepsKm: "كم",
    stepsSaved: "تم الحفظ", stepsMin: "دقيقة", stepsGoalLabel: "الهدف",
    networkError: "انقطع الاتصال بالإنترنت — تحقق من اتصالك وأعد المحاولة",
    networkOfflineBanner: "أنت غير متصل بالإنترنت",
    retryBtn: "إعادة المحاولة",
    signIn: "تسجيل الدخول", signUp: "إنشاء حساب", signOut: "تسجيل الخروج", signOutThisDevice: "تسجيل الخروج من هذا الجهاز",
    authEmail: "البريد الإلكتروني", authPassword: "كلمة المرور",
    authTitle: "حساب المستخدم", authSignedInAs: "مسجّل دخول بـ",
    authSyncBanner: "سجّل دخولك لمزامنة خطواتك عبر أجهزتك",
    authError: "خطأ في المصادقة — تحقق من بياناتك",
    authWrongPassword: "كلمة المرور غير صحيحة",
    authEmailNotFound: "البريد الإلكتروني غير مسجل — أنشئ حساباً أولاً",
    authEmailExists: "هذا البريد الإلكتروني مسجل بالفعل — سجّل دخولك بدلاً من ذلك",
    authInvalidEmail: "البريد الإلكتروني غير صالح",
    authSignUpSuccess: "تم إنشاء الحساب بنجاح",
    authBodyTitle: "بيانات جسمك", authBodySubtitle: "أدخل بياناتك لاستخدامها في برنامج إنقاص الوزن",
    authBodySave: "حفظ المعلومات", authBodyError: "تحقق من القيم المدخلة", authBodySaveError: "فشل حفظ البيانات",
    authShowPassword: "إظهار كلمة المرور", authHidePassword: "إخفاء كلمة المرور",
    authForgotPassword: "نسيت كلمة المرور؟", authForgotTitle: "استعادة كلمة المرور",
    authForgotSubtitle: "أدخل بريدك الإلكتروني وسيتم إرسال رابط لإعادة تعيين كلمة المرور.",
    authSendResetLink: "إرسال رابط الاستعادة", authResetSent: "تم إرسال رابط استعادة كلمة المرور إلى بريدك. تحقق من صندوق الوارد.",
    authSignUpVerify: "تم إنشاء الحساب. تم إرسال رابط تأكيد إلى بريدك الإلكتروني — يرجى التحقق لتأكيد الحساب.",
    authResendVerify: "إعادة إرسال رابط التأكيد", authVerifySent: "تم إعادة إرسال رابط التأكيد إلى بريدك.",
    authFullName: "الاسم الكامل", authConfirmPassword: "تأكيد كلمة المرور", authRememberMe: "تذكرني",
    authPasswordTooShort: "كلمة المرور يجب أن تكون 8 أحرف على الأقل", authPasswordWeak: "كلمة المرور يجب أن تحتوي على أحرف وأرقام",
    authPasswordMismatch: "كلمتا المرور غير متطابقتين", authCreateAccount: "إنشاء حساب", authHaveAccount: "لديك حساب؟ سجّل دخولك",
    authNoAccount: "ليس لديك حساب؟ أنشئ حساباً", authResetTitle: "كلمة مرور جديدة", authResetSubtitle: "أدخل كلمة المرور الجديدة مرتين",
    authNewPassword: "كلمة المرور الجديدة", authResetSuccess: "تم تغيير كلمة المرور بنجاح", authResetError: "فشل تغيير كلمة المرور",
    authChangePassword: "تغيير كلمة المرور", authCurrentPassword: "كلمة المرور الحالية",
    authPasswordChanged: "تم تغيير كلمة المرور بنجاح", authPasswordChangeError: "فشل تغيير كلمة المرور",
    accountSettings: "إعدادات الحساب", accountProfile: "الملف الشخصي", accountSubscription: "الاشتراك",
    accountPlan: "الباقة", accountStatus: "الحالة", accountExpiry: "تاريخ الانتهاء", accountNoSubscription: "لا يوجد اشتراك",
    accountFree: "مجاني", accountTrial: "تجربة", accountPremiumMonthly: "اشتراك شهري", accountPremiumYearly: "اشتراك سنوي",
    subStatusActive: "نشط", subStatusTrial: "تجربة", subStatusExpired: "منتهي", subStatusCancelled: "ملغي", subStatusPastDue: "متأخر الدفع",
    authEmailNotConfirmed: "بريدك الإلكتروني غير مؤكد — تحقق من بريدك لتأكيد الحساب",
    authUsername: "اسم المستخدم", authUsernameTooShort: "اسم المستخدم يجب أن يكون 3 أحرف على الأقل",
    welcomeContinue: "متابعة", welcomeDesc: "مساعدك الذكي للتغذية والصحة — حلّل طعامك، تتبّع خطواتك، وحقق أهدافك",
    consentCheckbox: "لقد قرأت ووافقت على الشروط والأحكام وسياسة الخصوصية وإرشادات المستخدم.",
    guidelinesTitle: "إرشادات المستخدم", guidelinesBtn: "الإرشادات",
    subContinueFree: "المتابعة مجاناً", subRestore: "استعادة الشراء", subNoPurchase: "لا يوجد شراء سابق لاستعادته",
    subRenewalInfo: "يتجدد الاشتراك تلقائياً ما لم يتم إلغاؤه قبل 24 ساعة من تاريخ التجديد.",
    subCancelInfo: "يمكنك إلغاء اشتراكك في أي وقت من إعدادات الحساب أو متجر التطبيقات.",
    accountConsent: "الموافقة", accountConsentStatus: "حالة الموافقة", accountConsentAccepted: "تم القبول",
    accountConsentDate: "تاريخ الموافقة", accountNoConsent: "لا توجد موافقة مسجلة",
    adminPanel: "لوحة الإدارة", adminDocuments: "المستندات", adminPlans: "الباقات", adminSave: "حفظ",
    adminSaved: "تم الحفظ بنجاح", adminSaveError: "فشل الحفظ", adminEdit: "تعديل",
    adminAccessDenied: "تم رفض الوصول", adminAccessDeniedDesc: "ليس لديك صلاحية للوصول إلى لوحة الإدارة.",
    authAccountNotFound: "الحساب غير موجود — تحقق من بريدك الإلكتروني", authNetworkError: "خطأ في الشبكة — تحقق من اتصالك",
    authSubscriptionFailed: "فشل في الاشتراك — حاول مرة أخرى", authSubscriptionExpired: "انتهت صلاحية اشتراكك",
    trialTitle: "تجربة البرنامج",
    trialSubtitle: "أدخل كلمة المرور لتجربة البرنامج لمدة 3 أيام",
    trialPassword: "كلمة المرور",
    trialBtn: "دخول التجربة",
    trialError: "كلمة المرور غير صحيحة",
    trialExpired: "انتهت فترة التجربة",
    trialCountdown: "الوقت المتبقي للتجربة",
    trialPermSubtitle: "أدخل كلمة المرور للوصول الدائم للبرنامج",
    trialUnlock: "فتح الوصول الدائم",
    trialDaysLeft: "يوم متبقي",
    trialDayLeft: "يوم متبقي",
    trialScansLeft: "مسحات متبقية",
    trialSignInSubtitle: "انتهت فترة التجربة المجانية. سجّل دخولك أو اشترك للوصول الدائم للتطبيق",
    trialStartBtn: "ابدأ التجربة المجانية (٣ أيام)",
    trialSubscribeBtn: "اشترك الآن",
    trialForgotHint: "إذا نسيت كلمة المرور، اضغط تسجيل الدخول ثم 'نسيت كلمة المرور' لاستعادتها عبر بريدك",
    ownerCodePlaceholder: "كلمة الدخول الخاصة",
    ownerCodeBtn: "دخول دائم",
    helpTitle: "دليل الاستخدام الكامل",
    aboutPurelife: "عن بيور لايف",
    aboutDesc: "بيور لايف هو تطبيق صحي متكامل يجمع بين الذكاء الاصطناعي وتتبع الصحة اليومية. يساعدك على اكتشاف الوصفات، تتبع تغذيتك، قياس نشاطك البدني، وإدارة وزنك بطريقة علمية وممتعة.",
    helpAllergyDesc: "فحص مكونات أي وجبة للكشف عن مسببات الحساسية الغذائية المحتملة — لا يضمن خلو الطبق من جميع مسببات الحساسية",
    helpHealthScoreDesc: "احصل على تقييم صحي تقريبي لأي وجبة بالذكاء الاصطناعي مع توصيات لتحسين نظامك الغذائي — التقدير إرشادي فقط",
    helpWaterDesc: "تتبع كميات الماء التي تشربها يومياً واحصل على تذكيرات للحفاظ على الترطيب الصحي",
    helpMusicDesc: "مشغل موسيقى مدمج يرافقك أثناء التمارين والطهي لتجربة أكثر متعة",
    helpBarcodeDesc: "امسح باركود منتج غذائي للبحث عن قيمه الغذائية في قاعدة بيانات USDA — التغطية تختلف وليست كل المنتجات موجودة",
    helpCalorieCompareDesc: "قارن السعرات الحرارية بين عدة وجبات في نفس الوقت لاختيار الأنسب لهدفك الصحي",
    helpSavedDesc: "ارجع في أي وقت لجميع الوصفات التي حفظتها من أي قسم في التطبيق",
    lightMode: "نهاري",
    darkMode: "ليلي",
    language: "اللغة",
    subTitle: "اشترك في بيور لايف",
    subSubtitle: "اختر الباقة المناسبة لك واستمتع بكل المميزات",
    subMonthly: "اشتراك شهري",
    subYearly: "اشتراك سنوي",
    subMonth: "شهر",
    subPerYear: "سنوياً",
    subBestValue: "أفضل قيمة",
    subChooseMonthly: "اختر الشهري",
    subChooseYearly: "اختر السنوي",
    subCurrentPlan: "باقتك الحالية",
    subTrialActive: "فترة تجربة نشطة",
    subActive: "اشتراك نشط",
    subFeatureAi3: "200 استخدامات للذكاء الاصطناعي في الشهر",
    subFeatureAiYearly: "300 استخدامات للذكاء الاصطناعي في الشهر",
    subFeatureCredits100: "100 رصيد ذكاء اصطناعي شهرياً",
    subFeatureCreditsDaily10: "حد أقصى 10 أرصدة يومياً",
    subFeatureAll: "وصول كامل لكل المميزات",
    subFeatureSync: "مزامنة بياناتك عبر الأجهزة",
    creditCostPhoto: "تحليل الصورة: رصيدان",
    creditCostText: "توليد وصفة — رصيد واحد",
    creditStatusUnavailable: "تعذر تحميل رصيد الذكاء الاصطناعي",
    creditStatusLoading: "جارٍ التحميل...",
    creditRetry: "إعادة المحاولة",
    subFeature2MonthsFree: "شهران مجاناً عند الاشتراك السنوي",
    subTrialHint: "الميزات المدفوعة ستكون متاحة قريباً عند تفعيل الدفع",
    subSignInFirst: "سجّل الدخول أولاً للاشتراك",
    subError: "حدث خطأ، حاول مرة أخرى",
    subUnavailable: "الاشتراك مؤقتاً غير متاح، تابعنا قريباً",
    subCheckoutNotWired: "نظام الدفع غير متصل حالياً — لا يمكن إتمام عملية الشراء الآن",
    aiSignInRequired: "سجّل الدخول لاستخدام ميزات الذكاء الاصطناعي",
    creditEmailRequired: "يجب تأكيد بريدك الإلكتروني لاستخدام ميزات الذكاء الاصطناعي",
    creditInsufficient: "ليس لديك رصيد كافٍ لإجراء هذا الإجراء",
    creditNoLifetime: "لقد استخدمت جميع رصيدك المجاني (5 عمليات). اشترك للحصول على المزيد.",
    creditDailyLimit: "لقد وصلت إلى الحد اليومي (10 أرصدة). عُد غداً.",
    creditMonthlyLimit: "لقد وصلت إلى الحد الشهري (100 رصيد). يتجدد في موعد دورة اشتراكك.",
    creditUnavailable: "خدمة الذكاء الاصطناعي غير متاحة حالياً. حاول لاحقاً.",
    creditCost: "التكلفة",
    creditRemaining: "الرصيد المتبقي",
    creditsRemaining: "رصيد متبقي",
    creditLifetime: "رصيد مجاني مدى الحياة",
    creditMonthly: "رصيد شهري",
    creditDaily: "رصيد يومي",
    creditTier: "الباقة",
    creditTierFree: "مجاني",
    creditTierMonthly: "اشتراك شهري",
    creditTierYearly: "اشتراك سنوي",
    creditConfirmAction: "سيتم خصم {credits} رصيد لهذا الإجراء. متبقي: {remaining}",
    closeDialog: "إغلاق",
    musicPrev: "المقطع السابق",
    musicPlay: "تشغيل",
    musicPause: "إيقاف مؤقت",
    musicNext: "المقطع التالي",
    musicShuffle: "تشغيل عشوائي",
    musicRepeat: "تكرار",
    musicRepeatOne: "تكرار مقطع واحد",
    musicMute: "كتم الصوت",
    musicUnmute: "إلغاء كتم الصوت",
    musicVolume: "مستوى الصوت",
    musicPlaylist: "قائمة التشغيل",
    musicRemoveTrack: "إزالة المقطع",
    musicAddFiles: "إضافة ملفات موسيقى",
    musicClose: "إغلاق مشغل الموسيقى",
    subUpgradeBtn: "ترقية الاشتراك",
    scanLimitReached: "لقد وصلت إلى الحد اليومي المسموح من المسح (5 صور يومياً). اشترك للحصول على مسح أكثر.",
    scanLimitRemaining: "مسح متبقي اليوم",
    scanMonthlyLimitReached: "لقد وصلت إلى الحد الشهري المسموح من المسح (100 صورة شهرياً).",
    scanMonthlyLimitRemaining: "مسح متبقي هذا الشهر",
    scan80Alert: "لقد وصلت إلى 80 مسحاً هذا الشهر. تبقى لديك 20 مسحاً يمكنك استخدامها.",
    scan90Alert: "لقد وصلت إلى 90 مسحاً هذا الشهر. تبقى لديك 10 مسحات فقط.",
    scan100Reached: "لقد استخدمت جميع المسحات الـ 100 الشهرية. يمكنك شراء 20 مسحاً إضافياً بـ 1.5$.",
    buyExtraScans: "شراء 20 مسح إضافي",
    buyExtraScansDesc: "أضف 20 مسحاً إضافياً إلى حسابك مقابل 1.5$ فقط",
    extraScansPurchased: "تم شراء 20 مسح إضافي بنجاح!",
    extraScansError: "حدث خطأ أثناء عملية الشراء، حاول مرة أخرى.",
    extraScansRemaining: "مسحات إضافية متبقية",
    medicalDisclaimer: "تنبيه: هذا التطبيق يقدم إرشادات معلوماتية عامة فقط وليس بديلاً عن الاستشارة الطبية المتخصصة. باستخدامك للبرنامج فإنك تقر وتوافق على أن أي إجراء تتخذه بناءً على المعلومات المقدمة هو على مسؤوليتك الخاصة بالكامل.",
    disclaimerTitle: "إخلاء المسؤولية القانوني",
    disclaimerIntro: "هذا التطبيق يقدم معلومات عامة وإرشادات مولّدة بالذكاء الاصطناعي فقط. وهو غير مخصص لتقديم استشارات طبية أو تشخيص أو علاج، ولا يجب استخدامه كبديل عن الاستشارة الطبية المتخصصة.",
    disclaimerSec1Title: "1. المحتوى الطبي والصحي",
    disclaimerSec1Body: "أي اقتراحات أو تقييمات صحية مولّدة بواسطة التطبيق هي لأغراض معلوماتية فقط. إنها لا تُعوّض الحكم الطبي المهني. يجب على المستخدمين استشارة مقدمي رعاية صحية مرخصين قبل اتخاذ أي قرارات طبية أو تشخيصية أو علاجية.",
    disclaimerSec2Title: "2. المحتوى المولّد بالذكاء الاصطناعي",
    disclaimerSec2Body: "جميع المخرجات التي ينتجها هذا التطبيق تُولّد تلقائياً باستخدام الذكاء الاصطناعي. قد يحتوي المحتوى المولّد بالذكاء الاصطناعي على عدم دقة أو حذف أو تفسيرات تعتمد على السياق. لا يضمن المطورون والمشغّلون دقة أو موثوقية أو ملاءمة أي معلومات مولّدة بالذكاء الاصطناعي.",
    disclaimerSec3Title: "3. مسؤولية المستخدم وسوء الاستخدام",
    disclaimerSec3Body: "باستخدامك لهذا التطبيق، فإنك تقرّ بأن جميع الإجراءات والقرارات والتفسيرات المبنية على المعلومات المقدمة هي مسؤوليتك وحدك. لن يُحمل المطورون أو المالكون أو المشغّلون مسؤولية أي أضرار مباشرة أو غير مباشرة أو عرضية أو تبعية ناتجة عن سوء الاستخدام أو التفسير الخاطئ أو الاعتماد على مخرجات النظام.",
    disclaimerSec4Title: "4. حماية البيانات والخصوصية",
    disclaimerSec4Body: "لا يقوم التطبيق بتخزين أو معالجة أو تحليل السجلات الطبية الشخصية إلا إذا قدّمها المستخدم صراحةً. يتحمّل المستخدمون مسؤولية ضمان أن أي بيانات مرفوعة تتوافق مع قوانين الخصوصية المعمول بها ولا تكشف معلومات شخصية حساسة. يخلي المطورون مسؤوليتهم عن أي أضرار تنشأ عن المعالجة غير السليمة للبيانات أو الإفصاح غير المصرّح به من قبل المستخدم.",
    disclaimerSec5Title: "5. عدم الاستخدام في حالات الطوارئ",
    disclaimerSec5Body: "هذا التطبيق غير مخصص للاستخدام في حالات الطوارئ الطبية. إذا كنت تعاني من حالة طارئة، اتصل فوراً بخدمات الطوارئ أو اذهب إلى أقرب مستشفى. لا تعتمد على هذا التطبيق لاتخاذ قرارات في مواقف تهدد الحياة.",
    disclaimerSec6Title: "6. خدمات الأطراف الثالثة",
    disclaimerSec6Body: "قد يعتمد التطبيق على خدمات خارجية (مثل قواعد بيانات التغذية ونماذج الذكاء الاصطناعي). لا يتحكم المطورون في دقة هذه الخدمات أو توفرها، ولا يتحملون المسؤولية عن أي أضرار ناتجة عن أعطال أو أخطاء في هذه الخدمات.",
    disclaimerSec7Title: "7. تحديث الإخلاء",
    disclaimerSec7Body: "يحتفظ المطورون بالحق في تحديث أو تعديل هذا الإخلاء في أي وقت. استمرارك في استخدام التطبيق بعد أي تحديث يعني قبولك للإخلاء المعدّل.",
    disclaimerSec8Title: "8. أمن البيانات وحوادث الاختراق",
    disclaimerSec8Body: "رغم أن هذا التطبيق يطبّق تدابير تقنية معقولة لحماية بيانات المستخدم، لا يمكن لأي نظام ضمان أمن مطلق. في حال وقوع هجوم سيبراني أو وصول غير مصرّح به أو اختراق للبيانات، لن يُحمل المطورون أو المالكون أو المشغّلون مسؤولية أي فقدان أو كشف أو سوء استخدام لمعلومات المستخدم الناتجة عن اختراق خارجي أو نشاط خبيث أو ظروف خارج سيطرتنا. المستخدمون مسؤولون عن ضمان أن أي معلومات شخصية أو حساسة يرفعونها تكون على مسؤوليتهم الخاصة. باستخدامك لهذا التطبيق، تقرّ وتوافق على أن المطورين لا يمكنهم ضمان حماية كاملة ضد الاختراقات الأمنية ولا يتحملون المسؤولية عن أي أضرار تنشأ عن مثل هذه الحوادث.",
    disclaimerAccept: "أوافق وأقبل",
    disclaimerDecline: "لا أوافق",
    disclaimerAcceptance: "بالمتابعة، فإنك تقرّ بمحدوديات ومخاطر المحتوى المولّد بالذكاء الاصطناعي وتقبل هذا الإخلاء بالكامل.",
    consentTitle: "موافقة المستخدم وحماية البيانات",
    consentIntro: "بالمتابعة، فإنك توافق على أن هذا التطبيق قد يخزّن بيانات حسابك وبياناتك الصحية بشكل آمن في السحابة. جميع الصور تُعالج على جهازك ولا يتم رفعها أو تخزينها خارج هاتفك. يمكنك حذف حسابك وجميع بياناتك المرتبطة في أي وقت.",
    consentLocalTitle: "المعالجة المحلية على الجهاز",
    consentLocalBody: "جميع عمليات معالجة الصور والتعرف على الطعام تتم محلياً على جهازك. لا يتم نقل أو رفع أو تخزين أي صور خارج هاتفك.",
    consentCloudTitle: "التخزين السحابي الآمن",
    consentCloudBody: "بيانات الحساب والبيانات الصحية (الوزن، السعرات، الخطوات، التمارين) محمية باستخدام اتصال مشفر (HTTPS) وتخزين آمن مشفر (AES-256).",
    consentRightsTitle: "حقوقك بموجب قانون حماية البيانات",
    consentRightsBody: "الحق في الوصول إلى بياناتك، تصحيح البيانات غير الدقيقة، حذف حسابك وجميع بياناتك المخزنة، وسحب الموافقة في أي وقت.",
    consentAccept: "أوافق وأتابع",
    consentDecline: "لا أوافق",
    consentAcceptance: "باستخدامك لهذا التطبيق، فإنك توافق على معالجة البيانات الأساسية اللازمة لعمل الحساب وتتبع الصحة.",
    consentBack: "العودة", consentViewFull: "عرض كامل المستند",
    privacyPolicyBtn: "سياسة الخصوصية",
    termsBtn: "شروط الاستخدام",
    privacyPolicyTitle: "سياسة الخصوصية",
    privacyIntro: "هذا التطبيق يلتزم بقانون حماية البيانات الشخصية (PDPL). نجمع ونعالج فقط الحد الأدنى من البيانات اللازمة لتشغيل الخدمة.",
    pdplBadge: "متوافق مع قانون حماية البيانات الشخصية (PDPL)",
    privacySec1Title: "1. البيانات التي نجمعها",
    privacySec1Body: "نجمع بيانات الحساب (البريد الإلكتروني)، البيانات الصحية (الوزن، الطول، العمر، الجنس، النشاط)، سجلات التغذية والوجبات، بيانات النشاط البدني (الخطوات، التمارين)، وبيانات الاشتراك والدفع. لا نجمع بيانات طبية شخصية إلا ما يقدمه المستخدم صراحةً.",
    privacySec2Title: "2. معالجة الصور محلياً",
    privacySec2Body: "جميع الصور التي يلتقطها المستخدم أو يرفعها تُعالج محلياً على جهاز المستخدم. لا يتم رفع الصور أو نقلها أو تخزينها على أي خادم خارجي.",
    privacySec3Title: "3. التخزين السحابي والحماية",
    privacySec3Body: "البيانات المخزنة سحابياً (معلومات الحساب، المؤشرات الصحية، سجلات التغذية، والاشتراكات) محمية باستخدام اتصال مشفر (HTTPS) وتخزين آمن مشفر (AES-256).",
    privacySec4Title: "4. حقوق المستخدم",
    privacySec4Body: "للمستخدمين حقوق كاملة بموجب قانون حماية البيانات، تشمل: الحق في الوصول إلى بياناتهم، الحق في تصحيح البيانات غير الدقيقة، الحق في حذف حسابهم وجميع بياناتهم المخزنة، والحق في سحب الموافقة في أي وقت.",
    privacySec5Title: "5. مشاركة البيانات مع أطراف ثالثة",
    privacySec5Body: "لا يتم مشاركة أي بيانات شخصية مع أطراف ثالثة. لا يتم نقل البيانات خارج دولة الإمارات إلا إذا سمح القانون بذلك وبموافقة المستخدم.",
    privacySec6Title: "6. حذف البيانات",
    privacySec6Body: "يمكن للمستخدم حذف حسابه وجميع بياناته المخزنة في أي وقت من خلال إعدادات التطبيق. سيتم حذف جميع البيانات المرتبطة بشكل دائم.",
    termsTitle: "شروط الاستخدام",
    termsIntro: "باستخدامك لهذا التطبيق، فإنك توافق على الشروط والأحكام التالية. يرجى قراءتها بعناية.",
    termsSec1Title: "1. قبول الشروط",
    termsSec1Body: "باستخدامك لهذا التطبيق، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي جزء منها، يجب عليك التوقف عن استخدام التطبيق.",
    termsSec2Title: "2. المحتوى الطبي والصحي",
    termsSec2Body: "هذا التطبيق يقدم إرشادات معلوماتية عامة فقط وليس بديلاً عن الاستشارة الطبية المتخصصة. أي إجراء تتخذه بناءً على المعلومات المقدمة هو على مسؤوليتك الخاصة.",
    termsSec3Title: "3. المحتوى المولّد بالذكاء الاصطناعي",
    termsSec3Body: "جميع المخرجات تُولّد تلقائياً باستخدام الذكاء الاصطناعي وقد تحتوي على عدم دقة. لا يضمن المطورون دقة أو موثوقية أي معلومات مولّدة بالذكاء الاصطناعي.",
    termsSec4Title: "4. مسؤولية المستخدم",
    termsSec4Body: "جميع الإجراءات والقرارات المبنية على المعلومات المقدمة هي مسؤوليتك وحدك. لن يُحمل المطورون مسؤولية أي أضرار ناتجة عن استخدام التطبيق أو الاعتماد على مخرجاته.",
    termsSec5Title: "5. تعديل الشروط",
    termsSec5Body: "يحتفظ المطورون بالحق في تحديث أو تعديل هذه الشروط في أي وقت. استمرارك في استخدام التطبيق بعد أي تحديث يعني قبولك للشروط المعدّلة.",
    guidelinesIntro: "يرجى اتباع هذه الإرشادات لضمان تجربة آمنة ومفيدة مع التطبيق.",
    guidelinesSec1Title: "1. استشارة الطبيب",
    guidelinesSec1Body: "لا تعتمد على التطبيق كبديل للاستشارة الطبية. استشر طبيبك قبل اتخاذ أي قرارات صحية مهمة.",
    guidelinesSec2Title: "2. دقة المعلومات",
    guidelinesSec2Body: "المعلومات المقدمة هي إرشادات عامة وقد لا تنطبق على حالتك الخاصة. تحقق دائماً من المصادر الموثوقة.",
    guidelinesSec3Title: "3. المحتوى المولّد بالذكاء الاصطناعي",
    guidelinesSec3Body: "الوصفات والتحليلات الصحية تُولّد تلقائياً وقد تحتوي على عدم دقة. استخدمها كمرجع فقط وليس كنصيحة نهائية.",
    guidelinesSec4Title: "4. الخصوصية",
    guidelinesSec4Body: "لا تشارك معلوماتك الشخصية مع أي طرف خارجي. جميع بياناتك تُعالج محلياً على جهازك.",
    guidelinesSec5Title: "5. الاستخدام المسؤول",
    guidelinesSec5Body: "استخدم التطبيق بمسؤولية ولا تعتمد عليه بشكل كامل في إدارة صحتك. التزم بنمط حياة متوازن ومتنوع.",
  },
  en: {
    appTitle: "PureLife",
    appSubtitle: "Discover amazing recipes from your fridge ingredients",
    bannerTitle: "Your Healthy Life",
    bannerSubtitle: "Your Healthy Life",
    helpFridgeLabel: "Smart Fridge",
    helpScanLabel: "AI Food Scanner",
    helpBarcodeLabel: "Barcode Scanner",
    helpRecipesLabel: "Recipe Search",
    helpMenuLabel: "Food Menu",
    helpSavedLabel: "Saved Recipes",
    helpWLLabel: "Weight Loss Program",
    helpStepsLabel: "Step Counter",
    helpHealthScoreLabel: "Food Health Score",
    helpAllergyLabel: "Allergy Checker",
    helpWaterLabel: "Water Intake Tracker",
    helpNutritionLabel: "Nutrition Chart",
    helpCalorieCompareLabel: "Calorie Comparison",
    helpMusicLabel: "Music Player",
    prepareDishes: "Prepare Dishes",
    nutritionCompare: "Nutrition Compare",
    dietFilters: "Diet Filters",
    categories: "Categories",
    noFilterResults: "No results match this filter",
    savedAiRecipes: "Saved AI Recipes",
    recentSearches: "Recent Searches",
    clearAll2: "Clear all",
    noResultsFound: "No results found",
    glutenFreeEmptyState: "Only recipes with verified complete ingredients appear here. Recipes with incomplete or unverified ingredients are not eligible for gluten-free.",
    nutritionBasisUnverified: "Ingredient data is incomplete — the nutrition values shown are estimates and the serving basis has not been verified. Do not rely on them as confirmed per-serving facts.",
    pickIngredientsHint: "Pick ingredients to prepare the dish",
    noIngredientsMatch: "No ingredients match",
    waterReminderEnabled: "Water reminder enabled",
    waterReminderDisabled: "Water reminder disabled",
    greetingHi: "Hi, ",
    fridgeTab: "Fridge Ingredients",
    fridgeTabDesc: "Know your food ingredients and their nutritional values in detail",
    recipesTab: "Main Dishes",
    recipesTabDesc: "Search for healthy and delicious recipes that match your nutrition goal",
    menuTab: "Food Menu",
    nutritionTab: "Nutrition",
    selectIngredients: "Select available ingredients",
    findRecipes: "Find Recipes",
    availableIngredients: "Available Ingredients",
    suggestedRecipes: "Suggested Recipes",
    ingredients: "Ingredients",
    steps: "Preparation Steps",
    ovenTemp: "Oven/Cooker Temperature",
    cookingTips: "Cooking Tips & Spices",
    servingTips: "Serving Suggestions",
    servings: "Servings",
    time: "Prep Time",
    calories: "Calories",
    protein: "Protein",
    carbs: "Carbs",
    fat: "Fat",
    fiber: "Fiber",
    sodium: "Sodium",
    calcium: "Calcium",
    noRecipes: "Select ingredients to discover recipes",
    selectCategory: "Select Food Type",
    allCategories: "All Categories",
    soups: "Soups",
    salads: "Salads",
    desserts: "Desserts",
    breakfast: "Breakfast",
    grilled: "Grilled",
    seafood: "Seafood",
    athletes: "Athletes' Meals",
    juices: "Juices & Drinks",
    minutes: "min",
    persons: "persons",
    personSingular: "person",
    nutritionTitle: "Nutrition Table per 100g",
    food: "Food",
    perHundredG: "Per 100g",
    selectAll: "Select All",
    clearAll: "Clear All",
    matchPercent: "Match",
    viewRecipe: "View Recipe",
    close: "Close",
    saveRecipe: "Save Recipe",
    savedRecipe: "Saved!",
    shareRecipe: "Share Recipe",
    shareTitle: "A great recipe from PureLife",
    shareCopied: "Link copied!",
    savedTab: "Saved Recipes",
    noSaved: "No saved recipes yet",
    noSavedHint: "Save your favourite recipes to find them here",
    pastries: "Pastries & Sweets",
    removeFromSaved: "Remove from saved",
    optional: "optional",
    aiGenerate: "✨ AI Recipe",
    aiGenerating: "Creating...",
    aiRecipeTitle: "AI-Generated Recipe",
    aiError: "Generation failed, please try again",
    aiDisclaimer: "Recipe created by AI based on your ingredients",
    sugar: "Sugar",
    perServing: "per serving",
    aiFromCache: "Loaded from cache",
    dishSearch: "Search for any dish by name...",
    dishSearchBtn: "Search",
    aiIngredientsList: "Ingredients & Quantities",
    clearSearch: "Clear",
    dishNotFoundAi: "Not in our recipes, generating with AI...",
    scanTab: "Scan Food",
    scanTabDesc: "Scan any food or product to get its nutritional information",
    scanTitle: "Identify Your Food with AI",
    scanSubtitle: "Photograph your meal and AI will estimate its ingredients and nutrition",
    takePhoto: "Take Photo",
    uploadPhoto: "Upload Photo",
    analyzeFood: "Analyze Food",
    retake: "Retake",
    analyzing: "Analyzing image...",
    analysisStep1: "Running vision model...",
    analysisStep2: "Identifying ingredients...",
    analysisStep3: "Generating recipe...",
    aiAnalyzerTitle: "AI Food Analyzer",
    aiAnalyzingMeal: "Analyzing your meal...",
    aiCompleteMsg: "Analysis Complete!",
    aiStep1: "Detecting Food", aiStep2: "Identifying Ingredients", aiStep3: "Analyzing Nutrition",
    aiStep4: "Calculating Calories", aiStep5: "Checking Sugar", aiStep6: "Calculating Protein",
    aiStatus1: "Detecting your food...", aiStatus2: "Scanning the meal...", aiStatus3: "Identifying ingredients...",
    aiStatus4: "Analyzing nutritional values...", aiStatus5: "Calculating calories...", aiStatus6: "Checking sugar content...",
    aiStatus7: "Estimating protein...", aiStatus8: "Preparing your nutrition report...",
    aiBrainStatus: "AI is analyzing your meal...",
    aiBrainDesc: "Our AI is identifying ingredients and calculating nutrition with high accuracy.",
    aiComplete: "Complete",
    aiFewSeconds: "This usually takes a few seconds",
    aiTipTitle: "Healthy Tip",
    aiTip1: "Adding colorful vegetables to your meals can help increase the variety of nutrients you consume.",
    aiTip2: "Protein can help you feel full and support muscle maintenance during weight loss.",
    aiTip3: "Drinking enough water throughout the day supports overall health and can help with appetite management.",
    aiPrivacy: "Your data is private and secure",
    aiErrorTitle: "We couldn't analyze this meal. Please try again.",
    aiRetryBtn: "Try Again",
    aiNewPhotoBtn: "Take New Photo",
    confirmDish: "What dish do you see?",
    confirmSubtitle: "Select the correct option or edit it",
    confidence: "Confidence",
    generateRecipe: "Generate Recipe",
    typeManually: "Enter name manually",
    notFood: "No food detected in the image",
    cropTitle: "Crop Image",
    cropHint: "Drag to select area",
    cropApply: "Apply Crop",
    cropCancel: "Cancel",
    cropBtn: "Crop",
    lowConfidenceTitle: "Detection unclear — pick the closest match",
    lowConfidenceSubtitle: "AI wasn't sure. Choose one of the options below or type the name manually",
    selectCandidate: "Select this",
    selectedCandidate: "Selected",
    addManuallyBtn: "Add food manually",
    manualEntryTitle: "Add food manually",
    manualEntryPlaceholder: "e.g. Chicken shawarma, salad, falafel...",
    manualEntryBtn: "Generate Recipe",
    scanError: "Analysis failed, please try again",
    scanHistory: "Today's Diary",
    scanHistoryEmpty: "No meals logged today",
    todayCalories: "Today's total calories",
    saveToDiary: "Save to Diary",
    savedToDiary: "Saved to Diary",
    scanAnother: "Scan Another Meal",
    cuisine: "Cuisine",
    alternatives: "Alternative names",
    clearHistory: "Clear History",
    genderLabel: "Gender", male: "Male", female: "Female",
    ageLabel: "Age (yrs)", weightLabel: "Weight (kg)", heightLabel: "Height (cm)",
    goalLabel: "Your Goal", goalLose: "Lose Weight", goalMaintain: "Maintain Weight", goalGain: "Gain Weight",
    activityLabel: "Activity Level", sedentary: "Sedentary", activityLight: "Light", activityModerate: "Moderate", activityActive: "Active",
    bmiLabel: "BMI", underweight: "Underweight", normalWeight: "Normal", overweight: "Overweight", obese: "Obese",
    healthyRange: "Healthy Range", dailyCaloriesTarget: "Daily Calorie Target", macroTargets: "Macro Targets",
    saveProfile: "Save Profile", profileSaved: "Saved!",
    mealCompatibility: "Meal Fit for Your Goal", suitable: "Highly Suitable", moderatelySuitable: "Moderately Suitable", unsuitable: "Not Recommended",
    betterOption: "Better Option", noProfileSet: "Enter your details first for personalised advice",
    perMealTarget: "per meal",
    recommendedFoods: "Recommended Foods", foodsToAvoid: "Foods to Limit",
    goalDesc_lose: "High protein, low calorie meals", goalDesc_maintain: "Balanced, varied diet", goalDesc_gain: "High calorie, protein-rich meals",
    suitabilityScore: "Suitability Score",
    weightTab: "Weight Loss", nutritionChartTitle: "Nutrition Chart",
    weightTabDesc: "Easily track your weight and progress toward your goal",
    helpBtn: "Help Guide",
    helpFridgeDesc: "Select ingredients from your fridge and the app instantly suggests matching recipes",
    helpScanDesc: "Photograph any dish and AI attempts to identify it, giving you a recipe and estimated nutrition — results may be inaccurate",
    helpRecipesDesc: "Search any recipe by name — if not found, AI generates it for you (requires sign-in, may take a moment)",
    helpMenuDesc: "Choose your ingredients and AI creates a brand new custom recipe just for you",
    helpWLDesc: "Track your weight, daily calories and macros, and chat with an AI coach dedicated to your weight loss program",
    helpNutritionDesc: "Every meal shows an estimated donut chart with a visual breakdown of protein, fat and carbs — values are approximate",
    beveragesTab: "Beverages & Juices", helpBeveragesDesc: "Browse 20+ halal drinks and juices in your fridge — add them to recipes or compare their calories", goalHealthy: "Healthy Lifestyle",
    dietaryPrefsLabel: "Dietary Preferences", allergensLabel: "Food Allergies",
    prefStandard: "Standard", prefVegetarian: "Vegetarian", prefVegan: "Vegan", prefKeto: "Keto", prefLowCarb: "Low Carb", prefMediterranean: "Mediterranean", prefHalal: "Halal", prefGlutenFree: "Gluten-Free", prefDairyFree: "Dairy-Free",
    allergenGluten: "Gluten", allergenDairy: "Dairy", allergenLactose: "Lactose", allergenEggs: "Eggs", allergenPeanuts: "Peanuts", allergenTreeNuts: "Tree Nuts", allergenSoy: "Soy", allergenFish: "Fish", allergenShellfish: "Shellfish", allergenSesame: "Sesame", allergenMustard: "Mustard", allergenCelery: "Celery", allergenSulfites: "Sulfites", allergenLupin: "Lupin", allergenMollusks: "Mollusks",
    safeLabel: "Safe", warningLabel: "Warning", dangerLabel: "Danger",
    allergenAlert: "Allergy Alert", noAllergensDetected: "No allergens detected",
    healthScore: "Health Score", healthScoreExcellent: "Excellent", healthScoreGood: "Good", healthScoreFair: "Fair", healthScorePoor: "Poor",
    getHealthScore: "Get Health Score (1 credit)",
    substituteLabel: "Suggested Substitutes",
    weightLossTab: "Weight Program",
    wlSetupTitle: "Weight Loss Program Setup",
    wlSetupStep1: "Body Data",
    wlSetupStep2: "Goal & Date",
    wlSetupStep3: "Review",
    wlTargetWeight: "Target Weight (kg)",
    wlStartWeight: "Starting Weight (kg)",
    wlTargetDate: "Target Date",
    wlWeeklyLoss: "Weekly Loss Target",
    wlDashboard: "Dashboard",
    wlProgress: "Progress",
    wlMeals: "Meal Ideas",
    wlLogMeal: "Log Meal",
    wlCaloriesIn: "Consumed",
    wlCaloriesRemaining: "Remaining",
    wlCaloriesBurned: "Burned",
    wlWater: "Water",
    wlWaterGlasses: "Water Glasses",
    wlSteps: "Steps",
    wlExercise: "Exercise",
    wlWeightHistory: "Weight History",
    wlAddWeight: "Log Weight",
    wlBMI: "Body Mass Index",
    wlBMR: "Basal Metabolic Rate",
    wlTDEE: "Total Daily Energy Expenditure",
    wlLostSoFar: "Lost So Far",
    wlToGo: "Left to Goal",
    wlDaysLeft: "days left",
    wlGoalDate: "Goal Date",
    wlProgression: "Progress",
    wlEstCompletion: "Est. Completion",
    wlAchievements: "Achievements & Badges",
    wlWarningDeficit: "Warning: A large calorie deficit can harm your health",
    wlWarningGoal: "Goal may be unrealistic — aim for 0.5–1 kg/week",
    wlDisclaimer: "This app is for educational purposes only and is not a substitute for professional medical advice",
    wlStartProgram: "Start Program",
    wlMealTime: "Meal Time",
    wlBreakfast: "Breakfast",
    wlLunch: "Lunch",
    wlDinner: "Dinner",
    wlSnack: "Snack",
    wlMealName: "Meal Name",
    wlSaveEntry: "Save",
    wlScore: "Diet Score",
    wlScoreExcellent: "Excellent for Diet",
    wlScoreGood: "Good for Diet",
    wlScoreFair: "Acceptable",
    wlScorePoor: "Not Ideal",
    wlNext: "Next",
    wlBack: "Back",
    wlEditGoal: "Edit Goal",
    wlAddGlass: "Add Glass",
    wlAddSteps: "Add Steps",
    wlMotivation: "Today's Message",
    wlWeightKg: "Weight (kg)",
    wlWaistCm: "Waist (cm) — optional",
    wlRecommendedCalories: "Recommended Calories",
    scoreTab: "Health Score",
    scoreTitle: "AI Food Health Analyzer",
    scoreSubtitle: "Analyze any meal and get instant health scores",
    scoreFoodInput: "Enter food or meal (e.g. burger + fries + soda)...",
    scoreAnalyze: "Analyze Now",
    scoreAnalyzing: "Analyzing...",
    scoreHealthy: "Very Healthy",
    scoreGood: "Good",
    scoreFair: "Fair",
    scorePoor: "Unhealthy",
    scoreWarnings: "Warnings",
    scoreSuggestions: "Improvement Suggestions",
    scoreAnalysis: "Quick Analysis",
    scoreCompare: "Compare Meals",
    scoreAddMeal: "Add Meal",
    scoreCompareMeals: "Compare Now",
    scoreWinner: "Healthiest",
    scoreHistory: "Previous Analyses",
    scoreNoHistory: "No previous analyses yet",
    scoreGoalNote: "Adjusted for your health goal",
    scoreMeal: "Meal",
    vitaminsSectionLabel: "Vitamins & Minerals",
    barcodeBtn: "Barcode Scanner",
    barcodeTitle: "Scan Barcode",
    barcodeSubtitle: "Point the camera at a product barcode",
    barcodeScanning: "Scanning...",
    barcodeNotSupported: "Barcode scanner not supported on this browser",
    barcodeManualHint: "Enter barcode number manually",
    barcodeSearch: "Search",
    barcodeNotFound: "Product not found in database",
    barcodeBrand: "Brand",
    barcodeNutritionPer100g: "Nutrition per 100g",
    barcodeScanAgain: "Scan Again",
    stepsTab: "Step Counter", helpStepsDesc: "Count your daily steps and calculate burned calories and distance — accuracy depends on your device and browser sensors",
    stepsTabDesc: "Track your daily steps, burned calories, and activity level",
    walkTab: "Walk", walkTabDesc: "High-accuracy GPS walking tracker — route, speed, calories, elevation",
    reportTab: "Daily Report", reportTabDesc: "Comprehensive health assessment of your daily achievements and tips for a better tomorrow",
    medsTab: "Medication Center", medsTabDesc: "Manage your medications and dose reminders easily and safely",
    helpReportDesc: "At the end of each day, get a full assessment: how much water you drank, how much you walked, protein and sugar intake, with smart tips to improve tomorrow",
    stepsToday: "Today's Steps", stepsGoal: "Daily Goal", stepsBurned: "Calories Burned", stepsDistance: "Distance",
    stepsStart: "Start Counting", stepsStop: "Stop", stepsHistory: "Last 7 Days",
    stepsPermission: "Tap to allow motion sensor access", stepsPermissionBtn: "Allow Access",
    stepsUnit: "steps", stepsActiveTime: "Active Time", stepsGoalSet: "Set Goal",
    stepsNotSupported: "This device does not support motion sensors", stepsReset: "Reset", stepsKm: "km",
    stepsSaved: "Saved", stepsMin: "min", stepsGoalLabel: "Goal",
    networkError: "Internet connection lost — check your connection and try again",
    networkOfflineBanner: "You are offline",
    retryBtn: "Retry",
    signIn: "Sign In", signUp: "Sign Up", signOut: "Sign Out", signOutThisDevice: "Sign out of this device",
    authEmail: "Email", authPassword: "Password",
    authTitle: "Account", authSignedInAs: "Signed in as",
    authSyncBanner: "Sign in to sync your steps across devices",
    authError: "Authentication error — check your credentials",
    authWrongPassword: "Incorrect password",
    authEmailNotFound: "Email not registered — create an account first",
    authEmailExists: "This email is already registered — sign in instead",
    authInvalidEmail: "Invalid email address",
    authSignUpSuccess: "Account created successfully",
    authBodyTitle: "Your Body Data", authBodySubtitle: "Enter your details to use in the weight loss program",
    authBodySave: "Save Data", authBodyError: "Check the entered values", authBodySaveError: "Failed to save data",
    authShowPassword: "Show password", authHidePassword: "Hide password",
    authForgotPassword: "Forgot password?", authForgotTitle: "Reset password",
    authForgotSubtitle: "Enter your email and we'll send you a link to reset your password.",
    authSendResetLink: "Send reset link", authResetSent: "A password reset link has been sent to your email. Check your inbox.",
    authSignUpVerify: "Account created. A confirmation link has been sent to your email — please verify to confirm your account.",
    authResendVerify: "Resend confirmation link", authVerifySent: "Confirmation link resent to your email.",
    authFullName: "Full Name", authConfirmPassword: "Confirm Password", authRememberMe: "Remember me",
    authPasswordTooShort: "Password must be at least 8 characters", authPasswordWeak: "Password must contain letters and numbers",
    authPasswordMismatch: "Passwords do not match", authCreateAccount: "Create Account", authHaveAccount: "Already have an account? Sign in",
    authNoAccount: "Don't have an account? Sign up", authResetTitle: "New Password", authResetSubtitle: "Enter your new password twice",
    authNewPassword: "New Password", authResetSuccess: "Password changed successfully", authResetError: "Failed to change password",
    authChangePassword: "Change Password", authCurrentPassword: "Current Password",
    authPasswordChanged: "Password changed successfully", authPasswordChangeError: "Failed to change password",
    accountSettings: "Account Settings", accountProfile: "Profile", accountSubscription: "Subscription",
    accountPlan: "Plan", accountStatus: "Status", accountExpiry: "Expiry Date", accountNoSubscription: "No subscription",
    accountFree: "Free", accountTrial: "Trial", accountPremiumMonthly: "Premium Monthly", accountPremiumYearly: "Premium Yearly",
    subStatusActive: "Active", subStatusTrial: "Trial", subStatusExpired: "Expired", subStatusCancelled: "Cancelled", subStatusPastDue: "Past Due",
    authEmailNotConfirmed: "Your email is not confirmed — check your email to confirm your account",
    authUsername: "Username", authUsernameTooShort: "Username must be at least 3 characters",
    welcomeContinue: "Continue", welcomeDesc: "Your smart companion for nutrition and health — scan your food, track your steps, and reach your goals",
    consentCheckbox: "I have read and agree to the Terms & Conditions, Privacy Policy, and User Guidelines.",
    guidelinesTitle: "User Guidelines", guidelinesBtn: "Guidelines",
    subContinueFree: "Continue with Free", subRestore: "Restore Purchase", subNoPurchase: "No previous purchase found to restore",
    subRenewalInfo: "Subscription auto-renews unless cancelled at least 24 hours before the renewal date.",
    subCancelInfo: "You can cancel your subscription at any time from Account Settings or the App Store.",
    accountConsent: "Consent", accountConsentStatus: "Consent Status", accountConsentAccepted: "Accepted",
    accountConsentDate: "Consent Date", accountNoConsent: "No consent record found",
    adminPanel: "Admin Panel", adminDocuments: "Documents", adminPlans: "Plans", adminSave: "Save",
    adminSaved: "Saved successfully", adminSaveError: "Failed to save", adminEdit: "Edit",
    adminAccessDenied: "Access Denied", adminAccessDeniedDesc: "You do not have permission to access the admin panel.",
    authAccountNotFound: "Account not found — check your email", authNetworkError: "Network error — check your connection",
    authSubscriptionFailed: "Subscription failed — please try again", authSubscriptionExpired: "Your subscription has expired",
    trialTitle: "Trial Access",
    trialSubtitle: "Enter password to try the app for 3 days",
    trialPassword: "Password",
    trialBtn: "Start Trial",
    trialError: "Incorrect password",
    trialExpired: "Trial expired",
    trialCountdown: "Trial time remaining",
    trialPermSubtitle: "Enter password for permanent access",
    trialUnlock: "Unlock permanent access",
    trialDaysLeft: "days left",
    trialDayLeft: "day left",
    trialScansLeft: "scans left",
    trialSignInSubtitle: "Your free trial has ended. Sign in or subscribe for permanent access",
    trialStartBtn: "Start free trial (3 days)",
    trialSubscribeBtn: "Subscribe Now",
    trialForgotHint: "Forgot your password? Tap Sign In then 'Forgot password' to reset it via email",
    ownerCodePlaceholder: "Owner access code",
    ownerCodeBtn: "Permanent access",
    helpTitle: "Full User Guide",
    aboutPurelife: "About PureLife",
    aboutDesc: "PureLife is a comprehensive health app combining AI and daily health tracking. Discover recipes, track your nutrition, measure physical activity, and manage your weight scientifically and enjoyably.",
    helpAllergyDesc: "Check any meal's ingredients for potential allergens — cannot guarantee the dish is free from all allergens",
    helpHealthScoreDesc: "Get an approximate AI health score for any meal with dietary improvement tips — the estimate is advisory only",
    helpWaterDesc: "Track your daily water intake and receive reminders to stay properly hydrated throughout the day",
    helpMusicDesc: "Built-in music player to keep you company while cooking or working out",
    helpBarcodeDesc: "Scan a food product barcode to look up nutrition facts from the USDA database — coverage varies and not all products are listed",
    helpCalorieCompareDesc: "Compare calories across multiple meals side-by-side to make the best choice for your health goal",
    helpSavedDesc: "Come back anytime to all the recipes you have saved from anywhere in the app",
    lightMode: "Light",
    darkMode: "Dark",
    language: "Language",
    subTitle: "Subscribe to PureLife",
    subSubtitle: "Choose the plan that suits you and enjoy all features",
    subMonthly: "Monthly",
    subYearly: "Yearly",
    subMonth: "month",
    subPerYear: "per year",
    subBestValue: "Best Value",
    subChooseMonthly: "Choose Monthly",
    subChooseYearly: "Choose Yearly",
    subCurrentPlan: "Your current plan",
    subTrialActive: "Trial active",
    subActive: "Active subscription",
    subFeatureAi3: "200 AI uses per month",
    subFeatureAiYearly: "300 AI uses per month",
    subFeatureCredits100: "100 AI credits per month",
    subFeatureCreditsDaily10: "Up to 10 credits per day",
    subFeatureAll: "Full access to all features",
    subFeatureSync: "Sync your data across devices",
    creditCostPhoto: "Photo analysis: 2 credits",
    creditCostText: "Generate recipe — 1 credit",
    creditStatusUnavailable: "AI credit balance unavailable",
    creditStatusLoading: "Loading...",
    creditRetry: "Retry",
    subFeature2MonthsFree: "2 months free with yearly plan",
    subTrialHint: "Premium features will be available once payments are activated",
    subSignInFirst: "Sign in first to subscribe",
    subError: "Something went wrong, please try again",
    subUnavailable: "Subscriptions are temporarily unavailable — check back soon",
    subCheckoutNotWired: "Payment system is not connected — checkout cannot be completed at this time",
    aiSignInRequired: "Sign in to use AI features",
    creditEmailRequired: "Please verify your email to use AI features",
    creditInsufficient: "You don't have enough credits for this action",
    creditNoLifetime: "You've used all your free credits (5). Subscribe for more.",
    creditDailyLimit: "You've reached the daily limit (10). Come back tomorrow.",
    creditMonthlyLimit: "You've reached the monthly limit (100 credits). Renews on your subscription cycle.",
    creditUnavailable: "AI service is temporarily unavailable. Try later.",
    creditCost: "Cost",
    creditRemaining: "Remaining",
    creditsRemaining: "credits left",
    creditLifetime: "Lifetime free credits",
    creditMonthly: "Monthly credits",
    creditDaily: "Daily credits",
    creditTier: "Plan",
    creditTierFree: "Free",
    creditTierMonthly: "Monthly subscription",
    creditTierYearly: "Yearly subscription",
    creditConfirmAction: "This action will use {credits} credits. Remaining: {remaining}",
    closeDialog: "Close",
    musicPrev: "Previous track",
    musicPlay: "Play",
    musicPause: "Pause",
    musicNext: "Next track",
    musicShuffle: "Shuffle",
    musicRepeat: "Repeat",
    musicRepeatOne: "Repeat one",
    musicMute: "Mute",
    musicUnmute: "Unmute",
    musicVolume: "Volume",
    musicPlaylist: "Playlist",
    musicRemoveTrack: "Remove track",
    musicAddFiles: "Add music files",
    musicClose: "Close music player",
    subUpgradeBtn: "Upgrade subscription",
    scanLimitReached: "You've reached the daily scan limit (5 images per day). Subscribe for more scans.",
    scanLimitRemaining: "scans remaining today",
    scanMonthlyLimitReached: "You've reached the monthly scan limit (100 images per month).",
    scanMonthlyLimitRemaining: "scans remaining this month",
    scan80Alert: "You've reached 80 scans this month. You have 20 scans left.",
    scan90Alert: "You've reached 90 scans this month. You have only 10 scans left.",
    scan100Reached: "You've used all 100 monthly scans. You can buy 20 extra scans for $1.50.",
    buyExtraScans: "Buy 20 extra scans",
    buyExtraScansDesc: "Add 20 extra scans to your account for just $1.50",
    extraScansPurchased: "Successfully purchased 20 extra scans!",
    extraScansError: "An error occurred during purchase, please try again.",
    extraScansRemaining: "extra scans remaining",
    medicalDisclaimer: "Disclaimer: This application provides general informational guidance only and is not a substitute for professional medical advice. By using this program, you acknowledge and agree that any actions you take based on the information provided are solely at your own risk and responsibility.",
    disclaimerTitle: "Legal Disclaimer",
    disclaimerIntro: "This application provides general information and AI-generated guidance only. It is not intended to provide medical advice, diagnosis, or treatment, and must not be used as a substitute for professional medical consultation.",
    disclaimerSec1Title: "1. Medical & Health-Related Content",
    disclaimerSec1Body: "Any health-related suggestions or assessments generated by the application are for informational purposes only. They do not replace professional medical judgment. Users must consult licensed healthcare providers before making any medical, diagnostic, or treatment decisions.",
    disclaimerSec2Title: "2. AI-Generated Content",
    disclaimerSec2Body: "All outputs produced by this application are generated automatically using artificial intelligence. AI-generated content may contain inaccuracies, omissions, or context-dependent interpretations. The developers and operators do not guarantee the accuracy, reliability, or suitability of any AI-generated information.",
    disclaimerSec3Title: "3. User Responsibility & Misuse",
    disclaimerSec3Body: "By using this application, you acknowledge that all actions, decisions, and interpretations based on the provided information are your sole responsibility. The developers, owners, and operators shall not be held liable for any direct, indirect, incidental, or consequential damages resulting from misuse, misinterpretation, or reliance on the system's output.",
    disclaimerSec4Title: "4. Data Protection & Privacy",
    disclaimerSec4Body: "The application does not store, process, or analyze personal medical records unless explicitly provided by the user. Users are responsible for ensuring that any uploaded data complies with applicable privacy laws and does not expose sensitive personal information. The developers disclaim any liability for damages arising from improper data handling or unauthorized disclosure by the user.",
    disclaimerSec5Title: "5. No Emergency Use",
    disclaimerSec5Body: "This application is not intended for use in medical emergencies. If you are experiencing an emergency, call your local emergency services or go to the nearest hospital immediately. Do not rely on this application for life-threatening situations.",
    disclaimerSec6Title: "6. Third-Party Services",
    disclaimerSec6Body: "The application may rely on external services (such as nutrition databases and AI models). The developers do not control the accuracy or availability of these services and are not responsible for any damages resulting from their failures or errors.",
    disclaimerSec7Title: "7. Updates to Disclaimer",
    disclaimerSec7Body: "The developers reserve the right to update or modify this disclaimer at any time. Continued use of the application after any update constitutes acceptance of the modified disclaimer.",
    disclaimerSec8Title: "8. Data Security & Breach Incidents",
    disclaimerSec8Body: "While this application implements reasonable technical measures to protect user data, no system can guarantee absolute security. In the event of a cyber-attack, unauthorized access, or data breach, the developers, owners, and operators shall not be held liable for any loss, exposure, or misuse of user information resulting from external hacking, malicious activity, or circumstances beyond our control. Users are responsible for ensuring that any personal or sensitive information they upload is done at their own risk. By using this application, you acknowledge and agree that the developers cannot guarantee complete protection against security breaches and are not liable for any damages arising from such incidents.",
    disclaimerAccept: "I Agree & Accept",
    disclaimerDecline: "I Decline",
    disclaimerAcceptance: "By continuing, you acknowledge the limitations and risks associated with AI-generated content and accept this disclaimer in full.",
    consentTitle: "User Consent & Data Protection",
    consentIntro: "By continuing, you agree that this app may store your basic account and health data securely in the cloud. All photos are processed on your device and are never uploaded or stored outside your phone. You can delete your account and all associated data at any time.",
    consentLocalTitle: "Local Device Processing",
    consentLocalBody: "All image processing and food recognition operations are performed locally on your device. No photos are transmitted, uploaded, or stored outside your phone.",
    consentCloudTitle: "Secure Cloud Storage",
    consentCloudBody: "Account data and health data (weight, calories, steps, exercises) is protected using encrypted communication (HTTPS) and secure encrypted storage (AES-256).",
    consentRightsTitle: "Your Rights Under Data Protection Law",
    consentRightsBody: "The right to access your data, correct inaccurate data, delete your account and all stored data, and withdraw consent at any time.",
    consentAccept: "I Agree & Continue",
    consentDecline: "I Decline",
    consentAcceptance: "By using this application, you agree to the processing of essential data required for account functionality and health tracking.",
    consentBack: "Back", consentViewFull: "View full document",
    privacyPolicyBtn: "Privacy Policy",
    termsBtn: "Terms of Use",
    privacyPolicyTitle: "Privacy Policy",
    privacyIntro: "This application complies with the UAE Personal Data Protection Law (PDPL). We collect and process only the minimum data required to operate the service.",
    pdplBadge: "PDPL Compliant — UAE Personal Data Protection Law",
    privacySec1Title: "1. Data We Collect",
    privacySec1Body: "We collect account data (email), health data (weight, height, age, gender, activity level), nutrition and meal logs, physical activity data (steps, exercises), and subscription and payment data. We do not collect personal medical records unless explicitly provided by the user.",
    privacySec2Title: "2. Local Image Processing",
    privacySec2Body: "All photos captured or uploaded by the user are processed locally on the user's device. Photos are never uploaded, transferred, or stored on any external server.",
    privacySec3Title: "3. Cloud Storage & Protection",
    privacySec3Body: "Cloud-stored data (account information, health metrics, nutrition logs, and subscriptions) is protected using encrypted communication (HTTPS) and secure encrypted storage (AES-256).",
    privacySec4Title: "4. User Rights",
    privacySec4Body: "Users have full rights under data protection law, including: the right to access their data, the right to correct inaccurate data, the right to delete their account and all stored data, and the right to withdraw consent at any time.",
    privacySec5Title: "5. Third-Party Data Sharing",
    privacySec5Body: "No personal data is shared with third parties. No data is transferred outside the UAE unless legally permitted and with user consent.",
    privacySec6Title: "6. Data Deletion",
    privacySec6Body: "Users can delete their account and all stored data at any time through the app settings. All associated data will be permanently deleted.",
    termsTitle: "Terms of Use",
    termsIntro: "By using this application, you agree to the following terms and conditions. Please read them carefully.",
    termsSec1Title: "1. Acceptance of Terms",
    termsSec1Body: "By using this application, you agree to be bound by these terms and conditions. If you do not agree to any part of them, you must stop using the application.",
    termsSec2Title: "2. Medical & Health Content",
    termsSec2Body: "This application provides general informational guidance only and is not a substitute for professional medical advice. Any actions you take based on the information provided are at your own risk and responsibility.",
    termsSec3Title: "3. AI-Generated Content",
    termsSec3Body: "All outputs are generated automatically using artificial intelligence and may contain inaccuracies. The developers do not guarantee the accuracy or reliability of any AI-generated information.",
    termsSec4Title: "4. User Responsibility",
    termsSec4Body: "All actions and decisions based on the provided information are your sole responsibility. The developers shall not be held liable for any damages resulting from the use of the application or reliance on its outputs.",
    termsSec5Title: "5. Updates to Terms",
    termsSec5Body: "The developers reserve the right to update or modify these terms at any time. Continued use of the application after any update constitutes acceptance of the modified terms.",
    guidelinesIntro: "Please follow these guidelines to ensure a safe and useful experience with the app.",
    guidelinesSec1Title: "1. Consult Your Doctor",
    guidelinesSec1Body: "Do not rely on the app as a substitute for medical advice. Consult your doctor before making any important health decisions.",
    guidelinesSec2Title: "2. Information Accuracy",
    guidelinesSec2Body: "The information provided is general guidance and may not apply to your specific situation. Always verify with trusted sources.",
    guidelinesSec3Title: "3. AI-Generated Content",
    guidelinesSec3Body: "Recipes and health analyses are generated automatically and may contain inaccuracies. Use them as a reference only, not as final advice.",
    guidelinesSec4Title: "4. Privacy",
    guidelinesSec4Body: "Do not share your personal information with any external party. All your data is processed locally on your device.",
    guidelinesSec5Title: "5. Responsible Use",
    guidelinesSec5Body: "Use the app responsibly and do not rely on it entirely for managing your health. Maintain a balanced and varied lifestyle.",
  },
};

export interface Ingredient {
  id: string;
  nameAr: string;
  nameEn: string;
  nameDe?: string;
  nameRu?: string;
  namePt?: string;
  icon: string;
  category: "vegetables" | "proteins" | "dairy" | "grains" | "fruits" | "seafood" | "condiments" | "legumes" | "beverages";
  [key: string]: unknown;
}

export const fridgeIngredients: Ingredient[] = [
  // Vegetables
  { id: "tomato", nameAr: "طماطم", nameEn: "Tomato", nameDe: "Tomate", nameRu: "Томат", namePt: "Tomate", icon: "🍅", category: "vegetables" },
  { id: "onion", nameAr: "بصل", nameEn: "Onion", nameDe: "Zwiebel", nameRu: "Лук", namePt: "Cebola", icon: "🧅", category: "vegetables" },
  { id: "garlic", nameAr: "ثوم", nameEn: "Garlic", nameDe: "Knoblauch", nameRu: "Чеснок", namePt: "Alho", icon: "🧄", category: "vegetables" },
  { id: "carrot", nameAr: "جزر", nameEn: "Carrot", nameDe: "Karotte", nameRu: "Морковь", namePt: "Cenoura", icon: "🥕", category: "vegetables" },
  { id: "pepper", nameAr: "فلفل", nameEn: "Bell Pepper", nameDe: "Paprika", nameRu: "Перец", namePt: "Pimentão", icon: "🫑", category: "vegetables" },
  { id: "cucumber", nameAr: "خيار", nameEn: "Cucumber", nameDe: "Gurke", nameRu: "Огурец", namePt: "Pepino", icon: "🥒", category: "vegetables" },
  { id: "potato", nameAr: "بطاطس", nameEn: "Potato", nameDe: "Kartoffel", nameRu: "Картофель", namePt: "Batata", icon: "🥔", category: "vegetables" },
  { id: "spinach", nameAr: "سبانخ", nameEn: "Spinach", nameDe: "Spinat", nameRu: "Шпинат", namePt: "Espinafre", icon: "🥬", category: "vegetables" },
  { id: "eggplant", nameAr: "باذنجان", nameEn: "Eggplant", nameDe: "Aubergine", nameRu: "Баклажан", namePt: "Berinjela", icon: "🍆", category: "vegetables" },
  { id: "zucchini",     nameAr: "كوسا",          nameEn: "Zucchini",     nameDe: "Zucchini",          nameRu: "Кабачок",             namePt: "Abobrinha",        icon: "🟢", category: "vegetables" },
  { id: "mushroom",     nameAr: "فطر",           nameEn: "Mushroom",     nameDe: "Pilz",         nameRu: "Гриб",                namePt: "Cogumelo",           icon: "🍄", category: "vegetables" },
  { id: "broccoli",     nameAr: "بروكلي",        nameEn: "Broccoli",       nameDe: "Brokkoli",      nameRu: "Брокколи",            namePt: "Brócolis",     icon: "🥦", category: "vegetables" },
  { id: "cauliflower",  nameAr: "قرنبيط",        nameEn: "Cauliflower",      nameDe: "Blumenkohl",       nameRu: "Цветная капуста",     namePt: "Couve-flor",         icon: "🥦", category: "vegetables" },
  { id: "cabbage",      nameAr: "ملفوف",         nameEn: "Cabbage",       nameDe: "Kohl",     nameRu: "Капуста",             namePt: "Repolho",            icon: "🥬", category: "vegetables" },
  { id: "corn",         nameAr: "ذرة",           nameEn: "Corn",          nameDe: "Mais",           nameRu: "Кукуруза",            namePt: "Milho",            icon: "🌽", category: "vegetables" },
  { id: "sweet_potato", nameAr: "بطاطا حلوة",   nameEn: "Sweet Potato",  nameDe: "Süßkartoffel",        nameRu: "Батат",               namePt: "Batata doce",icon: "🍠", category: "vegetables" },
  { id: "pumpkin",      nameAr: "يقطين",         nameEn: "Pumpkin",      nameDe: "Kürbis",         nameRu: "Тыква",               namePt: "Abóbora",       icon: "🎃", category: "vegetables" },
  { id: "green_onion",  nameAr: "بصل أخضر",     nameEn: "Green Onion",     nameDe: "Frühlingszwiebel",     nameRu: "Зелёный лук",         namePt: "Cebolinha",         icon: "🌱", category: "vegetables" },
  { id: "celery",       nameAr: "كرفس",          nameEn: "Celery",          nameDe: "Sellerie",        nameRu: "Сельдерей",           namePt: "Aipo",           icon: "🌿", category: "vegetables" },
  { id: "leek",         nameAr: "كراث",          nameEn: "Leek",        nameDe: "Lauch",           nameRu: "Лук-порей",           namePt: "Alho-porro",      icon: "🪴", category: "vegetables" },
  { id: "lettuce",      nameAr: "خس",            nameEn: "Lettuce",       nameDe: "Kopfsalat",    nameRu: "Салат-латук",         namePt: "Alface",           icon: "🥬", category: "vegetables" },
  { id: "beetroot",     nameAr: "شمندر",         nameEn: "Beetroot",     nameDe: "Rote Beete",        nameRu: "Свёкла",              namePt: "Beterraba",          icon: "💜", category: "vegetables" },
  { id: "okra",         nameAr: "بامية",         nameEn: "Okra",          nameDe: "Okra",         nameRu: "Окра",                namePt: "Quiabo",          icon: "🫛", category: "vegetables" },
  { id: "turnip",       nameAr: "لفت",           nameEn: "Turnip",          nameDe: "Rübe",          nameRu: "Репа",                namePt: "Nabo",           icon: "🧅", category: "vegetables" },
  { id: "green_beans",  nameAr: "فاصوليا خضراء",nameEn: "Green Beans", nameDe: "Grüne Bohnen",    nameRu: "Стручковая фасоль",   namePt: "Feijão verde",      icon: "🫛", category: "vegetables" },
  { id: "parsley",      nameAr: "بقدونس",        nameEn: "Parsley",       nameDe: "Petersilie",         nameRu: "Петрушка",            namePt: "Salsa",          icon: "🍀", category: "vegetables" },
  { id: "mint",         nameAr: "نعناع",         nameEn: "Mint",         nameDe: "Minze",        nameRu: "Мята",                namePt: "Hortelã",          icon: "❄️", category: "vegetables" },
  { id: "coriander",    nameAr: "كزبرة طازجة",  nameEn: "Fresh Coriander",      nameDe: "Frischer Koriander",     nameRu: "Кинза",               namePt: "Coentro fresco",     icon: "🌻", category: "vegetables" },
  { id: "squash",       nameAr: "قرع",           nameEn: "Squash",        nameDe: "Kürbis",          nameRu: "Тыква",               namePt: "Abóbora",            icon: "🎃", category: "vegetables" },
  { id: "arugula",      nameAr: "جرجير",         nameEn: "Arugula",       nameDe: "Rucola",          nameRu: "Руккола",             namePt: "Rúcula",            icon: "🥬", category: "vegetables" },
  // Proteins
  { id: "chicken", nameAr: "دجاج", nameEn: "Chicken", nameDe: "Hühnchen", nameRu: "Курица", namePt: "Frango", icon: "🍗", category: "proteins" },
  { id: "beef", nameAr: "لحم بقر", nameEn: "Beef", nameDe: "Rindfleisch", nameRu: "Говядина", namePt: "Carne bovina", icon: "🥩", category: "proteins" },
  { id: "lamb", nameAr: "لحم غنم", nameEn: "Lamb", nameDe: "Lammfleisch", nameRu: "Баранина", namePt: "Cordeiro", icon: "🐑", category: "proteins" },
  { id: "eggs",          nameAr: "بيض",          nameEn: "Eggs",        nameDe: "Eier",          nameRu: "Яйца",                namePt: "Ovos",        icon: "🥚", category: "proteins" },
  { id: "minced_meat",   nameAr: "لحم مفروم",    nameEn: "Minced Meat",  nameDe: "Hackfleisch",          nameRu: "Фарш",                namePt: "Carne moída", icon: "🥩", category: "proteins" },
  { id: "turkey",        nameAr: "ديك رومي",     nameEn: "Turkey",          nameDe: "Pute",         nameRu: "Индейка",             namePt: "Peru",        icon: "🦃", category: "proteins" },
  { id: "veal",          nameAr: "لحم عجل",      nameEn: "Veal",       nameDe: "Kalbfleisch",  nameRu: "Телятина",            namePt: "Vitela",   icon: "🍖", category: "proteins" },
  { id: "camel_meat",    nameAr: "لحم جمل",      nameEn: "Camel Meat",nameDe: "Kamelfleisch",   nameRu: "Верблюжье мясо",      namePt: "Carne de camelo",      icon: "🐪", category: "proteins" },
  { id: "liver",         nameAr: "كبدة",         nameEn: "Liver",        nameDe: "Leber",          nameRu: "Печень",              namePt: "Fígado",            icon: "🫀", category: "proteins" },
  { id: "sausage",       nameAr: "نقانق",        nameEn: "Sausage",     nameDe: "Wurst",         nameRu: "Колбаса",             namePt: "Salsicha",          icon: "🌭", category: "proteins" },
  { id: "mortadella",    nameAr: "مرتديلا",      nameEn: "Mortadella",     nameDe: "Mortadella",    nameRu: "Мортаделла",          namePt: "Mortadela",       icon: "🥓", category: "proteins" },
  { id: "duck",          nameAr: "بط",           nameEn: "Duck",          nameDe: "Ente",         nameRu: "Утка",                namePt: "Pato",           icon: "🦆", category: "proteins" },
  // Seafood
  { id: "salmon", nameAr: "سلمون", nameEn: "Salmon", nameDe: "Lachs", nameRu: "Лосось", namePt: "Salmão", icon: "🐟", category: "seafood" },
  { id: "tuna", nameAr: "تونة", nameEn: "Tuna", nameDe: "Thunfisch", nameRu: "Тунец", namePt: "Atum", icon: "🐠", category: "seafood" },
  { id: "shrimp", nameAr: "روبيان", nameEn: "Shrimp", nameDe: "Garnele", nameRu: "Креветки", namePt: "Camarão", icon: "🦐", category: "seafood" },
  { id: "fish", nameAr: "سمك", nameEn: "Fish", nameDe: "Fisch", nameRu: "Рыба", namePt: "Peixe", icon: "🐡", category: "seafood" },
  { id: "sea_bass",    nameAr: "قاروص",         nameEn: "Sea Bass",          nameDe: "Wolfsbarsch",       nameRu: "Морской окунь",  namePt: "Robalo",        icon: "🐬", category: "seafood" },
  { id: "sea_bream",   nameAr: "دنيس",           nameEn: "Sea Bream",          nameDe: "Meerbrasse",     nameRu: "Дорада",         namePt: "Dourada",     icon: "🫧", category: "seafood" },
  { id: "sardine",     nameAr: "سردين",          nameEn: "Sardine",         nameDe: "Sardine",      nameRu: "Сардина",        namePt: "Sardinha",        icon: "🎣", category: "seafood" },
  { id: "mackerel",    nameAr: "إسقمري",         nameEn: "Mackerel",         nameDe: "Makrele",       nameRu: "Скумбрия",       namePt: "Cavala", icon: "🌊", category: "seafood" },
  { id: "cod",         nameAr: "سمك القد",       nameEn: "Cod",         nameDe: "Kabeljau",          nameRu: "Треска",         namePt: "Bacalhau",      icon: "⚓", category: "seafood" },
  { id: "halibut",     nameAr: "هاليبوت",        nameEn: "Halibut",         nameDe: "Heilbutt",       nameRu: "Палтус",         namePt: "Linguado",       icon: "⛵", category: "seafood" },
  { id: "red_mullet",  nameAr: "بربون",          nameEn: "Red Mullet",       nameDe: "Meerbarbe",    nameRu: "Барабуля",       namePt: "Salmonete",   icon: "🩷", category: "seafood" },
  { id: "anchovy",     nameAr: "أنشوجة",         nameEn: "Anchovy",          nameDe: "Sardelle",      nameRu: "Анчоус",         namePt: "Anchova",         icon: "🪝", category: "seafood" },
  { id: "swordfish",   nameAr: "أبو سيف",        nameEn: "Swordfish",      nameDe: "Schwertfisch",   nameRu: "Рыба-меч",       namePt: "Espadarte",      icon: "⚔️", category: "seafood" },
  { id: "snapper",     nameAr: "هامور أحمر",     nameEn: "Red Snapper",      nameDe: "Schnapper",   nameRu: "Снэппер",        namePt: "Vermelho",    icon: "🍣", category: "seafood" },
  { id: "grouper",     nameAr: "هامور",          nameEn: "Grouper",            nameDe: "Zackenbarsch",       nameRu: "Групер",         namePt: "Garoupa",         icon: "🪸", category: "seafood" },
  { id: "pomfret",     nameAr: "زبيدي",          nameEn: "Pomfret",         nameDe: "Stachelmakrele",    nameRu: "Помпано",        namePt: "Pampo",     icon: "🫓", category: "seafood" },
  { id: "tilapia",     nameAr: "بلطي",           nameEn: "Tilapia",         nameDe: "Tilapia",     nameRu: "Тилапия",        namePt: "Tilápia",       icon: "🎏", category: "seafood" },
  { id: "carp",        nameAr: "كارب",           nameEn: "Carp",           nameDe: "Karpfen",        nameRu: "Карп",           namePt: "Carpa",          icon: "🏮", category: "seafood" },
  { id: "catfish",     nameAr: "سمك الجري",      nameEn: "Catfish",           nameDe: "Wels",       nameRu: "Сом",            namePt: "Peixe-gato",     icon: "🐾", category: "seafood" },
  { id: "trout",       nameAr: "تراوت",          nameEn: "Trout",          nameDe: "Forelle",       nameRu: "Форель",         namePt: "Truta",      icon: "🏔️", category: "seafood" },
  { id: "perch",       nameAr: "فرخ السمك",      nameEn: "Perch",           nameDe: "Flussbarsch",         nameRu: "Окунь",          namePt: "Perca",      icon: "🌲", category: "seafood" },
  { id: "mullet",      nameAr: "بوري",           nameEn: "Mullet",           nameDe: "Meeräsche",        nameRu: "Кефаль",         namePt: "Tainha",          icon: "🌅", category: "seafood" },
  { id: "sobour",      nameAr: "سمك صبور",       nameEn: "Sabour Fish",       nameDe: "Sabour",            nameRu: "Сабур",           namePt: "Sabour",          icon: "🐟", category: "seafood" },
  { id: "byakh",       nameAr: "سمك بياح",       nameEn: "Byakh Fish",        nameDe: "Byakh",             nameRu: "Бях",             namePt: "Byakh",           icon: "🐠", category: "seafood" },
  // Dairy
  { id: "cheese", nameAr: "جبن", nameEn: "Cheese", nameDe: "Käse", nameRu: "Сыр", namePt: "Queijo", icon: "🧀", category: "dairy" },
  { id: "milk", nameAr: "حليب", nameEn: "Milk", nameDe: "Milch", nameRu: "Молоко", namePt: "Leite", icon: "🥛", category: "dairy" },
  { id: "yogurt", nameAr: "لبن", nameEn: "Yogurt", nameDe: "Joghurt", nameRu: "Йогурт", namePt: "Iogurte", icon: "🍶", category: "dairy" },
  { id: "butter",        nameAr: "زبدة",          nameEn: "Butter",   nameDe: "Butter",         nameRu: "Масло",               namePt: "Manteiga",            icon: "🧈", category: "dairy" },
  { id: "labneh",        nameAr: "لبنة",          nameEn: "Labneh",        nameDe: "Labneh",        nameRu: "Лябнэ",               namePt: "Labneh",           icon: "🥣", category: "dairy" },
  { id: "mozzarella",    nameAr: "موزاريلا",      nameEn: "Mozzarella",    nameDe: "Mozzarella",     nameRu: "Моцарелла",           namePt: "Mozzarella",        icon: "🧀", category: "dairy" },
  { id: "feta",          nameAr: "جبن فيتا",      nameEn: "Feta Cheese",    nameDe: "Feta-Käse",     nameRu: "Сыр фета",            namePt: "Queijo feta",       icon: "🧊", category: "dairy" },
  { id: "halloumi",      nameAr: "جبن حلوم",      nameEn: "Halloumi",      nameDe: "Halloumi",         nameRu: "Халлуми",             namePt: "Halloumi",      icon: "🍳", category: "dairy" },
  { id: "cream_cheese",  nameAr: "جبن كريمي",     nameEn: "Cream Cheese",   nameDe: "Frischkäse",    nameRu: "Сливочный сыр",       namePt: "Cream cheese",   icon: "🥐", category: "dairy" },
  { id: "qashta",        nameAr: "قشطة",          nameEn: "Clotted Cream",  nameDe: "Rahmcreme",          nameRu: "Топлёные сливки",     namePt: "Nata coalhada",          icon: "🍮", category: "dairy" },
  { id: "condensed_milk",nameAr: "حليب مكثف",    nameEn: "Condensed Milk",nameDe: "Kondensmilch", nameRu: "Сгущённое молоко",    namePt: "Leite condensado", icon: "🥫", category: "dairy" },
  { id: "powdered_milk", nameAr: "حليب بودرة",   nameEn: "Powdered Milk",nameDe: "Milchpulver",     nameRu: "Сухое молоко",        namePt: "Leite em pó",        icon: "☁️", category: "dairy" },
  { id: "cottage_cheese",nameAr: "جبن القريش",  nameEn: "Cottage Cheese",nameDe: "Hüttenkäse",    nameRu: "Творог",              namePt: "Queijo cottage",    icon: "🧀", category: "dairy" },
  { id: "rob_yogurt",   nameAr: "زبادي الروب",   nameEn: "Rob Yogurt",   nameDe: "Rob-Joghurt",     nameRu: "Роб-йогурт",          namePt: "Iogurte Rob",       icon: "🍶", category: "dairy" },
  // Grains
  { id: "rice", nameAr: "أرز", nameEn: "Rice", nameDe: "Reis", nameRu: "Рис", namePt: "Arroz", icon: "🍚", category: "grains" },
  { id: "pasta", nameAr: "معكرونة", nameEn: "Pasta", nameDe: "Nudeln", nameRu: "Макароны", namePt: "Macarrão", icon: "🍝", category: "grains" },
  { id: "bread",   nameAr: "خبز",  nameEn: "Bread",    nameDe: "Brot",  nameRu: "Хлеб",  namePt: "Pão",  icon: "🍞", category: "grains" },
  { id: "flour",   nameAr: "دقيق", nameEn: "Flour", nameDe: "Mehl",   nameRu: "Мука",  namePt: "Farinha",  icon: "🌾", category: "grains" },
  { id: "oats",        nameAr: "شوفان",      nameEn: "Oats",          nameDe: "Haferflocken",           nameRu: "Овсянка",        namePt: "Aveia",       icon: "🌾", category: "grains" },
  { id: "quinoa",      nameAr: "كينوا",      nameEn: "Quinoa",         nameDe: "Quinoa",      nameRu: "Киноа",          namePt: "Quinoa",         icon: "☀️", category: "grains" },
  { id: "barley",      nameAr: "شعير",       nameEn: "Barley",         nameDe: "Gerste",           nameRu: "Ячмень",         namePt: "Cevada",            icon: "🎋", category: "grains" },
  { id: "bulgur",      nameAr: "برغل",       nameEn: "Bulgur",         nameDe: "Bulgur",       nameRu: "Булгур",         namePt: "Bulgur",         icon: "🍲", category: "grains" },
  { id: "couscous",    nameAr: "كسكس",       nameEn: "Couscous",         nameDe: "Couscous",       nameRu: "Кускус",         namePt: "Cuscuz",        icon: "🧆", category: "grains" },
  { id: "freekeh",     nameAr: "فريكة",      nameEn: "Freekeh",        nameDe: "Freekeh",      nameRu: "Фрике",          namePt: "Freekeh",         icon: "🌾", category: "grains" },
  { id: "vermicelli",  nameAr: "شعيرية",     nameEn: "Vermicelli",         nameDe: "Fadennudeln",         nameRu: "Вермишель",      namePt: "Aletria",          icon: "🍜", category: "grains" },
  { id: "semolina",    nameAr: "سميد",       nameEn: "Semolina",         nameDe: "Grieß",         nameRu: "Манка",          namePt: "Sêmola",       icon: "🍰", category: "grains" },
  { id: "kunafa_dough", nameAr: "عجينة الكنافة", nameEn: "Kunafa Dough", nameDe: "Kunafa-Teig", nameRu: "Тесто кунафа", namePt: "Massa de kunafa", icon: "🥮", category: "grains" },
  { id: "cornmeal",    nameAr: "دقيق ذرة",   nameEn: "Cornmeal", nameDe: "Maismehl",  nameRu: "Кукурузная мука",namePt: "Fubá",       icon: "🌽", category: "grains" },
  { id: "brown_rice",  nameAr: "أرز بني",    nameEn: "Brown Rice", nameDe: "Brauner Reis", nameRu: "Коричневый рис", namePt: "Arroz integral",  icon: "🍱", category: "grains" },
  { id: "rice_noodles",nameAr: "نودلز أرز",  nameEn: "Rice Noodles",nameDe: "Reisnudeln", nameRu: "Рисовая лапша",  namePt: "Macarrão de arroz",   icon: "🥢", category: "grains" },
  { id: "sesame",      nameAr: "سمسم",       nameEn: "Sesame",      nameDe: "Sesam",      nameRu: "Кунжут",         namePt: "Gergelim",            icon: "🌱", category: "grains" },
  { id: "sorghum",     nameAr: "الزرة",       nameEn: "Sorghum",     nameDe: "Sorghum",     nameRu: "Сорго",          namePt: "Sorgo",              icon: "🌾", category: "grains" },
  { id: "millet",      nameAr: "الدخن",       nameEn: "Millet",      nameDe: "Hirse",       nameRu: "Просо",          namePt: "Painço",             icon: "🌾", category: "grains" },
  { id: "lentils", nameAr: "عدس", nameEn: "Lentils", nameDe: "Linsen", nameRu: "Чечевица", namePt: "Lentilhas", icon: "🫘", category: "legumes" },
  // Fruits
  { id: "lemon",       nameAr: "ليمون",    nameEn: "Lemon",       nameDe: "Zitrone",       nameRu: "Лимон",       namePt: "Limão",       icon: "🍋", category: "fruits" },
  { id: "apple",       nameAr: "تفاح",     nameEn: "Apple",     nameDe: "Apfel",         nameRu: "Яблоко",      namePt: "Maçã",        icon: "🍎", category: "fruits" },
  { id: "banana",      nameAr: "موز",      nameEn: "Banana",     nameDe: "Banane",        nameRu: "Банан",       namePt: "Banana",        icon: "🍌", category: "fruits" },
  { id: "orange",      nameAr: "برتقال",   nameEn: "Orange",     nameDe: "Orange",       nameRu: "Апельсин",    namePt: "Laranja",     icon: "🍊", category: "fruits" },
  { id: "strawberry",  nameAr: "فراولة",   nameEn: "Strawberry",       nameDe: "Erdbeere", nameRu: "Клубника",    namePt: "Morango",  icon: "🍓", category: "fruits" },
  { id: "grape",       nameAr: "عنب",      nameEn: "Grape",         nameDe: "Traube",       nameRu: "Виноград",    namePt: "Uva",      icon: "🍇", category: "fruits" },
  { id: "watermelon",  nameAr: "بطيخ",     nameEn: "Watermelon",      nameDe: "Wassermelone",       nameRu: "Арбуз",       namePt: "Melancia",    icon: "🍉", category: "fruits" },
  { id: "mango",       nameAr: "مانجو",    nameEn: "Mango",       nameDe: "Mango",          nameRu: "Манго",       namePt: "Manga",       icon: "🥭", category: "fruits" },
  { id: "peach",       nameAr: "خوخ",      nameEn: "Peach",     nameDe: "Pfirsich",        nameRu: "Персик",      namePt: "Pêssego",        icon: "🍑", category: "fruits" },
  { id: "pear",        nameAr: "كمثرى",    nameEn: "Pear",        nameDe: "Birne",     nameRu: "Груша",       namePt: "Pera",      icon: "🍐", category: "fruits" },
  { id: "pineapple",   nameAr: "أناناس",   nameEn: "Pineapple",        nameDe: "Ananas",      nameRu: "Ананас",      namePt: "Abacaxi",     icon: "🍍", category: "fruits" },
  { id: "kiwi",        nameAr: "كيوي",     nameEn: "Kiwi",        nameDe: "Kiwi",        nameRu: "Киви",        namePt: "Kiwi",       icon: "🥝", category: "fruits" },
  { id: "cherry",      nameAr: "كرز",      nameEn: "Cherry",      nameDe: "Kirsche",        nameRu: "Вишня",       namePt: "Cereja",      icon: "🍒", category: "fruits" },
  { id: "melon",       nameAr: "شمام",     nameEn: "Melon",       nameDe: "Melone",      nameRu: "Дыня",        namePt: "Melão",      icon: "🍈", category: "fruits" },
  { id: "avocado",     nameAr: "أفوكادو",  nameEn: "Avocado",    nameDe: "Avocado",     nameRu: "Авокадо",     namePt: "Abacate",    icon: "🥑", category: "fruits" },
  { id: "blueberry",   nameAr: "توت أزرق", nameEn: "Blueberry",    nameDe: "Heidelbeere",    nameRu: "Черника",     namePt: "Mirtilo",     icon: "🫐", category: "fruits" },
  { id: "coconut",     nameAr: "جوز هند",  nameEn: "Coconut",        nameDe: "Kokosnuss",      nameRu: "Кокос",       namePt: "Coco",     icon: "🥥", category: "fruits" },
  { id: "pomegranate", nameAr: "رمان",     nameEn: "Pomegranate",     nameDe: "Granatapfel",        nameRu: "Гранат",      namePt: "Romã",       icon: "🍇", category: "fruits" },
  { id: "date_fruit",  nameAr: "تمر",      nameEn: "Dates",     nameDe: "Datteln",        nameRu: "Финики",      namePt: "Tâmaras",       icon: "🌴", category: "fruits" },
  { id: "fig",         nameAr: "تين",      nameEn: "Fig",        nameDe: "Feige",       nameRu: "Инжир",       namePt: "Figo",      icon: "🟣", category: "fruits" },
  { id: "mandarin",    nameAr: "يوسفي",    nameEn: "Mandarin",   nameDe: "Mandarine",   nameRu: "Мандарин",    namePt: "Tangerina", icon: "🍊", category: "fruits" },
  // Condiments – Oils
  { id: "olive_oil",      nameAr: "زيت زيتون",       nameEn: "Olive Oil",   nameDe: "Olivenöl",  nameRu: "Оливковое масло",  namePt: "Azeite",      icon: "🫒", category: "condiments" },
  { id: "veg_oil",        nameAr: "زيت نباتي",        nameEn: "Vegetable Oil",    nameDe: "Pflanzenöl",   nameRu: "Растительное масло",namePt: "Óleo vegetal",      icon: "🧴", category: "condiments" },
  { id: "ghee",           nameAr: "سمن",              nameEn: "Ghee",              nameDe: "Ghee",            nameRu: "Гхи",              namePt: "Ghee",     icon: "🪔", category: "condiments" },
  { id: "sesame_oil",     nameAr: "زيت السمسم",       nameEn: "Sesame Oil",  nameDe: "Sesamöl",    nameRu: "Кунжутное масло",  namePt: "Óleo de gergelim",       icon: "✨", category: "condiments" },
  // Condiments – Spices
  { id: "salt",           nameAr: "ملح",              nameEn: "Salt",               nameDe: "Salz",           nameRu: "Соль",             namePt: "Sal",             icon: "🧂", category: "condiments" },
  { id: "black_pepper",   nameAr: "فلفل أسود",        nameEn: "Black Pepper",    nameDe: "Schwarzer Pfeffer",    nameRu: "Черный перец",     namePt: "Pimenta preta",       icon: "⚫", category: "condiments" },
  { id: "cumin",          nameAr: "كمون",             nameEn: "Cumin",            nameDe: "Kreuzkümmel",          nameRu: "Тмин",             namePt: "Cominho",            icon: "🟤", category: "condiments" },
  { id: "turmeric",       nameAr: "كركم",             nameEn: "Turmeric",           nameDe: "Kurkuma",         nameRu: "Куркума",          namePt: "Cúrcuma",         icon: "🟡", category: "condiments" },
  { id: "cinnamon",       nameAr: "قرفة",             nameEn: "Cinnamon",            nameDe: "Zimt",       nameRu: "Корица",           namePt: "Canela",          icon: "🤎", category: "condiments" },
  { id: "cardamom",       nameAr: "هيل",              nameEn: "Cardamom",         nameDe: "Kardamom",        nameRu: "Кардамон",         namePt: "Cardamomo",              icon: "🫛", category: "condiments" },
  { id: "coriander_g",    nameAr: "كزبرة مطحونة",    nameEn: "Coriander (ground)",   nameDe: "Koriander gemahlen",  nameRu: "Кориандр молотый", namePt: "Coentro moído", icon: "🎍", category: "condiments" },
  { id: "paprika",        nameAr: "بابريكا",          nameEn: "Paprika",          nameDe: "Paprika",       nameRu: "Паприка",          namePt: "Páprica",         icon: "🔴", category: "condiments" },
  { id: "chili_powder",   nameAr: "فلفل حار",         nameEn: "Chili Powder",    nameDe: "Chilipulver",     nameRu: "Перец чили",       namePt: "Pimenta chili",  icon: "🌶️",category: "condiments" },
  { id: "ginger",         nameAr: "زنجبيل",           nameEn: "Ginger",          nameDe: "Ingwer",          nameRu: "Имбирь",           namePt: "Gengibre",          icon: "🫚", category: "condiments" },
  { id: "baharat",        nameAr: "بهارات",           nameEn: "Baharat (spice mix)",           nameDe: "Baharat",nameRu: "Бахарат",          namePt: "Baharat",          icon: "🫙", category: "condiments" },
  { id: "saffron",        nameAr: "زعفران",           nameEn: "Saffron",           nameDe: "Safran",          nameRu: "Шафран",           namePt: "Açafrão",          icon: "🟠", category: "condiments" },
  { id: "cloves",         nameAr: "قرنفل",            nameEn: "Cloves",             nameDe: "Nelken",          nameRu: "Гвоздика",         namePt: "Cravo",            icon: "☘️", category: "condiments" },
  { id: "nutmeg",         nameAr: "جوزة الطيب",       nameEn: "Nutmeg",      nameDe: "Muskatnuss",         nameRu: "Мускатный орех",   namePt: "Noz-moscada",        icon: "🌰", category: "condiments" },
  { id: "bay_leaf",       nameAr: "ورق الغار",        nameEn: "Bay Leaf",    nameDe: "Lorbeerblatt",     nameRu: "Лавровый лист",    namePt: "Folha de louro",          icon: "🍂", category: "condiments" },
  { id: "thyme",          nameAr: "زعتر",             nameEn: "Thyme / Za'atar",           nameDe: "Thymian",        nameRu: "Тимьян",           namePt: "Tomilho",           icon: "🏵️", category: "condiments" },
  { id: "vanilla",        nameAr: "فانيليا",          nameEn: "Vanilla",          nameDe: "Vanille",        nameRu: "Ваниль",           namePt: "Baunilha",           icon: "🌿", category: "condiments" },
  // Condiments – Sugars & Sweeteners
  { id: "sugar",          nameAr: "سكر أبيض",         nameEn: "White Sugar",     nameDe: "Weißer Zucker",     nameRu: "Белый сахар",      namePt: "Açúcar branco",        icon: "🍬", category: "condiments" },
  { id: "brown_sugar",    nameAr: "سكر بني",          nameEn: "Brown Sugar",     nameDe: "Brauner Zucker",     nameRu: "Коричневый сахар", namePt: "Açúcar mascavo",    icon: "🟫", category: "condiments" },
  { id: "powdered_sugar", nameAr: "سكر ناعم",         nameEn: "Powdered Sugar",   nameDe: "Puderzucker",   nameRu: "Сахарная пудра",   namePt: "Açúcar de confeiteiro",       icon: "🤍", category: "condiments" },
  { id: "honey",          nameAr: "عسل",              nameEn: "Honey",              nameDe: "Honig",           nameRu: "Мёд",              namePt: "Mel",             icon: "🍯", category: "condiments" },
  { id: "molasses",       nameAr: "دبس",              nameEn: "Molasses",            nameDe: "Melasse",           nameRu: "Патока",           namePt: "Melaço",            icon: "🍯", category: "condiments" },
  // Condiments – Sauces & Pastes
  { id: "tomato_paste",   nameAr: "معجون طماطم",      nameEn: "Tomato Paste",   nameDe: "Tomatenmark",nameRu: "Томатная паста",   namePt: "Extrato de tomate",         icon: "🍅", category: "condiments" },
  { id: "tahini",         nameAr: "طحينة",            nameEn: "Tahini",            nameDe: "Tahin",        nameRu: "Тахини",           namePt: "Tahine",            icon: "🌼", category: "condiments" },
  { id: "vinegar",        nameAr: "خل",               nameEn: "Vinegar",           nameDe: "Essig",         nameRu: "Уксус",            namePt: "Vinagre",            icon: "🫗", category: "condiments" },
  { id: "soy_sauce",      nameAr: "صلصة الصويا",      nameEn: "Soy Sauce",     nameDe: "Sojasoße",      nameRu: "Соевый соус",      namePt: "Molho de soja",         icon: "🥡", category: "condiments" },
  { id: "ketchup",        nameAr: "كاتشب",            nameEn: "Ketchup",           nameDe: "Ketchup",          nameRu: "Кетчуп",           namePt: "Ketchup",            icon: "🍅", category: "condiments" },
  { id: "pomegranate_mol",nameAr: "دبس الرمان",       nameEn: "Pomegranate Molasses", nameDe: "Granatapfelsirup",  nameRu: "Гранатовый соус",  namePt: "Melaço de romã",         icon: "🍷", category: "condiments" },
  { id: "rose_water",     nameAr: "ماء الورد",        nameEn: "Rose Water",     nameDe: "Rosenwasser",      nameRu: "Розовая вода",     namePt: "Água de rosas",            icon: "🌹", category: "condiments" },
  // Condiments – Baking essentials
  { id: "baking_powder",  nameAr: "مسحوق الخميرة",   nameEn: "Baking Powder", nameDe: "Backpulver",  nameRu: "Разрыхлитель",     namePt: "Fermento em pó",      icon: "🧁", category: "condiments" },
  { id: "chocolate",      nameAr: "شوكولاتة",         nameEn: "Chocolate",         nameDe: "Schokolade",        nameRu: "Шоколад",          namePt: "Chocolate",           icon: "🍫", category: "condiments" },
  // Condiments – Nuts
  { id: "almonds",        nameAr: "لوز",              nameEn: "Almonds",            nameDe: "Mandeln",           nameRu: "Миндаль",          namePt: "Amêndoas",            icon: "🌰", category: "condiments" },
  { id: "walnut",         nameAr: "جوز",              nameEn: "Walnut",             nameDe: "Walnuss",           nameRu: "Грецкий орех",     namePt: "Noz",                 icon: "🌰", category: "condiments" },
  { id: "barberry",       nameAr: "زرشك",             nameEn: "Barberry",           nameDe: "Berberitze",        nameRu: "Барбарис",         namePt: "Bérberis",            icon: "🔴", category: "condiments" },
  { id: "dill",           nameAr: "شبت",              nameEn: "Dill",               nameDe: "Dill",              nameRu: "Укроп",            namePt: "Endro",               icon: "🌿", category: "vegetables" },
  { id: "cream", nameAr: "كريمة", nameEn: "Cream", nameDe: "Sahne", nameRu: "Сливки", namePt: "Creme", icon: "🥛", category: "dairy" },
  // Legumes
  { id: "chickpeas", nameAr: "حمص", nameEn: "Chickpeas", nameDe: "Kichererbsen", nameRu: "Нут", namePt: "Grão-de-bico", icon: "🪙", category: "legumes" },
  { id: "green_peas", nameAr: "بازلاء", nameEn: "Green Peas", nameDe: "Erbsen", nameRu: "Зелёный горошек", namePt: "Ervilhas", icon: "🟩", category: "legumes" },
  { id: "black_eyed_peas", nameAr: "لوبيا", nameEn: "Black-eyed Peas", nameDe: "Schwarzaugenbohnen", nameRu: "Вигна", namePt: "Feijão-frade", icon: "🔘", category: "legumes" },
  { id: "kidney_beans", nameAr: "فاصوليا حمراء", nameEn: "Kidney Beans", nameDe: "Kidneybohnen", nameRu: "Красная фасоль", namePt: "Feijão vermelho", icon: "❤️", category: "legumes" },
  { id: "white_beans", nameAr: "فاصوليا بيضاء", nameEn: "White Beans", nameDe: "Weiße Bohnen", nameRu: "Белая фасоль", namePt: "Feijão branco", icon: "⚪", category: "legumes" },
  { id: "mung_beans", nameAr: "ماش", nameEn: "Mung Beans", nameDe: "Mungobohnen", nameRu: "Маш", namePt: "Feijão-mungo", icon: "🔆", category: "legumes" },
  { id: "broad_beans", nameAr: "باقلاء", nameEn: "Broad Beans", nameDe: "Puffbohnen", nameRu: "Крупные бобы", namePt: "Favas largas", icon: "🫛", category: "legumes" },
  { id: "lupini_beans",nameAr: "حبوب اللبة",nameEn: "Lupini Beans",nameDe: "Lupinen", nameRu: "Люпин", namePt: "Lupini", icon: "🟡", category: "legumes" },
  // Beverages & Juices (halal)
  { id: "water",          nameAr: "ماء",              nameEn: "Water",              nameDe: "Wasser",          nameRu: "Вода",             namePt: "Água",              icon: "💧", category: "beverages" },
  { id: "milk_drink",     nameAr: "حليب",             nameEn: "Milk",             nameDe: "Milch",           nameRu: "Молоко",           namePt: "Leite",             icon: "🥛", category: "beverages" },
  { id: "orange_juice",   nameAr: "عصير برتقال",      nameEn: "Orange Juice",   nameDe: "Orangensaft",   nameRu: "Апельсиновый сок", namePt: "Suco de laranja",       icon: "🍊", category: "beverages" },
  { id: "apple_juice",    nameAr: "عصير تفاح",        nameEn: "Apple Juice",   nameDe: "Apfelsaft",     nameRu: "Яблочный сок",     namePt: "Suco de maçã",          icon: "🍎", category: "beverages" },
  { id: "mango_juice",    nameAr: "عصير مانجو",       nameEn: "Mango Juice",     nameDe: "Mangosaft",      nameRu: "Манговый сок",     namePt: "Suco de manga",         icon: "🥭", category: "beverages" },
  { id: "grape_juice",    nameAr: "عصير عنب",         nameEn: "Grape Juice",       nameDe: "Traubensaft",   nameRu: "Виноградный сок",  namePt: "Suco de uva",        icon: "🍇", category: "beverages" },
  { id: "pom_juice",      nameAr: "عصير رمان",        nameEn: "Pomegranate Juice",   nameDe: "Granatapfelsaft",    nameRu: "Гранатовый сок",   namePt: "Suco de romã",         icon: "🍹", category: "beverages" },
  { id: "lemon_juice",    nameAr: "عصير ليمون",       nameEn: "Lemon Juice",     nameDe: "Zitronensaft",   nameRu: "Лимонный сок",     namePt: "Suco de limão",         icon: "🍋", category: "beverages" },
  { id: "tamarind_juice", nameAr: "عصير تمر هندي",    nameEn: "Tamarind Juice", nameDe: "Tamarindensaft",    nameRu: "Сок тамаринда",    namePt: "Suco de tamarindo",     icon: "🧃", category: "beverages" },
  { id: "hibiscus",       nameAr: "كركديه",           nameEn: "Hibiscus Drink",   nameDe: "Hibiskustee",  nameRu: "Каркаде",          namePt: "Chá de hibisco",         icon: "🌺", category: "beverages" },
  { id: "rose_drink",     nameAr: "شراب ورد",         nameEn: "Rose Drink",    nameDe: "Rosengetränk", nameRu: "Розовый напиток",   namePt: "Bebida de rosa",         icon: "🌷", category: "beverages" },
  { id: "laban",          nameAr: "لبن",              nameEn: "Laban (Buttermilk)",             nameDe: "Laban",         nameRu: "Лабан",            namePt: "Laban",             icon: "🥤", category: "beverages" },
  { id: "ayran",          nameAr: "عيران",            nameEn: "Ayran",             nameDe: "Ayran",         nameRu: "Айран",            namePt: "Ayran",           icon: "🧋", category: "beverages" },
  { id: "coconut_water",  nameAr: "ماء جوز الهند",    nameEn: "Coconut Water",      nameDe: "Kokoswasser",   nameRu: "Кокосовая вода",   namePt: "Água de coco",       icon: "🥥", category: "beverages" },
  { id: "green_tea",      nameAr: "شاي أخضر",         nameEn: "Green Tea",          nameDe: "Grüner Tee",       nameRu: "Зелёный чай",      namePt: "Chá verde",         icon: "🍵", category: "beverages" },
  { id: "black_tea",      nameAr: "شاي أسود",         nameEn: "Black Tea",          nameDe: "Schwarzer Tee",      nameRu: "Чёрный чай",       namePt: "Chá preto",        icon: "🍵", category: "beverages" },
  { id: "mint_tea",       nameAr: "شاي بالنعناع",     nameEn: "Mint Tea",       nameDe: "Minztee",    nameRu: "Мятный чай",       namePt: "Chá de hortelã",       icon: "🧉", category: "beverages" },
  { id: "coffee",         nameAr: "قهوة",             nameEn: "Coffee",              nameDe: "Kaffee",          nameRu: "Кофе",             namePt: "Café",            icon: "☕", category: "beverages" },
  { id: "arabic_coffee",  nameAr: "قهوة عربية",       nameEn: "Arabic Coffee",        nameDe: "Arabischer Kaffee",     nameRu: "Арабский кофе",    namePt: "Café árabe",       icon: "🥃", category: "beverages" },
  { id: "jallab",         nameAr: "جلاب",             nameEn: "Jallab",            nameDe: "Jallab",          nameRu: "Джаллаб",          namePt: "Jallab",            icon: "🍷", category: "beverages" },
  { id: "sahlab",         nameAr: "سحلب",             nameEn: "Sahlab",            nameDe: "Sahlab",          nameRu: "Сахлаб",           namePt: "Sahlab",          icon: "🫖", category: "beverages" },
  { id: "strawberry_juice",nameAr: "عصير فراولة",     nameEn: "Strawberry Juice",     nameDe: "Erdbeersaft",nameRu: "Клубничный сок",   namePt: "Suco de morango",   icon: "🍓", category: "beverages" },
  { id: "watermelon_juice",nameAr: "عصير بطيخ",       nameEn: "Watermelon Juice",    nameDe: "Wassermelonensaft",   nameRu: "Арбузный сок",     namePt: "Suco de melancia",       icon: "🍉", category: "beverages" },
  { id: "carrot_juice",   nameAr: "عصير جزر",         nameEn: "Carrot Juice", nameDe: "Karottensaft",    nameRu: "Морковный сок",    namePt: "Suco de cenoura",         icon: "🥕", category: "beverages" },
];

export type FoodCategory = "all" | "soups" | "salads" | "desserts" | "breakfast" | "grilled" | "seafood" | "pastries" | "juices" | "athletes";

export interface Recipe {
  id: string;
  nameAr: string;
  nameEn: string;
  nameDe?: string;
  nameRu?: string;
  namePt?: string;
  category: FoodCategory;
  cuisine?: string;
  requiredIngredients: string[];
  optionalIngredients: string[];
  ingredientQuantities?: Record<string, { amount: number | null; unit: string }>;
  stepsAr: string[];
  stepsEn: string[];
  ovenTempAr?: string;
  ovenTempEn?: string;
  tipsAr?: string[];
  tipsEn?: string[];
  servingAr?: string[];
  servingEn?: string[];
  time: number;
  servings: number;
  image: string;
  nutrition: {
    calories: number;
    protein: number;
    carbs: number;
    fat: number;
    fiber: number;
    sodium: number;
    calcium: number;
    sugar?: number;
  };
  ingredientCompleteness?: "verified" | "unverified";
}

export const recipes: Recipe[] = [
  // SEAFOOD MAIN DISHES
  {
    id: "shrimp_rice",
    nameAr: "أرز بالروبيان",
    nameEn: "Shrimp Rice",
    nameDe: "Garnelenreis",
    nameRu: "Рис с креветками",
    namePt: "Arroz com camarão",
    category: "seafood",
    requiredIngredients: ["shrimp", "rice", "onion", "garlic"],
    optionalIngredients: ["tomato", "pepper", "olive_oil", "lemon"],
    ingredientQuantities: { shrimp: { amount: 500, unit: "جرام" }, rice: { amount: 2, unit: "كوب" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 4, unit: "فص" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, lemon: { amount: 1, unit: "حبة" } },
    stepsAr: ["ننظف الروبيان ونتبله بالثوم والليمون والبهارات", "نسلق الأرز في ماء مملح حتى ينضج", "نحمر البصل والثوم في زيت الزيتون ثم نضيف الروبيان", "نطهي الروبيان ٥ دقائق حتى يتغير لونه", "نقدم الروبيان فوق الأرز ونعصر الليمون"],
    stepsEn: ["Clean shrimp and marinate with garlic, lemon, and spices", "Boil rice in salted water until cooked", "Sauté onion and garlic in olive oil then add shrimp", "Cook shrimp 5 minutes until color changes", "Serve shrimp over rice and squeeze lemon"],
    ovenTempAr: "نار متوسطة (١٨٠°م) لطهي الروبيان على الموقد",
    ovenTempEn: "Medium heat (180°C) for cooking shrimp on stovetop",
    tipsAr: ["تبل الروبيان قبل الطهي بـ ١٥ دقيقة على الأقل لامتصاص النكهة", "أضف الثوم المفروم والكمون والكزبرة المطحونة والفلفل الأسود للروبيان", "لا تطهي الروبيان أكثر من ٥ دقائق حتى لا يصبح مطاطياً", "أضف ملعقة صغيرة من الكركم للأرز للون ذهبي ونكهة مميزة", "قلّب الروبيان برفق مع البصل والثوم حتى يتغطى بالبهارات"],
    tipsEn: ["Marinate shrimp at least 15 minutes before cooking for flavor absorption", "Add minced garlic, cumin, ground coriander, and black pepper to shrimp", "Do not cook shrimp more than 5 minutes to avoid rubbery texture", "Add a teaspoon of turmeric to rice for golden color and distinct flavor", "Toss shrimp gently with onion and garlic until coated with spices"],
    servingAr: ["يقدم ساخناً فوق الأرز الأبيض في طبق واسع", "اعصر ليمونة طازجة فوق الروبيان قبل التقديم", "زيّن بالبقدونس المفروم وشرائح الليمون", "يقدم مع سلطة الزبادي بالخيار أو السلطة الخضراء"],
    servingEn: ["Serve hot over white rice in a wide plate", "Squeeze fresh lemon over shrimp before serving", "Garnish with chopped parsley and lemon slices", "Serve with cucumber yogurt salad or green salad"],
    time: 35,
    servings: 4,
    image: "images/recipes/pexels-723198-800.jpeg",
    nutrition: { calories: 320, protein: 24, carbs: 45, fat: 6, fiber: 1, sodium: 480, calcium: 70 },
  },
  {
    id: "fish_biryani",
    nameAr: "برياني سمك",
    nameEn: "Fish Biryani",
    nameDe: "Fisch-Biryani",
    nameRu: "Бирьяни с рыбой",
    namePt: "Biryani de peixe",
    category: "seafood",
    requiredIngredients: ["fish", "rice", "onion", "yogurt"],
    optionalIngredients: ["garlic", "tomato", "olive_oil", "lemon"],
    ingredientQuantities: { fish: { amount: 800, unit: "جرام" }, rice: { amount: 2, unit: "كوب" }, onion: { amount: 2, unit: "حبة" }, yogurt: { amount: 150, unit: "جرام" }, garlic: { amount: 4, unit: "فص" } },
    stepsAr: ["نتبل السمك بالزبادي والثوم والبهارات والليمون", "نسلق الأرز مع البهارات حتى يكتمل نصف نضجه", "نحمر البصل ونضيف السمك المتبل ونطهيه", "نرتب طبقات الأرز والسمك في القدر", "نطهي على نار هادئة ٢٠ دقيقة ونقدم مع الزبادي"],
    stepsEn: ["Marinate fish with yogurt, garlic, spices, and lemon", "Boil rice with spices until half cooked", "Sauté onion, add marinated fish, and cook", "Layer rice and fish in the pot", "Cook on low heat 20 minutes, serve with yogurt"],
    ovenTempAr: "نار هادئة جداً (١٥٠°م) على الموقد لمدة ٢٠ دقيقة بعد طبقات الأرز والسمك",
    ovenTempEn: "Very low heat (150°C) on stovetop for 20 minutes after layering rice and fish",
    tipsAr: ["تبل السمك بالزبادي والثون والكركم والكمون والبهار الحلو لمدة ٣٠ دقيقة", "اسلق الأرز مع ورق الغار والهيل والقرفة حتى يكتمل نصف نضجه فقط", "أضف ملعقة كبيرة من زيت الزيتون أو السمن بين طبقات الأرز والسمك", "استخدم بهارات البرياني المشكلة (كركم، كمون، كزبرة، فلفل أسود، بهار حلو)", "غطي القدر بورق الألمنيوم ثم الغطاء لاحتباس البخار ونضج الطبقات"],
    tipsEn: ["Marinate fish with yogurt, garlic, turmeric, cumin, and allspice for 30 minutes", "Boil rice with bay leaves, cardamom, and cinnamon until only half cooked", "Add a tablespoon of olive oil or ghee between rice and fish layers", "Use mixed biryani spices (turmeric, cumin, coriander, black pepper, allspice)", "Cover pot with foil then lid to trap steam and cook layers evenly"],
    servingAr: ["يقدم ساخناً في طبق واسع مع رشة من الزعفران والكزبرة الخضراء", "يقدم مع الزبادي البارد أو صلصة النعناع", "زيّن بالبصل المقلي الذهبي والكاجو", "يقدم مع الخبز العربي أو النان"],
    servingEn: ["Serve hot in a wide plate with a sprinkle of saffron and fresh coriander", "Serve with cold yogurt or mint sauce", "Garnish with golden fried onions and cashews", "Serve with Arabic bread or naan"],
    time: 60,
    servings: 5,
    image: "images/recipes/pexels-1279330-800.jpeg",
    nutrition: { calories: 380, protein: 28, carbs: 48, fat: 9, fiber: 2, sodium: 520, calcium: 90 },
  },
  {
    id: "grilled_shrimp_plate",
    nameAr: "طبق روبيان مشوي",
    nameEn: "Grilled Shrimp Plate",
    nameDe: "Gegrillter Garnelenteller",
    nameRu: "Тарелка с креветками гриль",
    namePt: "Prato de camarão grelhado",
    category: "seafood",
    requiredIngredients: ["shrimp", "garlic", "lemon", "olive_oil"],
    optionalIngredients: ["pepper", "onion", "parsley"],
    ingredientQuantities: { shrimp: { amount: 600, unit: "جرام" }, garlic: { amount: 5, unit: "فص" }, lemon: { amount: 2, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["ننظف الروبيان ونتبله بالثوم والليمون وزيت الزيتون", "نتركه يتبل ٣٠ دقيقة", "نشوي الروبيان على نار عالية ٣ دقائق من كل جانب", "نقدم مع الخضار المشوية والليمون", "نرش البقدونس المفروم فوقه"],
    stepsEn: ["Clean shrimp and marinate with garlic, lemon, and olive oil", "Let marinate for 30 minutes", "Grill shrimp on high heat 3 minutes each side", "Serve with grilled vegetables and lemon", "Sprinkle chopped parsley on top"],
    ovenTempAr: "نار عالية (٢٢٠°م) على الشواية أو الفرن - ٣ دقائق من كل جانب",
    ovenTempEn: "High heat (220°C) on grill or oven - 3 minutes per side",
    tipsAr: ["تبل الروبيان بزيت الزيتون والثون المهروس وعصير الليمون والملح والفلفل الأسود", "أضف ملعقة صغيرة من البابريكا والشطة للحرارة واللون", "انقع الروبيان في الأسياخ بعد تتبيله ٣٠ دقيقة لامتصاص النكهة", "اشوي على نار عالية مباشرة حتى تحصل على علامات الشواء الذهبية", "ادهن الروبيان بالتتبيلة المتبقية أثناء الشواء لترطيب إضافي"],
    tipsEn: ["Marinate shrimp with olive oil, minced garlic, lemon juice, salt, and black pepper", "Add a teaspoon of paprika and chili flakes for heat and color", "Thread shrimp onto skewers after 30 minutes marinating for flavor absorption", "Grill over direct high heat until golden grill marks appear", "Baste shrimp with remaining marinade during grilling for extra moisture"],
    servingAr: ["يقدم ساخناً مع شرائح الليمون والبقدونس المفروم", "يقدم مع الخضار المشوية (فلفل، كوسة، بصل)", "رش رشة من رقائق الفلفل الأحمر والملح البحري قبل التقديم", "يقدم مع صلصة الثوم أو الطحينة"],
    servingEn: ["Serve hot with lemon slices and chopped parsley", "Serve with grilled vegetables (pepper, zucchini, onion)", "Sprinkle red pepper flakes and sea salt before serving", "Serve with garlic sauce or tahini"],
    time: 40,
    servings: 3,
    image: "images/recipes/pexels-5493061-800.jpeg",
    nutrition: { calories: 220, protein: 28, carbs: 4, fat: 10, fiber: 1, sodium: 460, calcium: 80 },
  },
  {
    id: "seafood_pasta",
    nameAr: "معكرونة بالمأكولات البحرية",
    nameEn: "Seafood Pasta",
    nameDe: "Meeresfrüchte-Pasta",
    nameRu: "Паста с морепродуктами",
    namePt: "Macarrão com frutos do mar",
    category: "seafood",
    requiredIngredients: ["pasta", "shrimp", "garlic", "tomato"],
    optionalIngredients: ["fish", "olive_oil", "lemon", "parsley"],
    ingredientQuantities: { pasta: { amount: 400, unit: "جرام" }, shrimp: { amount: 300, unit: "جرام" }, garlic: { amount: 4, unit: "فص" }, tomato: { amount: 400, unit: "جرام" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نسلق المعكرونة في ماء مملح حتى تنضج", "نحمر الثوم في زيت الزيتون ونضيف الطماطم", "نضيف الروبيان والسمك ونطهي ٥ دقائق", "نضيف المعكرونة المسلوقة للصلصة ونقلب", "نقدم مع البقدونس وعصير الليمون"],
    stepsEn: ["Boil pasta in salted water until cooked", "Sauté garlic in olive oil and add tomatoes", "Add shrimp and fish, cook 5 minutes", "Add boiled pasta to sauce and toss", "Serve with parsley and lemon juice"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لطهي الصلصة والماكولات البحرية",
    ovenTempEn: "Medium heat (180°C) on stovetop for cooking sauce and seafood",
    tipsAr: ["اسلق المعكرونة في ماء مملح مع ملعقة زيت زيتون لمنع الالتصاق", "أضف الثون المفروم لزيت الزيتون البارد قبل تسخينه لتفادي احتراقه", "أضف الطماطم المفرومة وملعقة صغيرة من الأوريغانو والريحان المجفف", "أضف الروبيان والسمك للصلصة وقلّب برفق لمدة ٥ دقائق فقط", "احتفظ بنصف كوب من ماء سلق المعكرونة لإضافته للصلصة لكريمية أفضل"],
    tipsEn: ["Boil pasta in salted water with a tablespoon of olive oil to prevent sticking", "Add minced garlic to cold olive oil before heating to avoid burning", "Add chopped tomatoes with a teaspoon of oregano and dried basil", "Add shrimp and fish to sauce and toss gently for only 5 minutes", "Save half a cup of pasta water to add to sauce for better creaminess"],
    servingAr: ["يقدم ساخناً في طبق عميق مع رش البقدونس المفروم", "اعصر الليمون الطازج فوق المعكرونة قبل التقديم", "رش جبن البارميزان المبشور والفلفل الأسود الطازج", "يقدم مع خبز الثوم المحمص والسلطة الخضراء"],
    servingEn: ["Serve hot in a deep plate with chopped parsley", "Squeeze fresh lemon over pasta before serving", "Sprinkle grated parmesan and fresh black pepper", "Serve with garlic toast and green salad"],
    time: 30,
    servings: 4,
    image: "images/recipes/pexels-1438676-800.jpeg",
    nutrition: { calories: 380, protein: 24, carbs: 48, fat: 10, fiber: 3, sodium: 540, calcium: 60 },
  },
  {
    id: "fish_tagine",
    nameAr: "طاجين السمك",
    nameEn: "Fish Tagine",
    nameDe: "Fisch-Tajine",
    nameRu: "Тажин с рыбой",
    namePt: "Tajine de peixe",
    category: "seafood",
    requiredIngredients: ["fish", "tomato", "onion", "garlic", "olive_oil"],
    optionalIngredients: ["pepper", "potato", "lemon", "parsley"],
    ingredientQuantities: { fish: { amount: 800, unit: "جرام" }, tomato: { amount: 4, unit: "حبة" }, onion: { amount: 2, unit: "حبة" }, garlic: { amount: 4, unit: "فص" }, olive_oil: { amount: 4, unit: "ملعقة ك." } },
    stepsAr: ["نتبل السمك بالثوم والبهارات والليمون", "نرص شرائح البطاطس والطماطم والبصل في الطاجين", "نضع السمك فوق الخضار", "نسكب زيت الزيتون ونطهي على نار هادئة ٤٠ دقيقة", "نقدم ساخناً مع الخبز"],
    stepsEn: ["Marinate fish with garlic, spices, and lemon", "Arrange potato, tomato, and onion slices in tagine", "Place fish over vegetables", "Pour olive oil and cook on low heat 40 minutes", "Serve hot with bread"],
    ovenTempAr: "نار هادئة جداً (١٥٠°م) على الموقد في طاجين فخاري لمدة ٤٠ دقيقة",
    ovenTempEn: "Very low heat (150°C) on stovetop in clay tagine for 40 minutes",
    tipsAr: ["تبل السمك بالثون والكمون والكزبرة والكركم والفلفل الأحمر والملح والليمون", "رص شرائح البطاطس والطماطم والبصل في طبقات متساوية في قاع الطاجين", "أضف ملعقة صغيرة من الزعفران المطحون وورق الغار بين الطبقات", "اسكب زيت الزيتون بالتساوي فوق السمك والخضار لترطيبها", "غطي الطاجين بغطائه الفخاري واتركه على نار هادئة دون فتح لمدة ٤٠ دقيقة"],
    tipsEn: ["Marinate fish with garlic, cumin, coriander, turmeric, paprika, salt, and lemon", "Arrange potato, tomato, and onion slices in equal layers at bottom of tagine", "Add a teaspoon of ground saffron and bay leaves between layers", "Pour olive oil evenly over fish and vegetables to keep them moist", "Cover tagine with its clay lid and leave on low heat without opening for 40 minutes"],
    servingAr: ["يقدم ساخناً في الطاجين الفخاري مباشرة على المائدة", "يقدم مع الخبز العربي الطازج لامتصاص الصلصة", "رش الكزبرة الخضراء المفرومة والزيتون قبل التقديم", "اعصر الليمون الطازج فوق السمك عند التقديم"],
    servingEn: ["Serve hot in the clay tagine directly on the table", "Serve with fresh Arabic bread to absorb the sauce", "Sprinkle chopped fresh coriander and olives before serving", "Squeeze fresh lemon over fish when serving"],
    time: 50,
    servings: 4,
    image: "images/recipes/pexels-17010948-800.jpeg",
    nutrition: { calories: 280, protein: 30, carbs: 14, fat: 12, fiber: 3, sodium: 380, calcium: 55 },
  },
  {
    id: "salmon_rice_plate",
    nameAr: "طبق سلمون بالأرز",
    nameEn: "Salmon Rice Plate",
    nameDe: "Lachs-Reis-Teller",
    nameRu: "Тарелка с лососем и рисом",
    namePt: "Prato de salmão com arroz",
    category: "seafood",
    requiredIngredients: ["salmon", "rice", "lemon", "olive_oil"],
    optionalIngredients: ["garlic", "broccoli", "pepper"],
    ingredientQuantities: { salmon: { amount: 500, unit: "جرام" }, rice: { amount: 2, unit: "كوب" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نتبل السلمون بالليمون وزيت الزيتون والثوم", "نسلق الأرز في ماء مملح حتى ينضج", "نشوي السلمون في الفرن ١٥ دقيقة على ٢٠٠ درجة", "نقدم السلمون فوق الأرز مع الخضار", "نعصر الليمون فوق الطبق"],
    stepsEn: ["Marinate salmon with lemon, olive oil, and garlic", "Boil rice in salted water until cooked", "Bake salmon in oven 15 minutes at 200°C", "Serve salmon over rice with vegetables", "Squeeze lemon over the dish"],
    ovenTempAr: "فرن ساخن (٢٠٠°م) لمدة ١٥ دقيقة - يمكن شوي السلمون على نار متوسطة",
    ovenTempEn: "Hot oven (200°C) for 15 minutes - salmon can also be grilled on medium heat",
    tipsAr: ["تبل السلمون بالليمون وزيت الزيتون والثون وملعقة صغيرة من الشمر المطحون", "لا تتبل السلمون بالملح قبل الطهي بوقت طويل لتفادي جفافه", "ضع السلمون في فرن محمى مسبقاً على ورق زبدة لمنع الالتصاق", "اشوي السلمون جلدًا لأسفل لمدة ١٥ دقيقة دون تقليبه للحصول على قشرة مقرمشة", "أضف ملعقة صغيرة من العسل أو صلصة الصويا للتحلية واللمعان"],
    tipsEn: ["Marinate salmon with lemon, olive oil, garlic, and a teaspoon of ground fennel", "Do not salt salmon long before cooking to avoid drying it out", "Place salmon in preheated oven on parchment paper to prevent sticking", "Bake salmon skin-side down for 15 minutes without flipping for crispy skin", "Add a teaspoon of honey or soy sauce for glaze and shine"],
    servingAr: ["يقدم السلمون فوق الأرز الأبيض مع البروكلي المطهو على البخار", "اعصر الليمون الطازج فوق السلمون قبل التقديم", "زيّن بشرائح الليمون والبقدونس المفروم", "يقدم مع صلصة الطحينة أو صلصة الزبادي بالشبت"],
    servingEn: ["Serve salmon over white rice with steamed broccoli", "Squeeze fresh lemon over salmon before serving", "Garnish with lemon slices and chopped parsley", "Serve with tahini sauce or dill yogurt sauce"],
    time: 30,
    servings: 3,
    image: "images/recipes/pexels-1640774-800.jpeg",
    nutrition: { calories: 420, protein: 32, carbs: 48, fat: 12, fiber: 2, sodium: 320, calcium: 50 },
  },
  {
    id: "shrimp_curry",
    nameAr: "كاري الروبيان",
    nameEn: "Shrimp Curry",
    nameDe: "Garnelen-Curry",
    nameRu: "Карри с креветками",
    namePt: "Caril de camarão",
    category: "seafood",
    requiredIngredients: ["shrimp", "onion", "garlic", "tomato"],
    optionalIngredients: ["pepper", "olive_oil", "lemon", "coconut_water"],
    ingredientQuantities: { shrimp: { amount: 500, unit: "جرام" }, onion: { amount: 2, unit: "حبة" }, garlic: { amount: 4, unit: "فص" }, tomato: { amount: 3, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نحمر البصل والثوم في زيت الزيتون", "نضيف الطماطم والبهارات والكاري ونطهي ٥ دقائق", "نضيف الروبيان ونطهيه ٥ دقائق حتى ينضج", "نضيف جوز الهند أو الماء للحصول على صلصة كريمية", "نقدم مع الأرز الأبيض"],
    stepsEn: ["Sauté onion and garlic in olive oil", "Add tomatoes, spices, and curry, cook 5 minutes", "Add shrimp and cook 5 minutes until done", "Add coconut or water for creamy sauce", "Serve with white rice"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لطهي صلصة الكاري",
    ovenTempEn: "Medium heat (180°C) on stovetop for cooking curry sauce",
    tipsAr: ["أضف ملعقة كبيرة من مسحوق الكاري وملعقة صغيرة من الكركم والكمون والكزبرة", "حمر البصل حتى يصبح شفافياً قبل إضافة الثوم لتفادي احتراقه", "أضف الطماطم المفرومة واتركها تتكرمل قبل إضافة الروبيان", "أضف ماء جوز الهند أو الكريمة لتنعيم الصلصة وتقليل الحرارة", "أضف الروبيان في النهاية واطهيه ٥ دقائق فقط لتفادي المطاطية"],
    tipsEn: ["Add a tablespoon of curry powder and a teaspoon of turmeric, cumin, and coriander", "Sauté onion until translucent before adding garlic to avoid burning", "Add chopped tomatoes and let them caramelize before adding shrimp", "Add coconut water or cream to smooth the sauce and reduce heat", "Add shrimp at the end and cook only 5 minutes to avoid rubberiness"],
    servingAr: ["يقدم ساخناً فوق الأرز الأبيض أو البسمتي", "رش الكزبرة الخضراء المفرومة فوق الكاري", "يقدم مع خبز النان أو الخبز العربي لامتصاص الصلصة", "أضف شرائح الفلفل الحار الطازج للحرارة الإضافية"],
    servingEn: ["Serve hot over white or basmati rice", "Sprinkle chopped fresh coriander over curry", "Serve with naan or Arabic bread to absorb the sauce", "Add fresh chili slices for extra heat"],
    time: 25,
    servings: 3,
    image: "images/recipes/pexels-2474661-800.jpeg",
    nutrition: { calories: 260, protein: 24, carbs: 12, fat: 12, fiber: 2, sodium: 540, calcium: 70 },
  },
  {
    id: "fried_fish_plate",
    nameAr: "طبق سمك مقلي",
    nameEn: "Fried Fish Plate",
    nameDe: "Frittierter Fischteller",
    nameRu: "Тарелка с жареной рыбой",
    namePt: "Prato de peixe frito",
    category: "seafood",
    requiredIngredients: ["fish", "flour", "garlic", "lemon"],
    optionalIngredients: ["olive_oil", "pepper", "parsley"],
    ingredientQuantities: { fish: { amount: 800, unit: "جرام" }, flour: { amount: 1, unit: "كوب" }, garlic: { amount: 3, unit: "فص" }, lemon: { amount: 2, unit: "حبة" }, olive_oil: { amount: 4, unit: "ملعقة ك." } },
    stepsAr: ["ننظف السمك ونتبله بالثوم والليمون والبهارات", "نغطيه بالدقيق من الجهتين", "نسخن الزيت ونقلي السمك ٤ دقائق من كل جانب", "نصفيه على ورق ماص للزيت", "نقدم مع البطاطس المقلية والسلطة"],
    stepsEn: ["Clean fish and marinate with garlic, lemon, and spices", "Coat with flour on both sides", "Heat oil and fry fish 4 minutes each side", "Drain on paper towel", "Serve with fries and salad"],
    ovenTempAr: "زيت ساخن (١٨٠°م) على نار عالية - ٤ دقائق من كل جانب",
    ovenTempEn: "Hot oil (180°C) on high heat - 4 minutes per side",
    tipsAr: ["تبل السمك بالثون والليمون والكمون والكزبرة والفلفل الأسود والملح لمدة ١٥ دقيقة", "جفف السمك بورق ماص قبل تغطيته بالدقيق لتفادي تطاير الزيت", "اغمس السمك في الدقيق المتبل بالملح والفلفل والكمون واهز الفائض", "سخن الزيت جيداً قبل القلي لتفادي التصاق السمك", "اقلي السمك ٤ دقائق من كل جانب حتى يصبح ذهبياً ومقرمشاً"],
    tipsEn: ["Marinate fish with garlic, lemon, cumin, coriander, black pepper, and salt for 15 minutes", "Pat fish dry with paper towel before coating with flour to avoid oil splattering", "Dredge fish in seasoned flour with salt, pepper, and cumin and shake off excess", "Heat oil thoroughly before frying to prevent fish from sticking", "Fry fish 4 minutes per side until golden and crispy"],
    servingAr: ["يقدم ساخناً مع البطاطس المقلية والسلطة الخضراء", "اعصر الليمون الطازج فوق السمك قبل التقديم", "يقدم مع صلصة الطحينة أو صلصة الثوم", "رش البقدونس المفروم وشرائح الليمون للزينة"],
    servingEn: ["Serve hot with fries and green salad", "Squeeze fresh lemon over fish before serving", "Serve with tahini sauce or garlic sauce", "Sprinkle chopped parsley and lemon slices for garnish"],
    time: 25,
    servings: 4,
    image: "images/recipes/pexels-263119-800.jpeg",
    nutrition: { calories: 380, protein: 32, carbs: 18, fat: 18, fiber: 1, sodium: 460, calcium: 45 },
  },
  // SOUPS
  {
    id: "lentil_soup",
    nameAr: "شوربة العدس",
    nameEn: "Lentil Soup",
    nameDe: "Linsensuppe",
    nameRu: "Чечевичный суп",
    namePt: "Sopa de lentilhas",
    category: "soups",
    requiredIngredients: ["lentils", "onion", "carrot"],
    optionalIngredients: ["garlic", "potato", "olive_oil", "lemon"],
    ingredientQuantities: { lentils: { amount: 2, unit: "كوب" }, onion: { amount: 2, unit: "حبة" }, garlic: { amount: 3, unit: "فص" }, carrot: { amount: 2, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, lemon: { amount: 1, unit: "حبة" } },
    stepsAr: ["نغسل العدس ونضعه في قدر مع الماء", "نضيف البصل والجزر المقطع والثوم", "نطهي على نار متوسطة لمدة ٣٠ دقيقة", "نخلط الشوربة بالخلاط حتى تصبح ناعمة", "نضيف الليمون والتوابل ونقدم ساخنة"],
    stepsEn: ["Wash lentils and place in pot with water", "Add chopped onion, carrot, and garlic", "Cook on medium heat for 30 minutes", "Blend soup until smooth", "Add lemon and spices and serve hot"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لمدة ٣٠ دقيقة",
    ovenTempEn: "Medium heat (180°C) on stovetop for 30 minutes",
    tipsAr: ["اغسل العدس جيداً ونقعه ١٥ دقيقة قبل الطهي لتقليل وقت الطهي", "أضف ملعقة صغيرة من الكمون والكزبرة المطحونة والكركم للنكهة", "حمر البصل في زيت الزيتون قبل إضافته للعدس لنكهة أعمق", "أضف عصير الليمون في النهاية بعد الطهي للحفاظ على فيتامين C", "اخلط الشوربة بالخلاط اليدوي داخل القدر لقوام ناعم"],
    tipsEn: ["Wash lentils well and soak 15 minutes before cooking to reduce cooking time", "Add a teaspoon of cumin, ground coriander, and turmeric for flavor", "Sauté onion in olive oil before adding to lentils for deeper flavor", "Add lemon juice at the end after cooking to preserve vitamin C", "Blend soup with immersion blender inside the pot for smooth texture"],
    servingAr: ["يقدم ساخناً في أطباق شوربة عميقة", "اعصر الليمون الطازج فوق كل طبق عند التقديم", "رش الكزبرة الخضراء المفرومة والبقدونس", "يقدم مع الخبز المحمص أو خبز الثوم"],
    servingEn: ["Serve hot in deep soup bowls", "Squeeze fresh lemon over each bowl when serving", "Sprinkle chopped fresh coriander and parsley", "Serve with toasted bread or garlic bread"],
    time: 40,
    servings: 4,
    image: "images/recipes/pexels-539451-800.jpeg",
    nutrition: { calories: 180, protein: 11, carbs: 28, fat: 3, fiber: 8, sodium: 310, calcium: 35 },
  },
  {
    id: "tomato_soup",
    nameAr: "شوربة الطماطم",
    nameEn: "Tomato Soup",
    nameDe: "Tomatensuppe",
    nameRu: "Томатный суп",
    namePt: "Sopa de tomate",
    category: "soups",
    requiredIngredients: ["tomato", "onion", "garlic"],
    optionalIngredients: ["carrot", "butter", "milk"],
    ingredientQuantities: { tomato: { amount: 600, unit: "جرام" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 3, unit: "فص" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نسلق الطماطم مع البصل والثوم لمدة ٢٠ دقيقة", "نخلط المكونات في الخلاط", "نعيدها للقدر ونضيف الحليب", "نتبل بالملح والفلفل والريحان", "نقدم مع خبز محمص"],
    stepsEn: ["Boil tomatoes with onion and garlic for 20 minutes", "Blend all ingredients", "Return to pot and add milk", "Season with salt, pepper, and basil", "Serve with toasted bread"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لمدة ٢٠ دقيقة",
    ovenTempEn: "Medium heat (180°C) on stovetop for 20 minutes",
    tipsAr: ["قشر الطماطم بعد سلقها في ماء ساخن ٣٠ ثانية لنزع القشرة بسهولة", "أضف ملعقة صغيرة من الريحان المجفف والأوريغانو للنكهة الإيطالية", "حمر البصل في الزبدة بدلاً من الزيت لنكهة أغنى", "أضف الحليب أو الكريمة تدريجياً مع التحريك لتفادي التكتل", "تبل بالملح والفلفل الأسود وجوزة الطيب"],
    tipsEn: ["Peel tomatoes after blanching in hot water for 30 seconds for easy peeling", "Add a teaspoon of dried basil and oregano for Italian flavor", "Sauté onion in butter instead of oil for richer flavor", "Add milk or cream gradually while stirring to avoid clumping", "Season with salt, black pepper, and nutmeg"],
    servingAr: ["يقدم ساخناً مع خبز محمص مدهون بالزبدة والثوم", "رش أوراق الريحان الطازج والجبن البارميزان", "يقدم مع شطيرة الجبن المشوية أو السلطة الخضراء"],
    servingEn: ["Serve hot with toasted bread spread with butter and garlic", "Sprinkle fresh basil leaves and parmesan cheese", "Serve with grilled cheese sandwich or green salad"],
    time: 30,
    servings: 4,
    image: "images/recipes/pexels-3832344-800.jpeg",
    nutrition: { calories: 140, protein: 5, carbs: 18, fat: 5, fiber: 3, sodium: 290, calcium: 60 },
  },
  {
    id: "chicken_soup",
    nameAr: "شوربة الدجاج",
    nameEn: "Chicken Soup",
    nameDe: "Hühnersuppe",
    nameRu: "Куриный суп",
    namePt: "Sopa de frango",
    category: "soups",
    requiredIngredients: ["chicken", "carrot", "onion"],
    optionalIngredients: ["potato", "garlic", "rice"],
    ingredientQuantities: { chicken: { amount: 700, unit: "جرام" }, carrot: { amount: 3, unit: "حبة" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 4, unit: "فص" } },
    stepsAr: ["نضع الدجاج في قدر كبير ونغطيه بالماء", "نضيف الجزر والبصل والثوم", "نطهي على نار هادئة لمدة ٤٥ دقيقة", "نزيل الدجاج ونقطعه ونعيده للقدر", "نضيف الأرز أو المعكرونة ونكمل الطهي"],
    stepsEn: ["Place chicken in large pot and cover with water", "Add carrots, onion, and garlic", "Cook on low heat for 45 minutes", "Remove chicken, shred, and return to pot", "Add rice or pasta and continue cooking"],
    ovenTempAr: "نار هادئة (١٦٠°م) على الموقد لمدة ٤٥ دقيقة",
    ovenTempEn: "Low heat (160°C) on stovetop for 45 minutes",
    tipsAr: ["ازيل الرغوة المتراكمة على السطح أثناء الغليان لمرق صاف", "أضف ورق الغار والهيل والقرفة والبصل الصحيح للمرق للنكهة", "تبل الدجاج بالملح والفلفل الأسود والكزبرة قبل إضافته للمرق", "أضف الأرز أو المعكرونة بعد نضج الدجاج لتفادي طراوة الدجاج", "أضف البقدونس المفروم وعصير الليمون قبل التقديم"],
    tipsEn: ["Skim foam from surface during boiling for clear broth", "Add bay leaves, cardamom, cinnamon, and whole onion to broth for flavor", "Season chicken with salt, black pepper, and coriander before adding to broth", "Add rice or pasta after chicken is cooked to avoid overcooking chicken", "Add chopped parsley and lemon juice before serving"],
    servingAr: ["يقدم ساخناً في أطباق عميقة مع الدجاج المقطع", "رش البقدونس المفروم وعصر الليمون الطازج", "يقدم مع الخبز العربي أو الكروتون", "يقدم مع الأرز الأبيض أو المعكرونة"],
    servingEn: ["Serve hot in deep bowls with shredded chicken", "Sprinkle chopped parsley and squeeze fresh lemon", "Serve with Arabic bread or croutons", "Serve with white rice or pasta"],
    time: 60,
    servings: 6,
    image: "/images/chicken-soup.png",
    nutrition: { calories: 220, protein: 22, carbs: 20, fat: 6, fiber: 3, sodium: 480, calcium: 40 },
  },
  {
    id: "vegetable_soup",
    nameAr: "شوربة الخضار",
    nameEn: "Vegetable Soup",
    nameDe: "Gemüsesuppe",
    nameRu: "Овощной суп",
    namePt: "Sopa de legumes",
    category: "soups",
    requiredIngredients: ["carrot", "potato", "onion", "tomato"],
    optionalIngredients: ["garlic", "olive_oil", "zucchini", "celery"],
    ingredientQuantities: { carrot: { amount: 3, unit: "حبة" }, potato: { amount: 2, unit: "حبة" }, onion: { amount: 1, unit: "حبة" }, tomato: { amount: 2, unit: "حبة" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نقطع جميع الخضار إلى مكعبات متساوية", "نسخن زيت الزيتون في قدر ونحمر البصل", "نضيف باقي الخضار ونقلبها لمدة دقيقتين", "نغطي بالماء ونطهي على نار متوسطة ٣٠ دقيقة", "نتبل بالملح والفلفل والكزبرة ونقدم ساخنة"],
    stepsEn: ["Chop all vegetables into equal cubes", "Heat olive oil and sauté onion until golden", "Add remaining vegetables and stir for 2 minutes", "Cover with water and cook on medium heat 30 minutes", "Season with salt, pepper, and coriander and serve hot"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لمدة ٣٠ دقيقة",
    ovenTempEn: "Medium heat (180°C) on stovetop for 30 minutes",
    tipsAr: ["قطع جميع الخضار إلى مكعبات متساوية الحجم لنضج متساو", "حمر البصل في زيت الزيتون حتى يصبح شفافياً قبل إضافة باقي الخضار", "أضف ملعقة صغيرة من الكزبرة المطحونة والكمون للنكهة", "أضف مرق الخضار بدلاً من الماء لنكهة أغنى", "لا تفرط في طهي الخضار للحفاظ على قيمتها الغذائية"],
    tipsEn: ["Chop all vegetables into equal-sized cubes for even cooking", "Sauté onion in olive oil until translucent before adding other vegetables", "Add a teaspoon of ground coriander and cumin for flavor", "Use vegetable broth instead of water for richer flavor", "Do not overcook vegetables to preserve their nutritional value"],
    servingAr: ["يقدم ساخناً في أطباق شوربة عميقة", "رش البقدونس المفروم وزيت الزيتون البكر", "يقدم مع الخبز المحمص أو الكروتون", "أضف ملعقة من الكريمة أو الجبن المبشور للزينة"],
    servingEn: ["Serve hot in deep soup bowls", "Sprinkle chopped parsley and extra virgin olive oil", "Serve with toasted bread or croutons", "Add a spoonful of cream or grated cheese for garnish"],
    time: 35,
    servings: 4,
    image: "/images/vegetable-soup.png",
    nutrition: { calories: 100, protein: 4, carbs: 18, fat: 2, fiber: 4, sodium: 320, calcium: 45 },
  },
  {
    id: "mushroom_soup",
    nameAr: "شوربة الفطر",
    nameEn: "Mushroom Soup",
    nameDe: "Pilzsuppe",
    nameRu: "Грибной суп",
    namePt: "Sopa de cogumelos",
    category: "soups",
    requiredIngredients: ["mushroom", "onion", "garlic", "butter"],
    optionalIngredients: ["milk", "olive_oil", "thyme"],
    ingredientQuantities: { mushroom: { amount: 400, unit: "جرام" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 3, unit: "فص" }, butter: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نذيب الزبدة في قدر ونحمر البصل والثوم", "نضيف الفطر المقطع ونطهيه حتى يذبل", "نضيف الماء أو المرق ونطهي ١٥ دقيقة", "نخلط نصف الشوربة بالخلاط للحصول على قوام كريمي", "نضيف الحليب ونتبل ونقدم مع الخبز المحمص"],
    stepsEn: ["Melt butter and sauté onion and garlic until soft", "Add sliced mushrooms and cook until wilted", "Add water or broth and cook 15 minutes", "Blend half the soup for a creamy texture", "Add milk, season, and serve with toasted bread"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لمدة ١٥ دقيقة",
    ovenTempEn: "Medium heat (180°C) on stovetop for 15 minutes",
    tipsAr: ["حمر الفطر في الزبدة حتى يصبح ذهبياً لنكهة أعمق", "أضف ملعقة صغيرة من الزعتر المجفف والثوم المفروم", "اخلط نصف الشوربة فقط للحفاظ على قطع الفطر", "أضف الحليب أو الكريمة تدريجياً مع التحريك المستمر", "تبل بالملح والفلفل الأبيض وجوزة الطيب"],
    tipsEn: ["Sauté mushrooms in butter until golden for deeper flavor", "Add a teaspoon of dried thyme and minced garlic", "Blend only half the soup to keep mushroom pieces", "Add milk or cream gradually with continuous stirring", "Season with salt, white pepper, and nutmeg"],
    servingAr: ["يقدم ساخناً مع خبز محمص مدهون بالثوم والزبدة", "رش أوراق الزعتر الطازج والفطر المقلب", "أضف ملعقة كريمة طازجة وجبن البارميزان للزينة"],
    servingEn: ["Serve hot with toasted bread spread with garlic and butter", "Sprinkle fresh thyme leaves and sautéed mushrooms", "Add a spoonful of fresh cream and parmesan for garnish"],
    time: 25,
    servings: 4,
    image: "/images/mushroom-soup.png",
    nutrition: { calories: 130, protein: 4, carbs: 14, fat: 7, fiber: 2, sodium: 380, calcium: 80 },
  },
  {
    id: "potato_soup",
    nameAr: "شوربة البطاطس",
    nameEn: "Potato Soup",
    nameDe: "Kartoffelsuppe",
    nameRu: "Картофельный суп",
    namePt: "Sopa de batata",
    category: "soups",
    requiredIngredients: ["potato", "onion", "garlic"],
    optionalIngredients: ["butter", "milk", "carrot", "olive_oil"],
    ingredientQuantities: { potato: { amount: 500, unit: "جرام" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 3, unit: "فص" }, butter: { amount: 1, unit: "ملعقة ك." } },
    stepsAr: ["نقشر البطاطس ونقطعها ونضعها في القدر مع البصل والثوم", "نغطي بالماء ونطهي حتى تطرى البطاطس ٢٥ دقيقة", "نهرس البطاطس أو نخلطها في الخلاط", "نضيف الحليب والزبدة للحصول على قوام ناعم", "نتبل بالملح والفلفل الأبيض ونقدم ساخنة"],
    stepsEn: ["Peel and chop potatoes, place in pot with onion and garlic", "Cover with water and cook until potatoes are tender, 25 minutes", "Mash potatoes or blend", "Add milk and butter for smooth texture", "Season with salt and white pepper and serve hot"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لمدة ٢٥ دقيقة",
    ovenTempEn: "Medium heat (180°C) on stovetop for 25 minutes",
    tipsAr: ["استخدم بطاطس نشوية لقوام كريمي أفضل", "حمر البصل في الزبدة قبل إضافة البطاطس لنكهة أغنى", "أضف الحليب الدافئ تدريجياً مع التحريك لتفادي التكتل", "تبل بالملح والفلفل الأبيض وجوزة الطيب", "اخلط الشوربة بالخلاط اليدوي لقوام ناعم تماماً"],
    tipsEn: ["Use starchy potatoes for better creamy texture", "Sauté onion in butter before adding potatoes for richer flavor", "Add warm milk gradually while stirring to avoid clumping", "Season with salt, white pepper, and nutmeg", "Blend soup with immersion blender for completely smooth texture"],
    servingAr: ["يقدم ساخناً مع خبز محمص ورشة من البقدونس المفروم", "أضف ملعقة كريمة وجبن الشيدر المبشور للزينة", "رش زيت الزيتون البكر والفلفل الأسود الطازج"],
    servingEn: ["Serve hot with toasted bread and a sprinkle of chopped parsley", "Add a spoonful of cream and grated cheddar cheese for garnish", "Drizzle extra virgin olive oil and fresh black pepper"],
    time: 35,
    servings: 4,
    image: "/images/potato-soup.png",
    nutrition: { calories: 200, protein: 5, carbs: 32, fat: 6, fiber: 3, sodium: 360, calcium: 70 },
  },
  {
    id: "harira_soup",
    nameAr: "شوربة الحريرة",
    nameEn: "Harira Soup",
    nameDe: "Harira Suppe",
    nameRu: "Суп Харира",
    namePt: "Sopa Harira",
    category: "soups",
    requiredIngredients: ["lentils", "tomato", "onion", "garlic"],
    optionalIngredients: ["rice", "lemon", "coriander", "olive_oil"],
    ingredientQuantities: { lentils: { amount: 1, unit: "كوب" }, tomato: { amount: 3, unit: "حبة" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 4, unit: "فص" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نحمر البصل والثوم في زيت الزيتون", "نضيف الطماطم المبشورة ونطهي ١٠ دقائق", "نضيف العدس والماء ونطهي ٣٠ دقيقة", "نضيف الأرز والتوابل (كركم، كمون، كزبرة)", "نضيف عصير الليمون ونقدم مع التمر في رمضان"],
    stepsEn: ["Sauté onion and garlic in olive oil", "Add grated tomatoes and cook 10 minutes", "Add lentils and water, cook 30 minutes", "Add rice and spices (turmeric, cumin, coriander)", "Add lemon juice and serve traditionally with dates"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لمدة ٣٠ دقيقة بعد غليان المرق",
    ovenTempEn: "Medium heat (180°C) on stovetop for 30 minutes after broth boils",
    tipsAr: ["أضف ملعقة كبيرة من دبس الطماطم للون ونكهة أعمق", "تبل بالكركم والكمون والكزبرة والزعفران والقرفة", "أضف ملعقة صغيرة من خل التمر أو عصير الليمون للحموضة", "أضف الدقيق أو البيض في النهاية لتكثيف الشوربة", "انقع العدس قبل الطهي بساعة لتقليل وقت الطهي"],
    tipsEn: ["Add a tablespoon of tomato paste for deeper color and flavor", "Season with turmeric, cumin, coriander, saffron, and cinnamon", "Add a teaspoon of date vinegar or lemon juice for tanginess", "Add flour or egg at the end to thicken the soup", "Soak lentils an hour before cooking to reduce cooking time"],
    servingAr: ["يقدم ساخناً مع التمر والحليب في رمضان", "رش الكزبرة الخضراء المفرومة وعصر الليمون", "يقدم مع الخبز العربي والزيتون", "أضف ملعقة من الزبادي أو البيض المسلوق للزينة"],
    servingEn: ["Serve hot with dates and milk during Ramadan", "Sprinkle chopped fresh coriander and squeeze lemon", "Serve with Arabic bread and olives", "Add a spoonful of yogurt or boiled egg for garnish"],
    time: 50,
    servings: 6,
    image: "images/recipes/pexels-33434038-800.jpeg",
    nutrition: { calories: 210, protein: 11, carbs: 30, fat: 5, fiber: 6, sodium: 420, calcium: 55 },
  },
  {
    id: "bean_soup",
    nameAr: "شوربة الفاصولياء",
    nameEn: "Bean Soup",
    nameDe: "Bohnensuppe",
    nameRu: "Фасолевый суп",
    namePt: "Sopa de feijão",
    category: "soups",
    requiredIngredients: ["white_beans", "tomato", "onion", "garlic"],
    optionalIngredients: ["carrot", "olive_oil", "lemon", "spinach"],
    ingredientQuantities: { white_beans: { amount: 400, unit: "جرام" }, tomato: { amount: 2, unit: "حبة" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 4, unit: "فص" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نسلق الفاصولياء البيضاء مسبقاً أو نستخدم المعلبة", "نحمر البصل والثوم في زيت الزيتون", "نضيف الطماطم ونطهي ٥ دقائق", "نضيف الفاصولياء والماء ونطهي ٢٠ دقيقة", "نتبل ونضيف عصير الليمون ونقدم ساخنة"],
    stepsEn: ["Pre-boil white beans or use canned", "Sauté onion and garlic in olive oil", "Add tomatoes and cook 5 minutes", "Add beans and water, cook 20 minutes", "Season, add lemon juice and serve hot"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لمدة ٢٠ دقيقة",
    ovenTempEn: "Medium heat (180°C) on stovetop for 20 minutes",
    tipsAr: ["انقع الفاصولياء البيضاء ليلة كاملة قبل الطهي لتقليل الغازات", "أضف ملعقة صغيرة من البيكنج صودا أثناء النقع لتقليل الانتفاخ", "حمر البصل والثوم في زيت الزيتون قبل إضافة الطماطم", "تبل بالكمون والكزبرة والكركم والفلفل الأحمر", "أضف عصير الليمون في النهاية بعد الطهي"],
    tipsEn: ["Soak white beans overnight before cooking to reduce gas", "Add a teaspoon of baking soda during soaking to reduce bloating", "Sauté onion and garlic in olive oil before adding tomatoes", "Season with cumin, coriander, turmeric, and paprika", "Add lemon juice at the end after cooking"],
    servingAr: ["يقدم ساخناً في أطباق عميقة", "رش الكزبرة الخضراء المفرومة وزيت الزيتون", "يقدم مع الخبز العربي والليمون", "أضف ملعقة من الزبادي للزينة"],
    servingEn: ["Serve hot in deep bowls", "Sprinkle chopped fresh coriander and olive oil", "Serve with Arabic bread and lemon", "Add a spoonful of yogurt for garnish"],
    time: 40,
    servings: 4,
    image: "images/recipes/pexels-19870149-800.jpeg",
    nutrition: { calories: 220, protein: 13, carbs: 36, fat: 4, fiber: 9, sodium: 360, calcium: 80 },
  },
  {
    id: "meat_broth_soup",
    nameAr: "شوربة اللحم",
    nameEn: "Meat Broth Soup",
    nameDe: "Fleischsuppe",
    nameRu: "Мясной суп",
    namePt: "Sopa de carne",
    category: "soups",
    requiredIngredients: ["beef", "onion", "carrot", "potato"],
    optionalIngredients: ["garlic", "tomato", "olive_oil", "celery"],
    ingredientQuantities: { beef: { amount: 500, unit: "جرام" }, onion: { amount: 2, unit: "حبة" }, carrot: { amount: 3, unit: "حبة" }, potato: { amount: 2, unit: "حبة" } },
    stepsAr: ["نضع اللحم في قدر كبير مع الماء ونغلي ونزيل الرغوة", "نضيف البصل والجزر والثوم ونطهي ٦٠ دقيقة", "نضيف البطاطس والطماطم ونكمل الطهي ٢٠ دقيقة", "نزيل اللحم ونقطعه إلى قطع صغيرة", "نعيد اللحم للمرق ونتبل ونقدم ساخنة"],
    stepsEn: ["Place meat in large pot with water, boil and skim foam", "Add onion, carrot, garlic and cook 60 minutes", "Add potatoes and tomatoes, cook another 20 minutes", "Remove meat and cut into small pieces", "Return meat to broth, season and serve hot"],
    ovenTempAr: "نار هادئة (١٦٠°م) على الموقد لمدة ٦٠ دقيقة بعد الغليان",
    ovenTempEn: "Low heat (160°C) on stovetop for 60 minutes after boiling",
    tipsAr: ["ازيل الرغوة من سطح المرق أثناء الغليان لمرق صاف", "أضف ورق الغار والهيل والقرفة والبصل الصحيح للمرق", "تبل اللحم بالملح والفلفل الأسود والكمون قبل الطهي", "اطبخ اللحم على نار هادئة لمدة طويلة لطراوة", "أضف البطاطس في النصف الثاني من الطهي لتفادي تفتتها"],
    tipsEn: ["Skim foam from broth surface during boiling for clear broth", "Add bay leaves, cardamom, cinnamon, and whole onion to broth", "Season meat with salt, black pepper, and cumin before cooking", "Cook meat on low heat for a long time for tenderness", "Add potatoes in the second half of cooking to avoid falling apart"],
    servingAr: ["يقدم ساخناً في أطباق عميقة مع اللحم والمرق", "رش البقدونس المفروم وعصر الليمون الطازج", "يقدم مع الخبز العربي والأرز الأبيض", "أضف ملعقة من السمن أو الزبدة للمرق للنكهة"],
    servingEn: ["Serve hot in deep bowls with meat and broth", "Sprinkle chopped parsley and squeeze fresh lemon", "Serve with Arabic bread and white rice", "Add a spoonful of ghee or butter to broth for flavor"],
    time: 90,
    servings: 6,
    image: "images/recipes/pexels-18852567-800.jpeg",
    nutrition: { calories: 220, protein: 18, carbs: 12, fat: 10, fiber: 2, sodium: 520, calcium: 35 },
  },
  {
    id: "cream_soup",
    nameAr: "شوربة الكريمة",
    nameEn: "Cream Soup",
    nameDe: "Cremesuppe",
    nameRu: "Крем-суп",
    namePt: "Sopa creme",
    category: "soups",
    requiredIngredients: ["potato", "onion", "garlic", "milk"],
    optionalIngredients: ["butter", "carrot", "olive_oil", "cream"],
    ingredientQuantities: { potato: { amount: 400, unit: "جرام" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 2, unit: "فص" }, milk: { amount: 200, unit: "مل" }, butter: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نحمر البصل والثوم في الزبدة على نار متوسطة", "نضيف البطاطس المقطعة ونطهي مع الماء ٢٠ دقيقة", "نخلط المحتويات في الخلاط حتى تصبح ناعمة تماماً", "نعيد الشوربة للقدر ونضيف الحليب أو الكريمة", "نتبل بالملح والفلفل الأبيض والجوزة ونقدم ساخنة"],
    stepsEn: ["Sauté onion and garlic in butter over medium heat", "Add diced potato and cook with water 20 minutes", "Blend everything until completely smooth", "Return to pot and add milk or cream", "Season with salt, white pepper and nutmeg, serve hot"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد لمدة ٢٠ دقيقة",
    ovenTempEn: "Medium heat (180°C) on stovetop for 20 minutes",
    tipsAr: ["حمر البصل والثوم في الزبدة على نار هادئة لتفادي احتراقها", "أضف البطاطس المقطعة وغطها بالماء واتركها تنضج تماماً", "اخلط الشوربة بالخلاط الكهربائي حتى تصبح ناعمة تماماً", "أضف الحليب أو الكريمة الدافئ تدريجياً مع التحريك", "تبل بالملح والفلفل الأبيض وجوزة الطيب"],
    tipsEn: ["Sauté onion and garlic in butter on low heat to avoid burning", "Add diced potatoes, cover with water, and let cook completely", "Blend soup with electric blender until completely smooth", "Add warm milk or cream gradually while stirring", "Season with salt, white pepper, and nutmeg"],
    servingAr: ["يقدم ساخناً في أطباق عميقة مع الكروتون أو الخبز المحمص", "رش البقدونس المفروم وزيت الزيتون البكر", "أضف ملعقة كريمة طازجة وجبن البارميزان للزينة"],
    servingEn: ["Serve hot in deep bowls with croutons or toasted bread", "Sprinkle chopped parsley and extra virgin olive oil", "Add a spoonful of fresh cream and parmesan cheese for garnish"],
    time: 30,
    servings: 4,
    image: "images/recipes/pexels-7363671-800.jpeg",
    nutrition: { calories: 250, protein: 6, carbs: 28, fat: 13, fiber: 2, sodium: 380, calcium: 120 },
  },
  // SALADS
  {
    id: "fattoush",
    nameAr: "فتوش",
    nameEn: "Fattoush Salad",
    nameDe: "Fattoush Salat",
    nameRu: "Салат Фаттуш",
    namePt: "Salada Fattoush",
    category: "salads",
    requiredIngredients: ["tomato", "cucumber", "bread", "lemon"],
    optionalIngredients: ["onion", "pepper", "olive_oil"],
    ingredientQuantities: { tomato: { amount: 3, unit: "حبة" }, cucumber: { amount: 2, unit: "حبة" }, bread: { amount: 2, unit: "شريحة" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, onion: { amount: 1, unit: "حبة" } },
    stepsAr: ["نقطع الخبز إلى قطع صغيرة ونحمصه في الفرن", "نقطع الطماطم والخيار والبصل", "نعد الصلصة من الليمون وزيت الزيتون والثوم", "نخلط الخضروات مع الخبز المحمص", "نسكب الصلصة ونقدم مباشرة"],
    stepsEn: ["Cut bread into small pieces and toast in oven", "Chop tomatoes, cucumber, and onion", "Prepare dressing from lemon, olive oil, and garlic", "Mix vegetables with toasted bread", "Pour dressing and serve immediately"],
    time: 15,
    servings: 4,
    image: "images/recipes/pexels-1211887-800.jpeg",
    nutrition: { calories: 160, protein: 5, carbs: 22, fat: 7, fiber: 4, sodium: 280, calcium: 65 },
  },
  {
    id: "tabbouleh",
    nameAr: "تبولة",
    nameEn: "Tabbouleh",
    nameDe: "Taboulé",
    nameRu: "Табуле",
    namePt: "Tabule",
    category: "salads",
    requiredIngredients: ["tomato", "lemon", "olive_oil"],
    optionalIngredients: ["onion", "cucumber"],
    ingredientQuantities: { tomato: { amount: 3, unit: "حبة" }, lemon: { amount: 2, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, onion: { amount: 1, unit: "حبة" } },
    stepsAr: ["نفرم البقدونس والنعناع فرماً ناعماً", "نقطع الطماطم والبصل الأخضر قطعاً صغيرة", "نضيف البرغل المنقوع والمصفى", "نتبل بزيت الزيتون وعصير الليمون والملح", "نخلط جيداً ونبرد قبل التقديم"],
    stepsEn: ["Finely chop parsley and mint", "Dice tomatoes and green onions small", "Add soaked and drained bulgur wheat", "Dress with olive oil, lemon juice, and salt", "Mix well and chill before serving"],
    time: 20,
    servings: 4,
    image: "images/recipes/pexels-10311638-800.jpeg",
    nutrition: { calories: 120, protein: 4, carbs: 16, fat: 6, fiber: 4, sodium: 180, calcium: 80 },
  },
  {
    id: "arabic_salad",
    nameAr: "سلطة عربية",
    nameEn: "Arabic Salad",
    nameDe: "Arabischer Salat",
    nameRu: "Арабский салат",
    namePt: "Salada Árabe",
    category: "salads",
    requiredIngredients: ["tomato", "cucumber", "onion", "lemon"],
    optionalIngredients: ["pepper", "olive_oil"],
    ingredientQuantities: { tomato: { amount: 4, unit: "حبة" }, cucumber: { amount: 3, unit: "حبة" }, onion: { amount: 1, unit: "حبة" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نقطع الطماطم والخيار والبصل قطعاً صغيرة منتظمة", "نضيف الفلفل الأخضر المقطع", "نتبل بعصير الليمون وزيت الزيتون والملح", "نضيف نعناعاً مجففاً أو طازجاً", "نخلط ونقدم طازجاً"],
    stepsEn: ["Finely dice tomatoes, cucumber, and onion uniformly", "Add chopped green pepper", "Dress with lemon juice, olive oil, and salt", "Add dried or fresh mint", "Toss and serve fresh"],
    time: 10,
    servings: 4,
    image: "images/recipes/pexels-2116094-800.jpeg",
    nutrition: { calories: 80, protein: 2, carbs: 10, fat: 4, fiber: 3, sodium: 150, calcium: 40 },
  },
  {
    id: "cucumber_yogurt_salad",
    nameAr: "سلطة خيار باللبن",
    nameEn: "Cucumber Yogurt Salad",
    nameDe: "Gurken-Joghurt-Salat",
    nameRu: "Салат из огурцов с йогуртом",
    namePt: "Salada de pepino com iogurte",
    category: "salads",
    requiredIngredients: ["cucumber", "yogurt", "garlic"],
    optionalIngredients: ["olive_oil", "lemon"],
    ingredientQuantities: { cucumber: { amount: 2, unit: "حبة" }, yogurt: { amount: 300, unit: "جرام" }, garlic: { amount: 2, unit: "فص" } },
    stepsAr: ["نبشر الخيار أو نقطعه قطعاً صغيرة ونضغط لإزالة الماء", "نخلط اللبن مع الثوم المهروس والملح", "نضيف الخيار إلى اللبن", "نضيف زيت الزيتون والنعناع المجفف", "نبرد ونقدم بارداً"],
    stepsEn: ["Grate or finely dice cucumber and squeeze out excess water", "Mix yogurt with crushed garlic and salt", "Add cucumber to yogurt mixture", "Add olive oil and dried mint", "Chill and serve cold"],
    time: 10,
    servings: 3,
    image: "images/recipes/pexels-5191819-800.jpeg",
    nutrition: { calories: 90, protein: 5, carbs: 8, fat: 4, fiber: 1, sodium: 200, calcium: 120 },
  },
  {
    id: "chickpea_salad",
    nameAr: "سلطة الحمص",
    nameEn: "Chickpea Salad",
    nameDe: "Kichererbsensalat",
    nameRu: "Салат из нута",
    namePt: "Salada de grão-de-bico",
    category: "salads",
    requiredIngredients: ["chickpeas", "tomato", "onion", "lemon"],
    optionalIngredients: ["cucumber", "olive_oil", "pepper"],
    ingredientQuantities: { chickpeas: { amount: 400, unit: "جرام" }, tomato: { amount: 3, unit: "حبة" }, onion: { amount: 1, unit: "حبة" }, lemon: { amount: 1, unit: "حبة" } },
    stepsAr: ["نصفي الحمص المطبوخ أو المعلب ونشطفه", "نقطع الطماطم والخيار والبصل", "نخلط الحمص مع الخضروات المقطعة", "نتبل بزيت الزيتون وعصير الليمون والثوم", "نضيف البقدونس المفروم ونقدم"],
    stepsEn: ["Drain and rinse cooked or canned chickpeas", "Dice tomatoes, cucumber, and onion", "Toss chickpeas with chopped vegetables", "Dress with olive oil, lemon juice, and garlic", "Add chopped parsley and serve"],
    time: 15,
    servings: 4,
    image: "images/recipes/pexels-6066051-800.jpeg",
    nutrition: { calories: 200, protein: 9, carbs: 28, fat: 7, fiber: 8, sodium: 220, calcium: 70 },
  },
  {
    id: "carrot_salad",
    nameAr: "سلطة الجزر",
    nameEn: "Carrot Salad",
    nameDe: "Möhrensalat",
    nameRu: "Морковный салат",
    namePt: "Salada de cenoura",
    category: "salads",
    requiredIngredients: ["carrot", "lemon", "olive_oil"],
    optionalIngredients: ["garlic", "onion"],
    ingredientQuantities: { carrot: { amount: 500, unit: "جرام" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, garlic: { amount: 2, unit: "فص" } },
    stepsAr: ["نبشر الجزر أو نقطعه شرائح رفيعة", "نحضر التتبيلة من الليمون وزيت الزيتون والثوم والملح", "نضيف الكمون والكزبرة المطحونة", "نخلط الجزر مع التتبيلة جيداً", "نبرد لمدة ٣٠ دقيقة ثم نقدم"],
    stepsEn: ["Grate carrots or cut into thin strips", "Prepare dressing from lemon, olive oil, garlic, and salt", "Add cumin and ground coriander", "Toss carrots with dressing thoroughly", "Chill for 30 minutes then serve"],
    time: 15,
    servings: 4,
    image: "images/recipes/pexels-5741137-800.jpeg",
    nutrition: { calories: 95, protein: 1, carbs: 12, fat: 5, fiber: 3, sodium: 140, calcium: 35 },
  },
  {
    id: "green_salad",
    nameAr: "سلطة خضراء",
    nameEn: "Green Salad",
    nameDe: "Grüner Salat",
    nameRu: "Зелёный салат",
    namePt: "Salada verde",
    category: "salads",
    requiredIngredients: ["cucumber", "tomato", "lemon"],
    optionalIngredients: ["onion", "olive_oil", "pepper"],
    ingredientQuantities: { cucumber: { amount: 2, unit: "حبة" }, tomato: { amount: 3, unit: "حبة" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نقطع الخيار والطماطم والخس قطعاً متوسطة", "نضيف الفلفل الأخضر والبصل المقطع", "نحضر التتبيلة من الليمون وزيت الزيتون والملح", "نسكب التتبيلة على السلطة", "نرش الأعشاب الطازجة ونقدم فوراً"],
    stepsEn: ["Chop cucumber, tomatoes, and lettuce into medium pieces", "Add green pepper and sliced onion", "Prepare dressing from lemon, olive oil, and salt", "Pour dressing over salad", "Sprinkle fresh herbs and serve immediately"],
    time: 10,
    servings: 3,
    image: "images/recipes/pexels-1059905-800.jpeg",
    nutrition: { calories: 70, protein: 2, carbs: 8, fat: 4, fiber: 2, sodium: 120, calcium: 50 },
  },
  {
    id: "lentil_salad",
    nameAr: "سلطة العدس",
    nameEn: "Lentil Salad",
    nameDe: "Linsensalat",
    nameRu: "Салат из чечевицы",
    namePt: "Salada de lentilhas",
    category: "salads",
    requiredIngredients: ["lentils", "onion", "lemon", "olive_oil"],
    optionalIngredients: ["tomato", "cucumber", "garlic"],
    ingredientQuantities: { lentils: { amount: 300, unit: "جرام" }, onion: { amount: 1, unit: "حبة" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نطهو العدس حتى ينضج ويصفى ويبرد", "نقطع البصل والطماطم والخيار", "نخلط العدس مع الخضروات", "نتبل بزيت الزيتون وعصير الليمون والثوم والكمون", "نضيف البقدونس ونقدم دافئاً أو بارداً"],
    stepsEn: ["Cook lentils until tender, drain, and cool", "Dice onion, tomatoes, and cucumber", "Toss lentils with vegetables", "Dress with olive oil, lemon juice, garlic, and cumin", "Add parsley and serve warm or cold"],
    time: 30,
    servings: 4,
    image: "images/recipes/pexels-8934919-800.jpeg",
    nutrition: { calories: 220, protein: 12, carbs: 30, fat: 7, fiber: 10, sodium: 200, calcium: 55 },
  },
  {
    id: "avocado_tomato_salad",
    nameAr: "سلطة الأفوكادو والطماطم",
    nameEn: "Avocado Tomato Salad",
    nameDe: "Avocado-Tomaten-Salat",
    nameRu: "Салат с авокадо и томатами",
    namePt: "Salada de abacate e tomate",
    category: "salads",
    requiredIngredients: ["tomato", "lemon", "olive_oil"],
    optionalIngredients: ["onion", "cucumber"],
    ingredientQuantities: { tomato: { amount: 2, unit: "حبة" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 1, unit: "ملعقة ك." }, onion: { amount: 0.5, unit: "حبة" } },
    stepsAr: ["نقطع الأفوكادو والطماطم قطعاً متوسطة", "نضيف البصل الأحمر المفروم والكزبرة", "نتبل بعصير الليمون وزيت الزيتون والملح", "نخلط برفق حتى لا يتهرأ الأفوكادو", "نقدم فوراً"],
    stepsEn: ["Cube avocado and tomatoes into medium chunks", "Add diced red onion and cilantro", "Dress with lemon juice, olive oil, and salt", "Toss gently to keep avocado intact", "Serve immediately"],
    time: 10,
    servings: 2,
    image: "images/recipes/pexels-5115057-800.jpeg",
    nutrition: { calories: 180, protein: 3, carbs: 10, fat: 16, fiber: 7, sodium: 130, calcium: 25 },
  },
  {
    id: "coleslaw",
    nameAr: "سلطة الكول سلو",
    nameEn: "Coleslaw",
    nameDe: "Krautsalat",
    nameRu: "Коул слоу",
    namePt: "Salada de repolho",
    category: "salads",
    requiredIngredients: ["carrot", "lemon", "olive_oil"],
    optionalIngredients: ["onion"],
    ingredientQuantities: { carrot: { amount: 3, unit: "حبة" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نبشر الكرنب الأبيض والجزر بشرة ناعمة", "نقطع البصل الأخضر شرائح رفيعة", "نحضر الصلصة من المايونيز وعصير الليمون والملح والفلفل", "نخلط الخضروات مع الصلصة جيداً", "نبرد ساعة قبل التقديم"],
    stepsEn: ["Finely shred white cabbage and grate carrots", "Thinly slice green onion", "Prepare dressing from mayonnaise, lemon juice, salt, and pepper", "Toss vegetables with dressing thoroughly", "Chill for one hour before serving"],
    time: 15,
    servings: 6,
    image: "images/recipes/pexels-7362673-800.jpeg",
    nutrition: { calories: 140, protein: 2, carbs: 11, fat: 10, fiber: 3, sodium: 230, calcium: 45 },
  },
  // BREAKFAST
  {
    id: "scrambled_eggs",
    nameAr: "بيض مقلي",
    nameEn: "Scrambled Eggs",
    nameDe: "Rührei",
    nameRu: "Яичница-болтунья",
    namePt: "Ovos mexidos",
    category: "breakfast",
    requiredIngredients: ["eggs", "butter"],
    optionalIngredients: ["milk", "cheese"],
    ingredientQuantities: { eggs: { amount: 4, unit: "حبة" }, butter: { amount: 1, unit: "ملعقة ك." }, milk: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نكسر البيض في وعاء ونخفقه مع الملح والفلفل", "نسخن الزبدة في المقلاة على نار هادئة", "نسكب البيض المخفوق ونحركه باستمرار", "عند تجبن البيض جزئياً نضيف الجبن", "نقدم فوراً مع الخبز المحمص"],
    stepsEn: ["Beat eggs in bowl with salt and pepper", "Heat butter in pan on low heat", "Pour beaten eggs and stir constantly", "When partially set, add cheese", "Serve immediately with toast"],
    ovenTempAr: "نار هادئة جداً (١٢٠°م) على الموقد - مقلاة غير لاصقة",
    ovenTempEn: "Very low heat (120°C) on stovetop - non-stick pan",
    tipsAr: ["اخفق البيض جيداً قبل الطهي لقوام هش", "استخدم زبدة بدلاً من الزيت للنكهة", "حرك البيض باستمرار من الخارج للداخل بقوام كريمي", "ارفع المقلاة عن النار قبل تمام النضج لأن البيض سيستمر في النضج", "أضف ملعقة حليب أو كريمة للقوام الكريمي"],
    tipsEn: ["Beat eggs thoroughly before cooking for fluffy texture", "Use butter instead of oil for flavor", "Stir eggs constantly from outside to inside for creamy texture", "Remove pan from heat before fully set as eggs continue cooking", "Add a tablespoon of milk or cream for creamy consistency"],
    servingAr: ["يقدم فوراً مع الخبز المحمص والزبدة", "رش البقدونس المفروم والفلفل الأسود الطازج", "يقدم مع عصير البرتقال والقهوة"],
    servingEn: ["Serve immediately with toasted bread and butter", "Sprinkle chopped parsley and fresh black pepper", "Serve with orange juice and coffee"],
    time: 10,
    servings: 2,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 210, protein: 14, carbs: 2, fat: 17, fiber: 0, sodium: 380, calcium: 90 },
  },
  {
    id: "shakshuka",
    nameAr: "مخلمة (شاكشوكا)",
    nameEn: "Shakshuka",
    nameDe: "Shakshuka",
    nameRu: "Шакшука",
    namePt: "Shakshuka",
    category: "breakfast",
    requiredIngredients: ["eggs", "tomato"],
    optionalIngredients: ["onion", "garlic", "pepper", "olive_oil"],
    ingredientQuantities: { eggs: { amount: 6, unit: "حبة" }, tomato: { amount: 400, unit: "جرام" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 3, unit: "فص" }, olive_oil: { amount: 2, unit: "ملعقة ك." }, pepper: { amount: 1, unit: "حبة" } },
    stepsAr: [
      "نسخن زيت الزيتون في مقلاة عميقة على نار متوسطة",
      "نضيف البصل والثوم ونقليهما حتى يذبلا",
      "نضيف الطماطم المقطعة والفلفل الحار والبهارات ونطهو ١٠ دقائق",
      "نكسر البيض فوق الصلصة مباشرة",
      "نغطي المقلاة ونطهو حتى ينضج بياض البيض مع بقاء الصفار طريًا",
      "نقدم ساخنة مع الخبز"
    ],
    stepsEn: [
      "Heat olive oil in a deep skillet over medium heat",
      "Add onion and garlic, sauté until softened",
      "Add chopped tomatoes, chili, and spices; cook 10 minutes",
      "Crack eggs directly onto the tomato sauce",
      "Cover and cook until whites are set but yolks are still runny",
      "Serve hot with bread"
    ],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد - مقلاة عميقة مع غطاء",
    ovenTempEn: "Medium heat (180°C) on stovetop - deep skillet with lid",
    tipsAr: ["أضف ملعقة صغيرة من الكمون والبابريكا والفلفل الأحمر للصلصة", "حمر البصل والثوم حتى يصبح شفافياً قبل إضافة الطماطم", "اطبخ الطماطم حتى تتكرمل وتتكاثف الصلصة", "كسر البيض بحذر في حفرة صغيرة في الصلصة", "غطي المقلاة واطبخ على نار هادئة حتى ينضج البياض ويبقى الصفار طرياً"],
    tipsEn: ["Add a teaspoon of cumin, paprika, and red pepper to sauce", "Sauté onion and garlic until translucent before adding tomatoes", "Cook tomatoes until caramelized and sauce thickens", "Crack eggs carefully into small wells in the sauce", "Cover skillet and cook on low heat until whites set but yolks remain runny"],
    servingAr: ["يقدم ساخناً في نفس المقلاة مع الخبز العربي", "رش الكزبرة الخضراء المفرومة والفلفل الأحمر", "اعصر الليمون الطازج فوق البيض", "يقدم مع الفول المدمس أو الجبن"],
    servingEn: ["Serve hot in the same skillet with Arabic bread", "Sprinkle chopped fresh coriander and red pepper", "Squeeze fresh lemon over eggs", "Serve with foul medames or cheese"],
    time: 25,
    servings: 2,
    image: "images/recipes/pexels-5409015-800.jpeg",
    nutrition: { calories: 185, protein: 12, carbs: 9, fat: 12, fiber: 2, sodium: 420, calcium: 80 },
  },
  {
    id: "foul_medames",
    nameAr: "فول مدمس",
    nameEn: "Foul Medames",
    nameDe: "Foul Medames",
    nameRu: "Фуль медамес",
    namePt: "Foul Medames",
    category: "breakfast",
    requiredIngredients: ["broad_beans", "olive_oil", "lemon", "garlic"],
    optionalIngredients: ["cumin", "tomato", "parsley"],
    ingredientQuantities: { broad_beans: { amount: 400, unit: "جرام" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, lemon: { amount: 1, unit: "حبة" }, garlic: { amount: 2, unit: "فص" } },
    stepsAr: ["نسلق الفول حتى ينضج", "نهرس الفول قليلاً ونضيف الثوم والكمون", "نسكب زيت الزيتون وعصير الليمون", "نزين بالطماطم والبقدونس", "نقدم ساخناً مع الخبز"],
    stepsEn: ["Cook fava beans until tender", "Mash beans slightly and add garlic and cumin", "Pour olive oil and lemon juice", "Garnish with tomato and parsley", "Serve hot with bread"],
    time: 30,
    servings: 3,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 280, protein: 14, carbs: 34, fat: 10, fiber: 12, sodium: 420, calcium: 80 },
  },
  {
    id: "falafel_plate",
    nameAr: "طبق فلافل",
    nameEn: "Falafel Plate",
    nameDe: "Falafel-Teller",
    nameRu: "Тарелка фалафеля",
    namePt: "Prato de falafel",
    category: "breakfast",
    requiredIngredients: ["falafel", "olive_oil", "tahini", "bread"],
    optionalIngredients: ["tomato", "cucumber", "parsley", "lemon"],
    ingredientQuantities: { falafel: { amount: 12, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, tahini: { amount: 4, unit: "ملعقة ك." }, bread: { amount: 2, unit: "رغيف" } },
    stepsAr: ["نقلي الفلافل في زيت غزير حتى تحمر", "نخفق الطحينة مع الماء والليمون والثوم", "نقطع الطماطم والخيار", "نرص الفلافل مع الخضار والخبز", "نسكب صلصة الطحينة فوقها"],
    stepsEn: ["Fry falafel in deep oil until golden", "Whisk tahini with water, lemon, and garlic", "Chop tomato and cucumber", "Arrange falafel with vegetables and bread", "Pour tahini sauce on top"],
    ovenTempAr: "زيت ساخن (١٧٥°م) على نار متوسطة - ٣ دقائق لكل جانب",
    ovenTempEn: "Hot oil (175°C) on medium heat - 3 minutes per side",
    tipsAr: ["سخن الزيت جيداً قبل قلي الفلافل لتفادي التصاقها", "اقلي الفلافل على دفعات صغيرة لتفادي خفض حرارة الزيت", "أضف ملعقة صغيرة من الكزبرة المطحونة والكمون للعجين", "اخفق الطحينة مع الماء تدريجياً حتى تصبح ناعمة", "أضف الثون المهروس لصلصة الطحينة للنكهة"],
    tipsEn: ["Heat oil thoroughly before frying falafel to prevent sticking", "Fry falafel in small batches to avoid lowering oil temperature", "Add a teaspoon of ground coriander and cumin to dough", "Whisk tahini with water gradually until smooth", "Add minced garlic to tahini sauce for flavor"],
    servingAr: ["يقدم ساخناً مع الخبز العربي والصلصة", "رص الفلافل مع الطماطم والخيار والبقدونس", "أسكب صلصة الطحينة فوق الفلافل", "يقدم مع المخللات والسلطة الخضراء"],
    servingEn: ["Serve hot with Arabic bread and sauce", "Arrange falafel with tomato, cucumber, and parsley", "Pour tahini sauce over falafel", "Serve with pickles and green salad"],
    time: 25,
    servings: 3,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 340, protein: 12, carbs: 38, fat: 16, fiber: 6, sodium: 580, calcium: 90 },
  },
  {
    id: "omelette_veggie",
    nameAr: "أومليت بالخضار",
    nameEn: "Vegetable Omelette",
    nameDe: "Gemüse-Omelett",
    nameRu: "Омлет с овощами",
    namePt: "Omelete de legumes",
    category: "breakfast",
    requiredIngredients: ["eggs", "tomato", "onion", "olive_oil"],
    optionalIngredients: ["pepper", "cheese", "spinach", "mushroom"],
    ingredientQuantities: { eggs: { amount: 4, unit: "حبة" }, tomato: { amount: 1, unit: "حبة" }, onion: { amount: 1, unit: "حبة" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نخفق البيض مع الملح والفلفل", "نحمر البصل والطماطم في المقلاة", "نسكب البيض فوق الخضار", "نطهي على نار هادئة حتى ينضج", "نطوي الأومليت ونقدم مع الخبز"],
    stepsEn: ["Beat eggs with salt and pepper", "Sauté onion and tomato in pan", "Pour eggs over vegetables", "Cook on low heat until set", "Fold omelette and serve with bread"],
    ovenTempAr: "نار هادئة (١٤٠°م) على الموقد - مقلاة غير لاصقة",
    ovenTempEn: "Low heat (140°C) on stovetop - non-stick pan",
    tipsAr: ["حمر البصل والطماطم حتى يذبلا قبل إضافة البيض", "أضف ملعقة صغيرة من الأوريغانو والريحان المجفف", "اطبخ البيض على نار هادئة لتفادي جفافه", "أضف الجبن المبشور قبل طي الأومليت", "استخدم ملعقة سيليكون لتفادي خدش المقلاة"],
    tipsEn: ["Sauté onion and tomato until softened before adding eggs", "Add a teaspoon of oregano and dried basil", "Cook eggs on low heat to avoid drying", "Add grated cheese before folding omelette", "Use silicone spatula to avoid scratching pan"],
    servingAr: ["يقدم فوراً مع الخبز المحمص", "رش البقدونس المفروم والفلفل الأسود", "يقدم مع عصير البرتقال والفواكه الطازجة"],
    servingEn: ["Serve immediately with toasted bread", "Sprinkle chopped parsley and black pepper", "Serve with orange juice and fresh fruit"],
    time: 15,
    servings: 2,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 240, protein: 16, carbs: 6, fat: 18, fiber: 1, sodium: 320, calcium: 110 },
  },
  {
    id: "oatmeal_banana",
    nameAr: "شوفان بالموز",
    nameEn: "Banana Oatmeal",
    nameDe: "Bananen-Haferbrei",
    nameRu: "Овсянка с бананом",
    namePt: "Papas de aveia com banana",
    category: "breakfast",
    requiredIngredients: ["oats", "milk", "banana", "honey"],
    optionalIngredients: ["cinnamon", "walnut", "raisin"],
    ingredientQuantities: { oats: { amount: 1, unit: "كوب" }, milk: { amount: 2, unit: "كوب" }, banana: { amount: 1, unit: "حبة" }, honey: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نسخن الحليب حتى الغليان", "نضيف الشوفان ونطهي ٥ دقائق", "نقطع الموز ونضيفه للشوفان", "نحلي بالعسل ونرش القرفة", "نقدم دافئاً"],
    stepsEn: ["Heat milk until boiling", "Add oats and cook 5 minutes", "Slice banana and add to oatmeal", "Sweeten with honey and sprinkle cinnamon", "Serve warm"],
    time: 10,
    servings: 1,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 320, protein: 12, carbs: 58, fat: 6, fiber: 6, sodium: 100, calcium: 200 },
  },
  {
    id: "avocado_toast",
    nameAr: "توست الأفوكادو",
    nameEn: "Avocado Toast",
    nameDe: "Avocado-Toast",
    nameRu: "Тост с авокадо",
    namePt: "Torrada de abacate",
    category: "breakfast",
    requiredIngredients: ["bread", "avocado", "lemon", "olive_oil"],
    optionalIngredients: ["eggs", "tomato", "salt"],
    ingredientQuantities: { bread: { amount: 2, unit: "شريحة" }, avocado: { amount: 1, unit: "حبة" }, lemon: { amount: 0.5, unit: "حبة" }, olive_oil: { amount: 1, unit: "ملعقة ك." } },
    stepsAr: ["نحمص الخبز حتى يصبح ذهبياً", "نهرس الأفوكادو مع عصير الليمون والملح", "نوزع الأفوكادو على الخبز المحمص", "نرش زيت الزيتون", "نقدم فوراً"],
    stepsEn: ["Toast bread until golden", "Mash avocado with lemon juice and salt", "Spread avocado on toast", "Drizzle olive oil", "Serve immediately"],
    time: 10,
    servings: 1,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 280, protein: 6, carbs: 30, fat: 16, fiber: 8, sodium: 240, calcium: 40 },
  },
  {
    id: "pancakes_honey",
    nameAr: "بان كيك بالعسل",
    nameEn: "Pancakes with Honey",
    nameDe: "Pfannkuchen mit Honig",
    nameRu: "Панкейки с мёдом",
    namePt: "Panquecas com mel",
    category: "breakfast",
    requiredIngredients: ["flour", "eggs", "milk", "honey"],
    optionalIngredients: ["butter", "vanilla", "banana", "strawberry"],
    ingredientQuantities: { flour: { amount: 1, unit: "كوب" }, eggs: { amount: 2, unit: "حبة" }, milk: { amount: 1, unit: "كوب" }, honey: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نخفق البيض مع الحليب والفانيليا", "نضيف الدقيق تدريجياً ونخلط حتى يتجانس", "نسكب مغرفة في مقلاة ساخنة ونطهي دقيقة من كل جانب", "نرص البان كيك في الطبق", "نسكب العسل ونقدم مع الفاكهة"],
    stepsEn: ["Beat eggs with milk and vanilla", "Gradually add flour and mix until smooth", "Pour a ladle in hot pan, cook 1 minute each side", "Stack pancakes on plate", "Pour honey and serve with fruit"],
    ovenTempAr: "نار متوسطة (١٦٠°م) على الموقد - مقلاة غير لاصقة مدهونة بالزبدة",
    ovenTempEn: "Medium heat (160°C) on stovetop - non-stick pan greased with butter",
    tipsAr: ["اخفق البيض مع الحليب والفانيليا قبل إضافة الدقيق تدريجياً", "لا تخلط العجين كثيراً لتفادي ظهور فقاعات الهواء", "اترك العجين يرتاح ٥ دقائق قبل الطهي", "سخن المقلاة جيداً وادهنها بالزبدة قبل كل بان كيك", "اقلب البان كيك عند ظهور فقاعات صغيرة على السطح"],
    tipsEn: ["Beat eggs with milk and vanilla before gradually adding flour", "Do not overmix batter to avoid air bubbles", "Let batter rest 5 minutes before cooking", "Heat pan well and grease with butter before each pancake", "Flip pancake when small bubbles appear on surface"],
    servingAr: ["يقدم دافئاً مع العسل أو شراب القيقب", "زيّن بالموز والفراولة والمكسرات", "رش القرفة والسكر البودرة", "يقدم مع كوب حليب أو قهوة"],
    servingEn: ["Serve warm with honey or maple syrup", "Garnish with banana, strawberries, and nuts", "Sprinkle cinnamon and powdered sugar", "Serve with a glass of milk or coffee"],
    time: 20,
    servings: 3,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 290, protein: 8, carbs: 48, fat: 7, fiber: 1, sodium: 280, calcium: 120 },
  },
  {
    id: "labneh_plate",
    nameAr: "طبق لبنة",
    nameEn: "Labneh Plate",
    nameDe: "Labneh-Teller",
    nameRu: "Тарелка лябане",
    namePt: "Prato de labneh",
    category: "breakfast",
    requiredIngredients: ["yogurt", "olive_oil", "bread", "olives"],
    optionalIngredients: ["tomato", "cucumber", "mint", "lemon"],
    ingredientQuantities: { yogurt: { amount: 300, unit: "جرام" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, bread: { amount: 2, unit: "رغيف" }, olives: { amount: 100, unit: "جرام" } },
    stepsAr: ["نضع اللبنة في طبق ونشكل حفرة في وسطها", "نسكب زيت الزيتون في الوسط", "نرص الزيتون والطماطم والخيار حولها", "نزين بالنعناع", "نقدم مع الخبز"],
    stepsEn: ["Place labneh on plate and make a well in center", "Pour olive oil in the center", "Arrange olives, tomato, and cucumber around it", "Garnish with mint", "Serve with bread"],
    time: 10,
    servings: 3,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 220, protein: 10, carbs: 28, fat: 8, fiber: 2, sodium: 480, calcium: 150 },
  },
  {
    id: "french_toast",
    nameAr: "توست فرنسي",
    nameEn: "French Toast",
    nameDe: "Französischer Toast",
    nameRu: "Французский тост",
    namePt: "Torrada francesa",
    category: "breakfast",
    requiredIngredients: ["bread", "eggs", "milk", "butter"],
    optionalIngredients: ["honey", "cinnamon", "vanilla", "banana"],
    ingredientQuantities: { bread: { amount: 4, unit: "شريحة" }, eggs: { amount: 2, unit: "حبة" }, milk: { amount: 0.5, unit: "كوب" }, butter: { amount: 30, unit: "جرام" } },
    stepsAr: ["نخفق البيض مع الحليب والفانيليا والقرفة", "نغمس شرائح الخبز في الخليط", "نذيب الزبدة في مقلاة ونحمص الخبز من الجهتين", "نرص في الطبق", "نسكب العسل ونقدم"],
    stepsEn: ["Beat eggs with milk, vanilla, and cinnamon", "Dip bread slices in mixture", "Melt butter in pan and toast bread on both sides", "Arrange on plate", "Drizzle honey and serve"],
    ovenTempAr: "نار متوسطة (١٦٠°م) على الموقد - مقلاة بالزبدة",
    ovenTempEn: "Medium heat (160°C) on stovetop - pan with butter",
    tipsAr: ["اخفق البيض مع الحليب والفانيليا والقرفة وجوزة الطيب", "اغمس الخبز في الخليط لمدة ٢٠ ثانية من كل جانب", "سخن الزبدة على نار متوسطة لتفادي احتراقها", "اشوي الخبز حتى يصبح ذهبياً من الجهتين", "رش القرفة والسكر البودرة قبل التقديم"],
    tipsEn: ["Beat eggs with milk, vanilla, cinnamon, and nutmeg", "Dip bread in mixture for 20 seconds per side", "Heat butter on medium heat to avoid burning", "Toast bread until golden on both sides", "Sprinkle cinnamon and powdered sugar before serving"],
    servingAr: ["يقدم دافئاً مع العسل أو شراب القيقب", "زيّن بالموز أو الفراولة المقطعة", "رش السكر البودرة والقرفة", "يقدم مع كوب قهوة أو شاي"],
    servingEn: ["Serve warm with honey or maple syrup", "Garnish with sliced banana or strawberries", "Sprinkle powdered sugar and cinnamon", "Serve with a cup of coffee or tea"],
    time: 15,
    servings: 2,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 310, protein: 12, carbs: 36, fat: 12, fiber: 2, sodium: 340, calcium: 130 },
  },
  {
    id: "smoothie_bowl",
    nameAr: "وعاء سموذي",
    nameEn: "Smoothie Bowl",
    nameDe: "Smoothie-Bowl",
    nameRu: "Смузи-боул",
    namePt: "Tigela de smoothie",
    category: "breakfast",
    requiredIngredients: ["banana", "strawberry", "yogurt", "honey"],
    optionalIngredients: ["blueberry", "oats", "walnut", "apple"],
    ingredientQuantities: { banana: { amount: 1, unit: "حبة" }, strawberry: { amount: 150, unit: "جرام" }, yogurt: { amount: 150, unit: "جرام" }, honey: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نخفق الموز والفراولة والزبادي في الخلاط", "نسكب الخليط في وعاء", "نزين بالتوت الأزرق والشوفان والمكسرات", "نسكب العسل", "نقدم بارداً"],
    stepsEn: ["Blend banana, strawberry, and yogurt in blender", "Pour mixture into bowl", "Top with blueberries, oats, and nuts", "Drizzle honey", "Serve cold"],
    time: 10,
    servings: 1,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 260, protein: 8, carbs: 52, fat: 3, fiber: 7, sodium: 60, calcium: 140 },
  },
  {
    id: "eggs_benedict",
    nameAr: "بيض بنديكت",
    nameEn: "Eggs Benedict",
    nameDe: "Eggs Benedict",
    nameRu: "Яйца Бенедикт",
    namePt: "Ovos Benedict",
    category: "breakfast",
    requiredIngredients: ["eggs", "bread", "butter", "lemon"],
    optionalIngredients: ["spinach", "tomato", "olive_oil"],
    ingredientQuantities: { eggs: { amount: 4, unit: "حبة" }, bread: { amount: 2, unit: "شريحة" }, butter: { amount: 80, unit: "جرام" }, lemon: { amount: 0.5, unit: "حبة" } },
    stepsAr: ["نحمص الخبز في الفرن", "نسلق البيض بضع دقائق لنحصل على بيض مسلوق بطري", "نخفق صفار البيض مع الزبدة المذابة وعصير الليمون لتحضير صلصة الهولنديز", "نرص الخبز ونضع فوقه السبانخ ثم البيض", "نسكب الصلصة ونقدم فوراً"],
    stepsEn: ["Toast bread in oven", "Poach eggs briefly for runny yolk", "Whisk egg yolk with melted butter and lemon for hollandaise", "Arrange bread, top with spinach and egg", "Pour sauce and serve immediately"],
    ovenTempAr: "فرن متوسط (١٨٠°م) لتحميص الخبز - ماء ساخن (٨٠°م) لسلق البيض",
    ovenTempEn: "Medium oven (180°C) for toasting bread - hot water (80°C) for poaching eggs",
    tipsAr: ["حمص الخبز في الفرن حتى يصبح ذهبياً ومقرمشاً", "اضيف ملعقة خل أبيض للماء الساخن لسلق البيض بشكل مثالي", "اخفق صفار البيض مع الزبدة المذابة تدريجياً لصلصة الهولنديز", "أضف عصير الليمون والملح والفلفل الأبيض للصلصة", "اسلق البيض ٣ دقائق فقط للحصول على صفار طري"],
    tipsEn: ["Toast bread in oven until golden and crispy", "Add a tablespoon of white vinegar to hot water for perfect poaching", "Whisk egg yolk with melted butter gradually for hollandaise", "Add lemon juice, salt, and white pepper to sauce", "Poach eggs for only 3 minutes for runny yolk"],
    servingAr: ["يقدم فوراً في أطباق فردية", "رش البقدونس المفروم والفلفل الأسود", "زيّن بأوراق السبانخ الطازجة والطماطم", "يقدم مع عصير البرتقال والقهوة"],
    servingEn: ["Serve immediately in individual plates", "Sprinkle chopped parsley and black pepper", "Garnish with fresh spinach leaves and tomato", "Serve with orange juice and coffee"],
    time: 25,
    servings: 2,
    image: "images/recipes/pexels-5720777-800.jpeg",
    nutrition: { calories: 340, protein: 16, carbs: 22, fat: 22, fiber: 2, sodium: 480, calcium: 100 },
  },
  // GRILLED
  {
    id: "grilled_chicken",
    nameAr: "دجاج مشوي",
    nameEn: "Grilled Chicken",
    nameDe: "Gegrilltes Hühnchen",
    nameRu: "Курица гриль",
    namePt: "Frango grelhado",
    category: "grilled",
    requiredIngredients: ["chicken", "garlic", "lemon", "olive_oil"],
    optionalIngredients: ["onion", "pepper"],
    ingredientQuantities: { chicken: { amount: 800, unit: "جرام" }, lemon: { amount: 1, unit: "حبة" }, garlic: { amount: 4, unit: "فص" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نتبل الدجاج بالثوم والليمون وزيت الزيتون والبهارات", "نتركه يتبل لمدة ساعة في الثلاجة", "نشوي الدجاج على الجريل على حرارة عالية", "نقلب قطع الدجاج كل ١٠ دقائق", "نقدم مع السلطة والليمون"],
    stepsEn: ["Marinate chicken with garlic, lemon, olive oil, and spices", "Refrigerate for 1 hour", "Grill chicken on high heat", "Flip chicken pieces every 10 minutes", "Serve with salad and lemon"],
    ovenTempAr: "نار عالية (٢٢٠°م) على الشواية أو الفرن - ٢٠ إلى ٢٥ دقيقة",
    ovenTempEn: "High heat (220°C) on grill or oven - 20 to 25 minutes",
    tipsAr: ["تبل الدجاج بالثون والليمون وزيت الزيتون والكمون والكزبرة والبابريكا", "انقع الدجاج في التتبيلة لمدة ساعة على الأقل أو طوال الليل", "دهن الدجاج بالتتبيلة أثناء الشواء لترطيب إضافي", "اشوي الدجاج جلداً لأسفل أولاً لقشرة مقرمشة", "اترك الدجاج يرتاح ٥ دقائق بعد الشواء قبل التقطيع"],
    tipsEn: ["Marinate chicken with garlic, lemon, olive oil, cumin, coriander, and paprika", "Marinate chicken for at least 1 hour or overnight", "Baste chicken with marinade during grilling for extra moisture", "Grill chicken skin-side down first for crispy skin", "Let chicken rest 5 minutes after grilling before cutting"],
    servingAr: ["يقدم ساخناً مع السلطة الخضراء والطحينة", "اعصر الليمون الطازج فوق الدجاج", "يقدم مع الخبز العربي والأرز", "رش البقدونس المفروم والفلفل الأسود"],
    servingEn: ["Serve hot with green salad and tahini", "Squeeze fresh lemon over chicken", "Serve with Arabic bread and rice", "Sprinkle chopped parsley and black pepper"],
    time: 50,
    servings: 4,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 290, protein: 38, carbs: 3, fat: 14, fiber: 0, sodium: 420, calcium: 30 },
  },
  {
    id: "grilled_beef",
    nameAr: "لحم مشوي",
    nameEn: "Grilled Beef",
    nameDe: "Gegrilltes Rindfleisch",
    nameRu: "Говядина гриль",
    namePt: "Carne grelhada",
    category: "grilled",
    requiredIngredients: ["beef", "garlic", "onion", "olive_oil"],
    optionalIngredients: ["lemon", "pepper"],
    ingredientQuantities: { beef: { amount: 600, unit: "جرام" }, onion: { amount: 1, unit: "حبة" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نقطع اللحم إلى شرائح متساوية", "نتبل بالثوم والبصل وزيت الزيتون والبهارات", "نشوي على نار عالية ٥ دقائق من كل جانب", "نترك اللحم يرتاح ٥ دقائق قبل التقديم", "نقدم مع الخضروات المشوية"],
    stepsEn: ["Cut beef into equal slices", "Season with garlic, onion, olive oil, and spices", "Grill on high heat 5 minutes each side", "Let meat rest 5 minutes before serving", "Serve with grilled vegetables"],
    ovenTempAr: "نار عالية جداً (٢٤٠°م) على الشواية - ٥ دقائق من كل جانب",
    ovenTempEn: "Very high heat (240°C) on grill - 5 minutes per side",
    tipsAr: ["تبل اللحم بالثون والبصل وزيت الزيتون والفلفل الأسود والبهار الحلو", "اترك اللحم يصل لدرجة حرارة الغرفة قبل الشواء", "اشوي اللحم على نار عالية جداً للحصول على قشرة مقرمشة", "اترك اللحم يرتاح ٥ دقائق بعد الشواء قبل التقطيع للحفاظ على العصارة", "لا تقلب اللحم أكثر من مرة لتفادي جفافه"],
    tipsEn: ["Season beef with garlic, onion, olive oil, black pepper, and allspice", "Let meat reach room temperature before grilling", "Grill beef on very high heat for crispy crust", "Let meat rest 5 minutes after grilling before slicing to keep juices", "Do not flip meat more than once to avoid drying"],
    servingAr: ["يقدم ساخناً مع الخضروات المشوية والبطاطس", "يقدم مع صلصة الفطر أو صلصة الفلفل الأسود", "رش الملح البحري والفلفل الأسود الطازج", "يقدم مع الخبز العربي أو الأرز"],
    servingEn: ["Serve hot with grilled vegetables and potatoes", "Serve with mushroom sauce or black pepper sauce", "Sprinkle sea salt and fresh black pepper", "Serve with Arabic bread or rice"],
    time: 25,
    servings: 4,
    image: "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=800",
    nutrition: { calories: 350, protein: 42, carbs: 2, fat: 19, fiber: 0, sodium: 380, calcium: 20 },
  },
  {
    id: "kofta_grilled",
    nameAr: "كفتة مشوية",
    nameEn: "Grilled Kofta",
    nameDe: "Gegrillte Kofta",
    nameRu: "Кофта на гриле",
    namePt: "Kofta grelhada",
    category: "grilled",
    requiredIngredients: ["minced_meat", "onion", "garlic", "olive_oil"],
    optionalIngredients: ["pepper", "parsley"],
    ingredientQuantities: { minced_meat: { amount: 600, unit: "جرام" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 3, unit: "فص" } },
    stepsAr: ["نخلط اللحم المفروم مع البصل المبشور والثوم والبهارات والملح", "نعجن المزيج جيداً لمدة ٥ دقائق حتى يتماسك", "نشكل الكفتة على أسياخ بشكل أسطواني", "نشوي على الجريل الساخن ٥ دقائق من كل جانب", "نقدم مع الخبز العربي والطحينية والسلطة"],
    stepsEn: ["Mix minced meat with grated onion, garlic, spices, and salt", "Knead mixture well for 5 minutes until firm", "Shape kofta onto skewers in cylindrical form", "Grill on hot grill 5 minutes each side", "Serve with pita bread, tahini, and salad"],
    ovenTempAr: "نار عالية (٢٢٠°م) على الشواية - ٥ دقائق من كل جانب",
    ovenTempEn: "High heat (220°C) on grill - 5 minutes per side",
    tipsAr: ["أضف البصل المبشور والعصير للحم المفروم لترطيب الكفتة", "أضف ملعقة صغيرة من الكمون والكزبرة والفلفل الأسود والبهار الحلو", "اعجن اللحم جيداً لمدة ٥ دقائق حتى يتماسك على الأسياخ", "بلل يديك بالماء عند تشكيل الكفتة على الأسياخ", "اشوي على نار عالية مع التقليب كل دقيقتين"],
    tipsEn: ["Add grated onion and juice to minced meat to keep kofta moist", "Add a teaspoon of cumin, coriander, black pepper, and allspice", "Knead meat well for 5 minutes until firm on skewers", "Wet hands with water when shaping kofta onto skewers", "Grill on high heat turning every 2 minutes"],
    servingAr: ["يقدم ساخناً مع الخبز العربي وصلصة الطحينة", "رش البقدونس المفروم والبصل الأحمر", "يقدم مع السلطة الخضراء والمخللات", "اعصر الليمون الطازج فوق الكفتة"],
    servingEn: ["Serve hot with Arabic bread and tahini sauce", "Sprinkle chopped parsley and red onion", "Serve with green salad and pickles", "Squeeze fresh lemon over kofta"],
    time: 30,
    servings: 4,
    image: "https://images.unsplash.com/photo-1529042410759-befb1204b468?auto=format&fit=crop&w=800",
    nutrition: { calories: 280, protein: 26, carbs: 4, fat: 18, fiber: 1, sodium: 460, calcium: 25 },
  },
  {
    id: "shish_tawook",
    nameAr: "شيش طاووق",
    nameEn: "Shish Tawook",
    nameDe: "Shish Tawook",
    nameRu: "Шиш Тавук",
    namePt: "Shish Tawook",
    category: "grilled",
    requiredIngredients: ["chicken", "garlic", "lemon", "yogurt"],
    optionalIngredients: ["olive_oil", "pepper", "onion"],
    ingredientQuantities: { chicken: { amount: 700, unit: "جرام" }, yogurt: { amount: 150, unit: "جرام" }, lemon: { amount: 2, unit: "حبة" }, garlic: { amount: 5, unit: "فص" } },
    stepsAr: ["نقطع الدجاج لمكعبات متساوية", "نخلط الزبادي مع الثوم والليمون والكركم والبهارات", "نتبل الدجاج في الخليط لمدة ٣ ساعات أو طوال الليل", "نشك قطع الدجاج على الأسياخ ونشوي على نار عالية", "نقدم مع التوم والخبز العربي"],
    stepsEn: ["Cut chicken into equal cubes", "Mix yogurt with garlic, lemon, turmeric, and spices", "Marinate chicken in mixture for 3 hours or overnight", "Thread chicken onto skewers and grill on high heat", "Serve with garlic sauce and pita bread"],
    ovenTempAr: "نار عالية (٢٢٠°م) على الشواية - ٤ إلى ٥ دقائق من كل جانب",
    ovenTempEn: "High heat (220°C) on grill - 4 to 5 minutes per side",
    tipsAr: ["تبل الدجاج بالزبادي والثون والليمون والكركم والكزبرة والبابريكا", "انقع الدجاج في التتبيلة لمدة ٣ ساعات على الأقل لامتصاص النكهة", "شك قطع الدجاج على أسياخ مع الفلفل والبصل بين القطع", "اشوي على نار عالية مع التقليب كل دقيقتين", "ادهن الدجاج بالزبدة المذابة أثناء الشواء للترطيب"],
    tipsEn: ["Marinate chicken with yogurt, garlic, lemon, turmeric, coriander, and paprika", "Marinate chicken for at least 3 hours for flavor absorption", "Thread chicken onto skewers with pepper and onion between pieces", "Grill on high heat turning every 2 minutes", "Baste chicken with melted butter during grilling for moisture"],
    servingAr: ["يقدم ساخناً مع صلصة الثوم والخبز العربي", "رش البقدونس المفروم والفلفل الأسود", "يقدم مع البطاطس المقلية والسلطة", "اعصر الليمون الطازج فوق الدجاج"],
    servingEn: ["Serve hot with garlic sauce and Arabic bread", "Sprinkle chopped parsley and black pepper", "Serve with fries and salad", "Squeeze fresh lemon over chicken"],
    time: 40,
    servings: 4,
    image: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?auto=format&fit=crop&w=800",
    nutrition: { calories: 260, protein: 34, carbs: 5, fat: 11, fiber: 0.5, sodium: 500, calcium: 60 },
  },
  {
    id: "lamb_ribs_grilled",
    nameAr: "أضلع خروف مشوية",
    nameEn: "Grilled Lamb Ribs",
    nameDe: "Gegrillte Lammrippen",
    nameRu: "Жареные рёбра ягнёнка",
    namePt: "Costelas de cordeiro grelhadas",
    category: "grilled",
    requiredIngredients: ["lamb", "garlic", "olive_oil", "lemon"],
    optionalIngredients: ["onion", "pepper"],
    ingredientQuantities: { lamb: { amount: 800, unit: "جرام" }, garlic: { amount: 4, unit: "فص" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, lemon: { amount: 1, unit: "حبة" } },
    stepsAr: ["نتبل الأضلع بمزيج الثوم والليمون وزيت الزيتون والبهارات", "نتركها تتبل لمدة ساعتين في الثلاجة", "نشوي على فحم هادئ لمدة ٢٠ دقيقة مع التقليب المستمر", "نتأكد من نضجها الكامل من الداخل", "نقدم مع الأرز والسلطة والليمون"],
    stepsEn: ["Marinate ribs with garlic, lemon, olive oil, and spices", "Refrigerate for 2 hours", "Grill over low charcoal for 20 minutes, turning constantly", "Ensure fully cooked inside", "Serve with rice, salad, and lemon"],
    time: 45,
    servings: 4,
    image: "https://images.unsplash.com/photo-1527477396000-e27163b481c2?auto=format&fit=crop&w=800",
    nutrition: { calories: 380, protein: 32, carbs: 2, fat: 27, fiber: 0, sodium: 420, calcium: 30 },
  },
  {
    id: "grilled_corn",
    nameAr: "ذرة مشوية",
    nameEn: "Grilled Corn",
    nameDe: "Gegrillter Mais",
    nameRu: "Жареная кукуруза",
    namePt: "Milho grelhado",
    category: "grilled",
    requiredIngredients: ["corn", "butter", "salt"],
    optionalIngredients: ["lemon", "paprika"],
    ingredientQuantities: { corn: { amount: 4, unit: "كوز" }, butter: { amount: 50, unit: "جرام" } },
    stepsAr: ["نقشر الذرة ونزيل الخيوط بالكامل", "ندهن كل كوز بالزبدة المذابة والملح", "نشوي على الجريل الساخن ١٥ دقيقة مع التدوير", "نضغط عليها ونتأكد أن الحبوب ذهبية", "نقدم مع الليمون والفلفل الحار"],
    stepsEn: ["Peel corn and remove all silk", "Brush each cob with melted butter and salt", "Grill on hot grill 15 minutes while rotating", "Press and ensure kernels are golden", "Serve with lemon and chili pepper"],
    time: 20,
    servings: 4,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 150, protein: 4, carbs: 28, fat: 5, fiber: 3.5, sodium: 120, calcium: 10 },
  },
  {
    id: "grilled_vegetables",
    nameAr: "خضار مشوية",
    nameEn: "Grilled Vegetables",
    nameDe: "Gegrilltes Gemüse",
    nameRu: "Овощи на гриле",
    namePt: "Legumes grelhados",
    category: "grilled",
    requiredIngredients: ["pepper", "zucchini", "onion", "olive_oil"],
    optionalIngredients: ["eggplant", "tomato", "mushroom"],
    ingredientQuantities: { pepper: { amount: 2, unit: "حبة" }, zucchini: { amount: 2, unit: "حبة" }, onion: { amount: 1, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نقطع جميع الخضار إلى شرائح سميكة", "نتبل بزيت الزيتون والثوم والأعشاب والملح والفلفل", "نشوي كل نوع على حدة على نار عالية", "الفلفل والكوسا ٤ دقائق، الباذنجان ٥ دقائق من كل جانب", "نرص على طبق ونرش بالأعشاب الطازجة"],
    stepsEn: ["Cut all vegetables into thick slices", "Season with olive oil, garlic, herbs, salt, and pepper", "Grill each type separately on high heat", "Peppers and zucchini 4 min, eggplant 5 min each side", "Arrange on plate and sprinkle with fresh herbs"],
    time: 25,
    servings: 4,
    image: "images/recipes/pexels-1059905-800.jpeg",
    nutrition: { calories: 90, protein: 2.5, carbs: 12, fat: 4, fiber: 4, sodium: 25, calcium: 30 },
  },
  {
    id: "grilled_steak",
    nameAr: "ستيك مشوي",
    nameEn: "Grilled Steak",
    nameDe: "Gegrilltes Steak",
    nameRu: "Стейк на гриле",
    namePt: "Steak grelhado",
    category: "grilled",
    requiredIngredients: ["beef", "garlic", "olive_oil", "salt"],
    optionalIngredients: ["butter", "onion"],
    ingredientQuantities: { beef: { amount: 600, unit: "جرام" }, garlic: { amount: 3, unit: "فص" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نخرج الستيك من الثلاجة قبل ٣٠ دقيقة ليصل لدرجة حرارة الغرفة", "ندهن بزيت الزيتون ونتبل بالملح والفلفل الأسود", "نسخن الجريل على أعلى درجة حرارة", "نشوي ٣-٤ دقائق من كل جانب للنضج المتوسط", "نترك الستيك يرتاح ٥ دقائق قبل التقديم"],
    stepsEn: ["Remove steak from fridge 30 min before to reach room temperature", "Brush with olive oil and season with salt and black pepper", "Heat grill to highest temperature", "Grill 3-4 minutes each side for medium doneness", "Let steak rest 5 minutes before serving"],
    time: 20,
    servings: 2,
    image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=800",
    nutrition: { calories: 320, protein: 36, carbs: 0, fat: 19, fiber: 0, sodium: 380, calcium: 15 },
  },
  {
    id: "chicken_wings_grilled",
    nameAr: "أجنحة دجاج مشوية",
    nameEn: "Grilled Chicken Wings",
    nameDe: "Gegrillte Hühnerflügel",
    nameRu: "Куриные крылья на гриле",
    namePt: "Asas de frango grelhadas",
    category: "grilled",
    requiredIngredients: ["chicken", "garlic", "lemon", "olive_oil"],
    optionalIngredients: ["paprika", "onion"],
    ingredientQuantities: { chicken: { amount: 1000, unit: "جرام" }, garlic: { amount: 4, unit: "فص" }, lemon: { amount: 2, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نتبل الأجنحة بالثوم والليمون والزيت والكركم والبهارات", "نتركها تتبل ساعتين في الثلاجة", "نشوي على جريل ساخن ١٥ دقيقة مع التقليب المستمر", "نتأكد من نضج الأجنحة بالكامل ويصبح لونها ذهبياً", "نقدم مع صلصة الثوم والليمون"],
    stepsEn: ["Marinate wings with garlic, lemon, oil, turmeric, and spices", "Refrigerate for 2 hours", "Grill on hot grill 15 minutes turning constantly", "Ensure wings are fully cooked and golden", "Serve with garlic and lemon sauce"],
    time: 35,
    servings: 4,
    image: "https://images.unsplash.com/photo-1565299507177-b0ac66763828?auto=format&fit=crop&w=800",
    nutrition: { calories: 220, protein: 20, carbs: 2, fat: 14, fiber: 0, sodium: 380, calcium: 20 },
  },
  {
    id: "grilled_lamb_chops",
    nameAr: "كستليتا خروف مشوية",
    nameEn: "Grilled Lamb Chops",
    nameDe: "Gegrillte Lammkoteletts",
    nameRu: "Жареные бараньи отбивные",
    namePt: "Costeletas de cordeiro grelhadas",
    category: "grilled",
    requiredIngredients: ["lamb", "garlic", "rosemary", "olive_oil"],
    optionalIngredients: ["lemon", "pepper"],
    ingredientQuantities: { lamb: { amount: 700, unit: "جرام" }, garlic: { amount: 4, unit: "فص" }, rosemary: { amount: 2, unit: "غصن" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نتبل كستليتا الخروف بالثوم وإكليل الجبل وزيت الزيتون", "نتركها تتبل ساعة في الثلاجة", "نسخن الجريل على نار عالية", "نشوي ٤ دقائق من كل جانب", "نقدم مع البطاطس المشوية والسلطة"],
    stepsEn: ["Marinate lamb chops with garlic, rosemary, and olive oil", "Refrigerate for 1 hour", "Heat grill on high", "Grill 4 minutes each side", "Serve with grilled potatoes and salad"],
    time: 30,
    servings: 4,
    image: "https://images.unsplash.com/photo-1603048719571-3f24c3a35b21?auto=format&fit=crop&w=800",
    nutrition: { calories: 360, protein: 30, carbs: 2, fat: 26, fiber: 0, sodium: 400, calcium: 25 },
  },
  {
    id: "grilled_sausage",
    nameAr: "نقانق مشوية",
    nameEn: "Grilled Sausage",
    nameDe: "Gegrillte Würstchen",
    nameRu: "Жареные сосиски",
    namePt: "Salsicha grelhada",
    category: "grilled",
    requiredIngredients: ["sausage", "onion", "olive_oil"],
    optionalIngredients: ["pepper", "garlic"],
    ingredientQuantities: { sausage: { amount: 8, unit: "حبة" }, onion: { amount: 1, unit: "حبة" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نسخن الجريل على نار متوسطة", "نشوي النقانق ١٠ دقائق مع التقليب", "نضيف شرائح البصل والفلفل ونشويها", "نتأكد من نضج النقانق بالكامل", "نقدم مع الخبز والصلصة"],
    stepsEn: ["Heat grill on medium", "Grill sausages 10 minutes turning", "Add onion and pepper slices and grill", "Ensure sausages are fully cooked", "Serve with bread and sauce"],
    time: 20,
    servings: 4,
    image: "https://images.unsplash.com/photo-1432139509613-5c4255815697?auto=format&fit=crop&w=800",
    nutrition: { calories: 300, protein: 16, carbs: 5, fat: 24, fiber: 1, sodium: 720, calcium: 15 },
  },
  {
    id: "grilled_kebab_veal",
    nameAr: "كباب لحم عجل",
    nameEn: "Veal Kebab",
    nameDe: "Kalb-Kebab",
    nameRu: "Кебаб из телятины",
    namePt: "Kebab de vitela",
    category: "grilled",
    requiredIngredients: ["veal", "onion", "garlic", "olive_oil"],
    optionalIngredients: ["parsley", "pepper"],
    ingredientQuantities: { veal: { amount: 700, unit: "جرام" }, onion: { amount: 2, unit: "حبة" }, garlic: { amount: 4, unit: "فص" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نفرم اللحم مع البصل والثوم فرماً ناعماً", "نضيف البقدونس والبهارات والملح ونعجن جيداً", "نشكل الكباب على أسياخ", "نشوي على نار قوية ٥ دقائق من كل جانب", "نقدم مع الطماطم والبصل والخبز"],
    stepsEn: ["Mince veal with onion and garlic finely", "Add parsley, spices, and salt and knead well", "Shape kebab onto skewers", "Grill on high heat 5 minutes each side", "Serve with tomato, onion, and bread"],
    time: 35,
    servings: 4,
    image: "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?auto=format&fit=crop&w=800",
    nutrition: { calories: 320, protein: 35, carbs: 4, fat: 18, fiber: 1, sodium: 450, calcium: 20 },
  },
  {
    id: "grilled_quail",
    nameAr: "سمان مشوي",
    nameEn: "Grilled Quail",
    nameDe: "Gegrillte Wachteln",
    nameRu: "Жареные перепела",
    namePt: "Codorniz grelhada",
    category: "grilled",
    requiredIngredients: ["quail", "garlic", "lemon", "olive_oil"],
    optionalIngredients: ["pepper", "paprika"],
    ingredientQuantities: { quail: { amount: 6, unit: "حبة" }, garlic: { amount: 4, unit: "فص" }, lemon: { amount: 2, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["ننظف السمان ونتبله بالثوم والليمون وزيت الزيتون", "نتركه يتبل ساعتين", "نسخن الجريل على نار متوسطة", "نشوي ١٠ دقائق من كل جانب حتى يحمر", "نقدم مع البطاطس والسلطة"],
    stepsEn: ["Clean quail and marinate with garlic, lemon, and olive oil", "Rest 2 hours", "Heat grill on medium", "Grill 10 minutes each side until golden", "Serve with potatoes and salad"],
    time: 35,
    servings: 3,
    image: "https://images.unsplash.com/photo-1606755962773-d324e0a8f0e1?auto=format&fit=crop&w=800",
    nutrition: { calories: 250, protein: 28, carbs: 2, fat: 14, fiber: 0, sodium: 360, calcium: 25 },
  },
  {
    id: "grilled_portobello",
    nameAr: "فطر بورتوبيلو مشوي",
    nameEn: "Grilled Portobello",
    nameDe: "Gegrillte Portobello",
    nameRu: "Жареные портобелло",
    namePt: "Portobello grelhado",
    category: "grilled",
    requiredIngredients: ["mushroom", "garlic", "olive_oil", "balsamic"],
    optionalIngredients: ["cheese", "parsley"],
    ingredientQuantities: { mushroom: { amount: 4, unit: "حبة" }, garlic: { amount: 3, unit: "فص" }, olive_oil: { amount: 3, unit: "ملعقة ك." }, balsamic: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["ننظف الفطر ونزع السيقان", "نخلط زيت الزيتون والثوم والخل البلسمي", "ندهن الفطر بالمزيج ونتركه ١٥ دقيقة", "نشوي ٥ دقائق من كل جانب", "نرش الجبن والبقدونس ونقدم"],
    stepsEn: ["Clean mushrooms and remove stems", "Mix olive oil, garlic, and balsamic", "Brush mushrooms and rest 15 minutes", "Grill 5 minutes each side", "Sprinkle cheese and parsley and serve"],
    time: 25,
    servings: 4,
    image: "https://images.unsplash.com/photo-1526173462348-7c1ef4e6c0c3?auto=format&fit=crop&w=800",
    nutrition: { calories: 120, protein: 5, carbs: 8, fat: 8, fiber: 3, sodium: 180, calcium: 30 },
  },
  {
    id: "grilled_eggplant_babaganoush",
    nameAr: "بابا غنوج مشوي",
    nameEn: "Grilled Eggplant Baba Ganoush",
    nameDe: "Gegrillte Aubergine Baba Ganoush",
    nameRu: "Баба гануш на гриле",
    namePt: "Baba Ganoush grelhado",
    category: "grilled",
    requiredIngredients: ["eggplant", "tahini", "garlic", "lemon"],
    optionalIngredients: ["olive_oil", "parsley"],
    ingredientQuantities: { eggplant: { amount: 3, unit: "حبة" }, tahini: { amount: 3, unit: "ملعقة ك." }, garlic: { amount: 3, unit: "فص" }, lemon: { amount: 1, unit: "حبة" } },
    stepsAr: ["نشوي الباذنجان على الجريل حتى يتفحم الجلد", "نقشره ونهرس اللب", "نخلط الطحينة والثوم والليمون", "نضيف الباذنجان ونخلط جيداً", "نزين بزيت الزيتون والبقدونس"],
    stepsEn: ["Grill eggplant until skin is charred", "Peel and mash the flesh", "Mix tahini, garlic, and lemon", "Add eggplant and mix well", "Garnish with olive oil and parsley"],
    time: 30,
    servings: 4,
    image: "https://images.unsplash.com/photo-1604152135912-04a0c1f0b1c3?auto=format&fit=crop&w=800",
    nutrition: { calories: 140, protein: 4, carbs: 12, fat: 9, fiber: 5, sodium: 220, calcium: 60 },
  },
  // SEAFOOD
  {
    id: "grilled_fish",
    nameAr: "سمك مشوي",
    nameEn: "Grilled Fish",
    nameDe: "Gegrillter Fisch",
    nameRu: "Рыба гриль",
    namePt: "Peixe grelhado",
    category: "seafood",
    requiredIngredients: ["fish", "lemon", "garlic", "olive_oil"],
    optionalIngredients: ["onion", "pepper"],
    ingredientQuantities: { fish: { amount: 800, unit: "جرام" }, lemon: { amount: 2, unit: "حبة" }, garlic: { amount: 3, unit: "فص" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["ننظف السمك ونشق جانبيه", "نتبل بالليمون والثوم وزيت الزيتون", "نشوي على نار عالية ٧ دقائق من كل جانب", "نتحقق من النضج - يجب أن يتفتت اللحم بسهولة", "نقدم مع السلطة والخبز"],
    stepsEn: ["Clean fish and score both sides", "Marinate with lemon, garlic, and olive oil", "Grill on high heat 7 minutes each side", "Check doneness - flesh should flake easily", "Serve with salad and bread"],
    time: 25,
    servings: 2,
    image: "images/recipes/pexels-17010948-800.jpeg",
    nutrition: { calories: 240, protein: 32, carbs: 2, fat: 12, fiber: 0, sodium: 340, calcium: 50 },
  },
  {
    id: "shrimp_garlic",
    nameAr: "روبيان بالثوم",
    nameEn: "Garlic Shrimp",
    nameDe: "Knoblauch-Garnelen",
    nameRu: "Креветки с чесноком",
    namePt: "Camarão ao alho",
    category: "seafood",
    requiredIngredients: ["shrimp", "garlic", "butter", "lemon"],
    optionalIngredients: ["olive_oil", "onion"],
    ingredientQuantities: { shrimp: { amount: 500, unit: "جرام" }, garlic: { amount: 5, unit: "فص" }, butter: { amount: 50, unit: "جرام" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نسلق الروبيان لمدة دقيقتين في ماء مملح", "نذيب الزبدة في المقلاة ونضيف الثوم", "نضيف الروبيان ونطهي على نار متوسطة لدقيقتين", "نضيف عصير الليمون والأعشاب", "نقدم مباشرة مع الخبز"],
    stepsEn: ["Blanch shrimp for 2 minutes in salted water", "Melt butter in pan and add garlic", "Add shrimp and cook on medium heat for 2 minutes", "Add lemon juice and herbs", "Serve immediately with bread"],
    time: 15,
    servings: 2,
    image: "images/recipes/pexels-699544-800.jpeg",
    nutrition: { calories: 180, protein: 22, carbs: 3, fat: 9, fiber: 0, sodium: 520, calcium: 80 },
  },
  {
    id: "salmon_salad",
    nameAr: "سلمون مع السلطة",
    nameEn: "Salmon Salad",
    nameDe: "Lachssalat",
    nameRu: "Салат с лососем",
    namePt: "Salada de salmão",
    category: "seafood",
    requiredIngredients: ["salmon", "cucumber", "tomato", "lemon"],
    optionalIngredients: ["olive_oil", "onion"],
    ingredientQuantities: { salmon: { amount: 400, unit: "جرام" }, lemon: { amount: 1, unit: "حبة" }, olive_oil: { amount: 3, unit: "ملعقة ك." } },
    stepsAr: ["نشوي السلمون مع الليمون وزيت الزيتون", "نقطع الخيار والطماطم والبصل", "نعد صلصة الليمون وزيت الزيتون", "نضع السلطة ونضع السلمون فوقها", "نسكب الصلصة ونقدم"],
    stepsEn: ["Grill salmon with lemon and olive oil", "Chop cucumber, tomato, and onion", "Prepare lemon and olive oil dressing", "Arrange salad and place salmon on top", "Pour dressing and serve"],
    time: 20,
    servings: 2,
    image: "images/recipes/pexels-19870752-800.jpeg",
    nutrition: { calories: 310, protein: 28, carbs: 8, fat: 18, fiber: 3, sodium: 300, calcium: 45 },
  },
  {
    id: "kunafa",
    nameAr: "كنافة",
    nameEn: "Kunafa",
    nameDe: "Kunafa",
    nameRu: "Кунафа",
    namePt: "Kunafa",
    category: "pastries",
    requiredIngredients: ["kunafa_dough", "cheese", "butter", "sugar"],
    optionalIngredients: ["honey"],
    ingredientQuantities: { kunafa_dough: { amount: null, unit: "غير محدد" }, cheese: { amount: 500, unit: "جرام" }, butter: { amount: 150, unit: "جرام" }, sugar: { amount: 250, unit: "جرام" } },
    ingredientCompleteness: "unverified",
    stepsAr: ["نفرد عجينة الكنافة ونقسمها لنصفين", "ندهن الصينية بالزبدة ونضع النصف الأول", "نوزع الجبن بالتساوي فوق العجينة", "نضع النصف الثاني من العجينة ونضغط بلطف", "نخبز على ٢٠٠ درجة ٣٠ دقيقة حتى تحمر ثم نسكب القطر"],
    stepsEn: ["Spread kunafa dough and divide in half", "Butter the pan and place first half", "Distribute cheese evenly over dough", "Place second half and press gently", "Bake at 200°C for 30 minutes until golden then pour syrup"],
    ovenTempAr: "فرن ساخن (٢٠٠°م) لمدة ٣٠ دقيقة حتى يحمر السطح",
    ovenTempEn: "Hot oven (200°C) for 30 minutes until surface browns",
    tipsAr: ["ادهن الصينية بالزبدة جيداً قبل وضع العجينة لتفادي الالتصاق", "استخدم جبن العكاوي أو الموزاريلا للقوام المطاطي", "أضف ملعقة صغيرة من ماء الزهر للقطر للنكهة العطرية", "اسكب القطر الساخن على الكنافة فور إخراجها من الفرن", "غطي الكنافة بورق الألمنيوم في أول ٢٠ دقيقة ثم اكشفها للتحمير"],
    tipsEn: ["Butter the pan thoroughly before placing dough to prevent sticking", "Use akkawi or mozzarella cheese for stretchy texture", "Add a teaspoon of orange blossom water to syrup for aromatic flavor", "Pour hot syrup over kunafa immediately after removing from oven", "Cover kunafa with foil for first 20 minutes then uncover for browning"],
    servingAr: ["يقدم ساخناً أو دافئاً في طبق كبير", "رش الفستق الحلبي المطحون والقطر", "يقدم مع كوب شاي أو قهوة", "قطعها إلى مربعات متساوية قبل التقديم"],
    servingEn: ["Serve hot or warm in a large plate", "Sprinkle ground pistachios and syrup", "Serve with a cup of tea or coffee", "Cut into equal squares before serving"],
    time: 50,
    servings: 12,
    image: "images/recipes/pexels-6271902-800.jpeg",
    nutrition: { calories: 320, protein: 8, carbs: 42, fat: 14, fiber: 1, sodium: 310, calcium: 200 },
  },
  {
    id: "umm_ali",
    nameAr: "أم علي",
    nameEn: "Umm Ali",
    nameDe: "Umm Ali",
    nameRu: "Умм Али",
    namePt: "Umm Ali",
    category: "pastries",
    requiredIngredients: ["milk", "sugar", "butter"],
    optionalIngredients: ["honey", "eggs"],
    ingredientQuantities: { milk: { amount: 1, unit: "لتر" }, sugar: { amount: 4, unit: "ملعقة ك." }, butter: { amount: 50, unit: "جرام" } },
    stepsAr: ["نفرد العجين الورقي ونخبزه حتى يتفتت", "نحطم العجين المخبوز في صينية عميقة", "نضيف المكسرات والزبيب وجوز الهند المبشور", "نسكب الحليب المحلى الساخن فوق الخليط", "ندخله الفرن على ١٨٠ درجة ٢٠ دقيقة حتى يتحمر السطح"],
    stepsEn: ["Bake puff pastry until crumbly", "Crumble baked pastry into deep baking dish", "Add nuts, raisins, and shredded coconut", "Pour hot sweetened milk over the mixture", "Bake at 180°C for 20 minutes until top browns"],
    ovenTempAr: "فرن متوسط (١٨٠°م) لمدة ٢٠ دقيقة حتى يحمر السطح",
    ovenTempEn: "Medium oven (180°C) for 20 minutes until top browns",
    tipsAr: ["اخبز العجين الورقي حتى يصبح ذهبياً ومقرمشاً قبل تفتيته", "أضف القشطة أو الكريمة مع الحليب لقوام كريمي", "استخدم المكسرات المشكلة (لوز، جوز، فستق) للقرمشة", "سخن الحليب مع السكر قبل صبه فوق العجين لتفادي التكتل", "رش القرفة والسكر على السطح قبل الخبز للتحمير"],
    tipsEn: ["Bake puff pastry until golden and crispy before crumbling", "Add cream with milk for creamy texture", "Use mixed nuts (almond, walnut, pistachio) for crunch", "Heat milk with sugar before pouring over pastry to avoid clumping", "Sprinkle cinnamon and sugar on top before baking for browning"],
    servingAr: ["يقدم دافئاً في أطباق فردية", "رش المكسرات المفرومة وجوز الهند", "يقدم مع كوب حليب أو شاي", "أضف ملعقة كريمة أو قشطة على الوجه"],
    servingEn: ["Serve warm in individual bowls", "Sprinkle chopped nuts and coconut", "Serve with a glass of milk or tea", "Add a spoonful of cream on top"],
    time: 40,
    servings: 8,
    image: "images/recipes/pexels-5410400-800.jpeg",
    nutrition: { calories: 290, protein: 7, carbs: 38, fat: 13, fiber: 2, sodium: 120, calcium: 180 },
  },
  {
    id: "basbousa",
    nameAr: "بسبوسة",
    nameEn: "Basbousa",
    nameDe: "Basbousa",
    nameRu: "Басбуса",
    namePt: "Basbousa",
    category: "pastries",
    requiredIngredients: ["sugar", "butter", "eggs", "yogurt"],
    optionalIngredients: ["honey"],
    ingredientQuantities: { sugar: { amount: 200, unit: "جرام" }, butter: { amount: 100, unit: "جرام" }, eggs: { amount: 2, unit: "حبة" }, yogurt: { amount: 200, unit: "جرام" } },
    stepsAr: ["نخلط السميد مع السكر والزبدة المذابة والزبادي", "نضيف البيض وخلاصة الورد ومسحوق الخبز", "نسكب الخليط في صينية مدهونة", "نقطعها معينات قبل الخبز ونضع لوزة على كل قطعة", "نخبز ٣٠ دقيقة على ١٨٠ درجة ثم نسكب القطر"],
    stepsEn: ["Mix semolina with sugar, melted butter, and yogurt", "Add eggs, rose water, and baking powder", "Pour batter into greased pan", "Cut into diamonds and top each with an almond before baking", "Bake 30 min at 180°C then pour syrup"],
    ovenTempAr: "فرن متوسط (١٨٠°م) لمدة ٣٠ دقيقة حتى يحمر السطح",
    ovenTempEn: "Medium oven (180°C) for 30 minutes until surface browns",
    tipsAr: ["اخلط السميد مع السكر والزبدة المذابة والزبادي جيداً", "أضف البيض واحدة واحدة مع الخفق المستمر", "أضف ملعقة صغيرة من ماء الزهر والبيكنج باودر", "ادهن الصينية بالزبدة أو الطحينة لتفادي الالتصاق", "قطعها معينات قبل الخبز وضع لوزة على كل قطعة"],
    tipsEn: ["Mix semolina with sugar, melted butter, and yogurt thoroughly", "Add eggs one by one with continuous beating", "Add a teaspoon of orange blossom water and baking powder", "Grease pan with butter or tahini to prevent sticking", "Cut into diamonds before baking and place an almond on each piece"],
    servingAr: ["يقدم دافئاً أو بارداً في طبق كبير", "اسكب القطر الساخن فور إخراجها من الفرن", "رش جوز الهند أو الفستق المطحون", "يقدم مع الشاي أو القهوة"],
    servingEn: ["Serve warm or cold in a large plate", "Pour hot syrup immediately after removing from oven", "Sprinkle coconut or ground pistachios", "Serve with tea or coffee"],
    time: 45,
    servings: 16,
    image: "images/recipes/pexels-19077479-800.jpeg",
    nutrition: { calories: 240, protein: 4, carbs: 36, fat: 10, fiber: 1, sodium: 100, calcium: 60 },
  },
  {
    id: "luqaimat",
    nameAr: "لقيمات",
    nameEn: "Luqaimat",
    nameDe: "Luqaimat",
    nameRu: "Лукаймат",
    namePt: "Luqaimat",
    category: "pastries",
    requiredIngredients: ["flour", "sugar", "eggs"],
    optionalIngredients: ["honey", "butter"],
    ingredientQuantities: { flour: { amount: 2, unit: "كوب" }, sugar: { amount: 2, unit: "ملعقة ك." }, eggs: { amount: 1, unit: "حبة" } },
    stepsAr: ["نخلط الدقيق مع الخميرة والسكر والماء الدافئ", "نترك العجينة ترتاح ٣٠ دقيقة حتى تنتفخ", "نسخن الزيت في وعاء عميق على نار متوسطة", "نسكب العجينة بملعقة صغيرة ونقلي حتى تتحول للون الذهبي", "نقدم فوراً مع العسل والسمسم"],
    stepsEn: ["Mix flour with yeast, sugar, and warm water", "Rest dough 30 minutes until it rises", "Heat oil in deep pot on medium heat", "Drop batter by teaspoon and fry until golden", "Serve immediately with honey and sesame"],
    ovenTempAr: "زيت ساخن (١٧٥°م) على نار متوسطة - ٣ دقائق حتى يصبح ذهبياً",
    ovenTempEn: "Hot oil (175°C) on medium heat - 3 minutes until golden",
    tipsAr: ["اخلط الدقيق مع الخميرة والسكر والماء الدافئ واتركه يرتاح", "لا تفرط في خلط العجينة لتفادي فقدان الهواء", "سخن الزيت جيداً قبل القلي لتفادي التصاق اللقيمات", "اسكب العجينة بملعقة صغيرة مبللة بالماء للحصول على كرات متساوية", "قلّب اللقيمات باستمرار أثناء القلي لتحمير متساو"],
    tipsEn: ["Mix flour with yeast, sugar, and warm water and let rest", "Do not overmix batter to avoid losing air", "Heat oil thoroughly before frying to prevent sticking", "Drop batter with a water-moistened teaspoon for equal balls", "Turn luqaimat continuously during frying for even browning"],
    servingAr: ["يقدم فوراً ساخناً مع العسل أو القطر", "رش السمسم المحمص والقرفة", "يقدم مع الشاي أو القهوة العربية", "أضبها في طبق تقديم مغطى بمنديل ورقي"],
    servingEn: ["Serve immediately hot with honey or syrup", "Sprinkle toasted sesame and cinnamon", "Serve with tea or Arabic coffee", "Arrange in a serving plate lined with paper towel"],
    time: 50,
    servings: 6,
    image: "images/recipes/pexels-5461026-800.jpeg",
    nutrition: { calories: 210, protein: 4, carbs: 30, fat: 9, fiber: 1, sodium: 80, calcium: 30 },
  },
  {
    id: "qatayef",
    nameAr: "قطايف",
    nameEn: "Qatayef",
    nameDe: "Qatayef",
    nameRu: "Катаиф",
    namePt: "Qatayef",
    category: "pastries",
    requiredIngredients: ["flour", "sugar", "cheese"],
    optionalIngredients: ["honey", "butter"],
    ingredientQuantities: { flour: { amount: 2, unit: "كوب" }, sugar: { amount: 3, unit: "ملعقة ك." }, cheese: { amount: 300, unit: "جرام" } },
    stepsAr: ["نحضر عجينة القطايف بخلط الدقيق والخميرة والسكر وتركها ترتاح", "نشوي القطايف على الوجه الواحد فقط على مقلاة جافة", "نحشوها بالجبن أو المكسرات ونطوي الحواف", "نقليها في الزيت الساخن حتى تتحول للون الذهبي", "نقدمها مع القطر أو العسل"],
    stepsEn: ["Prepare qatayef batter with flour, yeast, sugar and let rest", "Cook on one side only on a dry pan", "Fill with cheese or nuts and seal edges", "Fry in hot oil until golden", "Serve with syrup or honey"],
    ovenTempAr: "مقلاة جافة على نار متوسطة (١٦٠°م) لخبز القطايف - زيت ساخن (١٧٥°م) للقلي",
    ovenTempEn: "Dry pan on medium heat (160°C) for baking qatayef - hot oil (175°C) for frying",
    tipsAr: ["اترك عجينة القطايف ترتاح ٣٠ دقيقة حتى تظهر الفقاعات على السطح", "اشوي القطايف على وجه واحد فقط حتى تتكون فقاعات بنية", "احشو القطايف بالجبن أو المكسرات واقفلي الحواف جيداً", "سخن الزيت جيداً قبل القلي لتفادي التصاق القطايف", "اسكب القطر الساخن على القطايف فور إخراجها من الزيت"],
    tipsEn: ["Let qatayef batter rest 30 minutes until bubbles form on surface", "Cook qatayef on one side only until brown bubbles form", "Fill qatayef with cheese or nuts and seal edges tightly", "Heat oil thoroughly before frying to prevent qatayef from sticking", "Pour hot syrup over qatayef immediately after removing from oil"],
    servingAr: ["يقدم ساخناً مع القطر أو العسل", "رش الفستق المطحون وجوز الهند", "يقدم مع الشاي أو القهوة", "أضبها في طبق تقديم كبير"],
    servingEn: ["Serve hot with syrup or honey", "Sprinkle ground pistachios and coconut", "Serve with tea or coffee", "Arrange in a large serving plate"],
    time: 60,
    servings: 8,
    image: "images/recipes/pexels-6419632-800.jpeg",
    nutrition: { calories: 260, protein: 7, carbs: 34, fat: 12, fiber: 1, sodium: 200, calcium: 150 },
  },
  {
    id: "muhallabia",
    nameAr: "مهلبية",
    nameEn: "Muhallabia",
    nameDe: "Muhallabia",
    nameRu: "Мухаллабия",
    namePt: "Muhallabia",
    category: "pastries",
    requiredIngredients: ["milk", "sugar"],
    optionalIngredients: ["honey"],
    ingredientQuantities: { milk: { amount: 1, unit: "لتر" }, sugar: { amount: 5, unit: "ملعقة ك." } },
    stepsAr: ["نخلط الحليب مع نشا الذرة والسكر في قدر", "نضع القدر على نار متوسطة مع التحريك المستمر", "نضيف ماء الورد وخلاصة الهال عند بدء الغليان", "نستمر في التحريك حتى يتكثف الخليط", "نسكب في أوعية صغيرة ونبرد ثم نزين بالمكسرات"],
    stepsEn: ["Mix milk with cornstarch and sugar in pot", "Heat on medium heat stirring constantly", "Add rose water and cardamom extract when boiling", "Keep stirring until mixture thickens", "Pour into cups, cool, then garnish with nuts"],
    ovenTempAr: "نار متوسطة (١٨٠°م) على الموقد مع التحريك المستمر",
    ovenTempEn: "Medium heat (180°C) on stovetop with constant stirring",
    tipsAr: ["ذوب نشا الذرة في القليل من الحليب البارد قبل إضافته للقدر لتفادي التكتل", "حرك الحليب باستمرار من القاع لتفادي الاحتراق", "أضف ماء الزهر وخلاصة الهال عند بدء الغليان", "لا تفرط في الطهي بعد التكثف لتفادي قوام مطاطي", "اسكب المهلبية في أوعية فردية وبردها قبل التقديم"],
    tipsEn: ["Dissolve cornstarch in a little cold milk before adding to pot to avoid clumping", "Stir milk constantly from bottom to avoid burning", "Add rose water and cardamom extract when boiling starts", "Do not overcook after thickening to avoid rubbery texture", "Pour muhallabia into individual cups and cool before serving"],
    servingAr: ["يقدم بارداً في أوعاء فردية", "رش الفستق المطحون واللوز المبشور", "أضف ملعقة من ماء الزهر للزينة", "يقدم مع الشاي أو القهوة"],
    servingEn: ["Serve cold in individual cups", "Sprinkle ground pistachios and slivered almonds", "Add a teaspoon of rose water for garnish", "Serve with tea or coffee"],
    time: 25,
    servings: 6,
    image: "images/recipes/pexels-20692141-800.jpeg",
    nutrition: { calories: 160, protein: 5, carbs: 28, fat: 3, fiber: 0, sodium: 60, calcium: 200 },
  },
  {
    id: "halva",
    nameAr: "حلوى الطحينية",
    nameEn: "Tahini Halva",
    nameDe: "Tahini Halva",
    nameRu: "Тахинная халва",
    namePt: "Halva de tahini",
    category: "pastries",
    requiredIngredients: ["sugar", "butter"],
    optionalIngredients: ["honey"],
    ingredientQuantities: { sugar: { amount: 300, unit: "جرام" }, butter: { amount: 50, unit: "جرام" } },
    stepsAr: ["نذيب السكر مع الماء على نار هادئة حتى يصبح شراباً", "نحرك الطحينة جيداً في وعاء منفصل", "نضيف شراب السكر الساخن للطحينة تدريجياً مع التحريك", "نضيف المكسرات المفرومة ونخلط بسرعة", "نسكب في قالب ونبرد عدة ساعات قبل التقطيع"],
    stepsEn: ["Dissolve sugar in water on low heat to make syrup", "Stir tahini well in separate bowl", "Gradually add hot sugar syrup to tahini while stirring", "Add chopped nuts and mix quickly", "Pour into mold and cool for several hours before cutting"],
    time: 30,
    servings: 20,
    image: "images/recipes/pexels-30710090-800.jpeg",
    nutrition: { calories: 300, protein: 6, carbs: 32, fat: 18, fiber: 2, sodium: 40, calcium: 70 },
  },
  {
    id: "rice_pudding",
    nameAr: "أرز بالحليب",
    nameEn: "Rice Pudding",
    nameDe: "Milchreis",
    nameRu: "Рисовый пудинг",
    namePt: "Arroz com leite",
    category: "pastries",
    requiredIngredients: ["milk", "sugar"],
    optionalIngredients: ["honey", "butter"],
    ingredientQuantities: { milk: { amount: 1, unit: "لتر" }, sugar: { amount: 4, unit: "ملعقة ك." } },
    stepsAr: ["ننقع الأرز لمدة ٣٠ دقيقة ثم نصفيه", "نطبخ الأرز مع الحليب على نار هادئة مع التحريك", "نضيف السكر وماء الزهر والهيل المطحون", "نستمر في التحريك حتى يتكثف المزيج وينضج الأرز", "نسكب في أطباق ونزين بالقرفة أو المكسرات"],
    stepsEn: ["Soak rice for 30 minutes then drain", "Cook rice with milk on low heat stirring frequently", "Add sugar, orange blossom water, and ground cardamom", "Keep stirring until mixture thickens and rice is cooked", "Pour into bowls and garnish with cinnamon or nuts"],
    time: 40,
    servings: 6,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 180, protein: 6, carbs: 30, fat: 4, fiber: 0, sodium: 80, calcium: 220 },
  },
  {
    id: "chocolate_cake",
    nameAr: "كيكة الشوكولاتة",
    nameEn: "Chocolate Cake",
    nameDe: "Schokoladenkuchen",
    nameRu: "Шоколадный торт",
    namePt: "Bolo de chocolate",
    category: "pastries",
    requiredIngredients: ["flour", "sugar", "eggs", "butter", "milk"],
    optionalIngredients: ["honey"],
    ingredientQuantities: { flour: { amount: 2, unit: "كوب" }, sugar: { amount: 250, unit: "جرام" }, eggs: { amount: 3, unit: "حبة" }, butter: { amount: 150, unit: "جرام" }, milk: { amount: 200, unit: "مل" } },
    stepsAr: ["نخفق الزبدة مع السكر حتى يصبح الخليط كريمياً", "نضيف البيض واحدة واحدة مع الاستمرار بالخفق", "نخلط الدقيق مع الكاكاو ومسحوق الخبز", "نضيف المواد الجافة والحليب بالتناوب للخليط", "نخبز في قالب على ١٧٥ درجة لمدة ٣٥ دقيقة"],
    stepsEn: ["Beat butter and sugar until creamy", "Add eggs one by one continuing to beat", "Mix flour with cocoa and baking powder", "Alternately add dry ingredients and milk to batter", "Bake in pan at 175°C for 35 minutes"],
    ovenTempAr: "فرن متوسط (١٧٥°م) لمدة ٣٥ دقيقة - سخن الفرن مسبقاً",
    ovenTempEn: "Medium oven (175°C) for 35 minutes - preheat oven",
    tipsAr: ["خفق الزبدة مع السكر حتى يصبح الخليط كريمياً وفاتح اللون", "أضف البيض واحدة واحدة مع الخفق المستمر", "نخل الدقيق مع الكاكاو والبيكنج باودر لتفادي التكتلات", "أضف المواد الجافة والحليب بالتناوب للخليط", "اختبر النضج بعود خشب قبل إخراجها من الفرن"],
    tipsEn: ["Beat butter with sugar until creamy and light colored", "Add eggs one by one with continuous beating", "Sift flour with cocoa and baking powder to avoid lumps", "Add dry ingredients and milk alternately to batter", "Test doneness with a toothpick before removing from oven"],
    servingAr: ["يقدم دافئاً أو بارداً مع كوب حليب أو قهوة", "زيّن بالكريمة أو الشوكولاتة الذائبة", "رش السكر البودرة والكاكاو", "يقدم مع كرة آيس كريم الفانيليا"],
    servingEn: ["Serve warm or cold with a glass of milk or coffee", "Garnish with cream or melted chocolate", "Sprinkle powdered sugar and cocoa", "Serve with a scoop of vanilla ice cream"],
    time: 55,
    servings: 10,
    image: "images/recipes/pexels-291528-800.jpeg",
    nutrition: { calories: 350, protein: 5, carbs: 48, fat: 17, fiber: 2, sodium: 180, calcium: 60 },
  },

  // JUICES & BEVERAGES
  {
    id: "lemonade",
    nameAr: "عصير الليمون الطازج",
    nameEn: "Fresh Lemonade",
    nameDe: "Frische Limonade",
    nameRu: "Свежий лимонад",
    namePt: "Limonada fresca",
    category: "juices",
    requiredIngredients: ["lemon_juice", "water", "sugar"],
    optionalIngredients: ["mint"],
    ingredientQuantities: { lemon_juice: { amount: 4, unit: "حبة ليمون" }, water: { amount: 1, unit: "لتر" }, sugar: { amount: 4, unit: "ملعقة ك." }, mint: { amount: 10, unit: "ورقة" } },
    stepsAr: ["نعصر الليمون ونصفي العصير", "نذيب السكر في كوب ماء دافئ لتحضير شراب السكر", "نمزج عصير الليمون مع الماء البارد وشراب السكر", "نضيف أوراق النعناع الطازج ونحرك جيداً", "نقدم على الثلج مع شرائح الليمون"],
    stepsEn: ["Squeeze lemons and strain the juice", "Dissolve sugar in a cup of warm water to make simple syrup", "Mix lemon juice with cold water and simple syrup", "Add fresh mint leaves and stir well", "Serve over ice with lemon slices"],
    time: 10,
    servings: 4,
    image: "images/recipes/pexels-2109099-800.jpeg",
    nutrition: { calories: 60, protein: 0, carbs: 16, fat: 0, fiber: 0, sodium: 5, calcium: 8 },
  },
  {
    id: "mango_smoothie",
    nameAr: "عصير المانجو الكريمي",
    nameEn: "Creamy Mango Smoothie",
    nameDe: "Cremiger Mango-Smoothie",
    nameRu: "Сливочный смузи из манго",
    namePt: "Smoothie cremoso de manga",
    category: "juices",
    requiredIngredients: ["mango", "milk_drink", "sugar"],
    optionalIngredients: ["yogurt", "lemon_juice"],
    ingredientQuantities: { mango: { amount: 2, unit: "حبة" }, milk_drink: { amount: 1, unit: "كوب" }, sugar: { amount: 2, unit: "ملعقة ك." }, yogurt: { amount: 0.5, unit: "كوب" } },
    stepsAr: ["نقشر المانجو ونقطعها إلى مكعبات", "نضع قطع المانجو في الخلاط مع الحليب والسكر", "نضيف الزبادي للقوام الكريمي", "نخلط جيداً حتى يصبح ناعماً ومتجانساً", "نقدم مبرداً مع الثلج"],
    stepsEn: ["Peel mango and cut into cubes", "Place mango in blender with milk and sugar", "Add yogurt for creamy texture", "Blend well until smooth and homogeneous", "Serve chilled with ice"],
    time: 8,
    servings: 2,
    image: "images/recipes/pexels-14509267-800.jpeg",
    nutrition: { calories: 175, protein: 4, carbs: 38, fat: 2, fiber: 3, sodium: 50, calcium: 130 },
  },
  {
    id: "watermelon_juice",
    nameAr: "عصير البطيخ المنعش",
    nameEn: "Refreshing Watermelon Juice",
    nameDe: "Erfrischender Wassermelonensaft",
    nameRu: "Освежающий сок арбуза",
    namePt: "Suco refrescante de melancia",
    category: "juices",
    requiredIngredients: ["watermelon", "lemon_juice"],
    optionalIngredients: ["mint", "sugar", "water"],
    ingredientQuantities: { watermelon: { amount: 1, unit: "كيلو" }, lemon_juice: { amount: 2, unit: "ملعقة ك." }, mint: { amount: 8, unit: "ورقة" } },
    stepsAr: ["نقطع البطيخ ونزيل البذور والقشر", "نضع قطع البطيخ في الخلاط", "نضيف عصير الليمون وبعض أوراق النعناع", "نخلط حتى يصبح سائلاً", "نصفي ونقدم على الثلج مباشرةً"],
    stepsEn: ["Cut watermelon and remove seeds and rind", "Place watermelon pieces in blender", "Add lemon juice and a few mint leaves", "Blend until liquid", "Strain and serve over ice immediately"],
    time: 8,
    servings: 3,
    image: "images/recipes/pexels-11009203-800.jpeg",
    nutrition: { calories: 45, protein: 1, carbs: 11, fat: 0, fiber: 1, sodium: 3, calcium: 10 },
  },
  {
    id: "strawberry_banana_smoothie",
    nameAr: "سموثي الفراولة والموز",
    nameEn: "Strawberry Banana Smoothie",
    nameDe: "Erdbeer-Bananen-Smoothie",
    nameRu: "Смузи из клубники и банана",
    namePt: "Smoothie de morango e banana",
    category: "juices",
    requiredIngredients: ["strawberry", "banana", "milk_drink"],
    optionalIngredients: ["yogurt", "honey", "sugar"],
    ingredientQuantities: { strawberry: { amount: 200, unit: "جرام" }, banana: { amount: 2, unit: "حبة" }, milk_drink: { amount: 1, unit: "كوب" }, honey: { amount: 1, unit: "ملعقة ك." } },
    stepsAr: ["نغسل الفراولة ونزيل عيدانها", "نقشر الموز ونقطعه إلى شرائح", "نضع جميع المكونات في الخلاط", "نضيف العسل وقليل من الثلج", "نخلط حتى ناعم ونقدم فوراً"],
    stepsEn: ["Wash strawberries and remove stems", "Peel banana and slice", "Place all ingredients in blender", "Add honey and some ice", "Blend until smooth and serve immediately"],
    time: 7,
    servings: 2,
    image: "images/recipes/pexels-3727250-800.jpeg",
    nutrition: { calories: 165, protein: 5, carbs: 35, fat: 2, fiber: 4, sodium: 55, calcium: 145 },
  },
  {
    id: "orange_carrot_juice",
    nameAr: "عصير البرتقال والجزر",
    nameEn: "Orange Carrot Juice",
    nameDe: "Orangen-Karotten-Saft",
    nameRu: "Апельсиново-морковный сок",
    namePt: "Suco de laranja e cenoura",
    category: "juices",
    requiredIngredients: ["orange_juice", "carrot", "lemon_juice"],
    optionalIngredients: ["ginger", "water", "sugar"],
    ingredientQuantities: { orange_juice: { amount: 4, unit: "برتقالة" }, carrot: { amount: 3, unit: "حبة" }, lemon_juice: { amount: 1, unit: "ملعقة ك." }, ginger: { amount: 1, unit: "ملعقة صغ." } },
    stepsAr: ["نعصر البرتقال ونحتفظ بالعصير", "نقشر الجزر ونضعه في الخلاط مع القليل من الماء", "نخلط الجزر حتى يصبح سائلاً ونصفيه", "نمزج عصير البرتقال مع عصير الجزر وعصير الليمون", "نضيف قليلاً من الزنجبيل المبشور ونقدم بارداً"],
    stepsEn: ["Squeeze oranges and keep the juice", "Peel carrots and place in blender with a little water", "Blend carrots until liquid and strain", "Mix orange juice with carrot juice and lemon juice", "Add a little grated ginger and serve cold"],
    time: 12,
    servings: 2,
    image: "images/recipes/pexels-8228297-800.jpeg",
    nutrition: { calories: 95, protein: 2, carbs: 22, fat: 0, fiber: 4, sodium: 80, calcium: 55 },
  },
  {
    id: "hibiscus_drink",
    nameAr: "مشروب الكركديه البارد",
    nameEn: "Cold Hibiscus Drink",
    nameDe: "Kalter Hibiskustee",
    nameRu: "Холодный напиток каркаде",
    namePt: "Bebida fria de hibisco",
    category: "juices",
    requiredIngredients: ["hibiscus", "water", "sugar"],
    optionalIngredients: ["lemon_juice", "rose_water"],
    ingredientQuantities: { hibiscus: { amount: 3, unit: "ملعقة ك." }, water: { amount: 1, unit: "لتر" }, sugar: { amount: 5, unit: "ملعقة ك." }, lemon_juice: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نغلي الماء ونضيف أزهار الكركديه ونتركها تنقع ١٠ دقائق", "نصفي المشروب ونذيب فيه السكر وهو ساخن", "نضيف عصير الليمون ونحرك جيداً", "نتركه يبرد ثم نضعه في الثلاجة", "نقدم بارداً مع قطع الثلج وشرائح الليمون"],
    stepsEn: ["Boil water, add hibiscus flowers and steep for 10 minutes", "Strain drink and dissolve sugar while hot", "Add lemon juice and stir well", "Let cool then refrigerate", "Serve cold with ice cubes and lemon slices"],
    time: 20,
    servings: 4,
    image: "images/recipes/pexels-5947043-800.jpeg",
    nutrition: { calories: 70, protein: 0, carbs: 18, fat: 0, fiber: 0, sodium: 4, calcium: 6 },
  },
  {
    id: "avocado_milk",
    nameAr: "عصير الأفوكادو بالحليب",
    nameEn: "Avocado Milk Shake",
    nameDe: "Avocado-Milchshake",
    nameRu: "Молочный коктейль с авокадо",
    namePt: "Milk shake de abacate",
    category: "juices",
    requiredIngredients: ["avocado", "milk_drink", "honey"],
    optionalIngredients: ["sugar", "lemon_juice"],
    ingredientQuantities: { avocado: { amount: 2, unit: "حبة" }, milk_drink: { amount: 1.5, unit: "كوب" }, honey: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نقشر الأفوكادو ونزيل النواة ونقطعها", "نضع قطع الأفوكادو في الخلاط مع الحليب البارد", "نضيف العسل حسب الرغبة", "نخلط حتى يصبح كريمياً وناعماً", "نقدم فوراً مع الثلج أو مبرداً"],
    stepsEn: ["Peel avocado, remove pit, and chop", "Place avocado in blender with cold milk", "Add honey to taste", "Blend until creamy and smooth", "Serve immediately with ice or chilled"],
    time: 7,
    servings: 2,
    image: "images/recipes/pexels-1435735-800.jpeg",
    nutrition: { calories: 230, protein: 5, carbs: 20, fat: 16, fiber: 7, sodium: 50, calcium: 140 },
  },
  {
    id: "pomegranate_juice",
    nameAr: "عصير الرمان الطبيعي",
    nameEn: "Natural Pomegranate Juice",
    nameDe: "Natürlicher Granatapfelsaft",
    nameRu: "Натуральный гранатовый сок",
    namePt: "Suco natural de romã",
    category: "juices",
    requiredIngredients: ["pom_juice", "lemon_juice", "sugar"],
    optionalIngredients: ["water", "rose_water"],
    ingredientQuantities: { pom_juice: { amount: 3, unit: "رمانة" }, lemon_juice: { amount: 1, unit: "ملعقة ك." }, sugar: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نقشر الرمان ونستخرج الحبات", "نضع حبات الرمان في الخلاط ونخلط لثوانٍ قليلة", "نصفي العصير بمصفاة ناعمة", "نضيف عصير الليمون والسكر ونحرك", "نقدم فوراً أو مثلجاً للحفاظ على النكهة"],
    stepsEn: ["Peel pomegranate and extract the seeds", "Place pomegranate seeds in blender and pulse briefly", "Strain juice through a fine strainer", "Add lemon juice and sugar and stir", "Serve immediately or iced to preserve flavor"],
    time: 12,
    servings: 2,
    image: "images/recipes/pexels-17245323-800.jpeg",
    nutrition: { calories: 85, protein: 1, carbs: 21, fat: 0, fiber: 1, sodium: 4, calcium: 10 },
  },
  {
    id: "mint_laban",
    nameAr: "لبن بالنعناع",
    nameEn: "Mint Laban",
    nameDe: "Laban mit Minze",
    nameRu: "Лабан с мятой",
    namePt: "Laban com hortelã",
    category: "juices",
    requiredIngredients: ["laban", "mint", "salt"],
    optionalIngredients: ["water", "cumin"],
    ingredientQuantities: { laban: { amount: 2, unit: "كوب" }, mint: { amount: 8, unit: "ورقة" }, salt: { amount: 0.25, unit: "ملعقة صغ." } },
    stepsAr: ["نضع اللبن في الخلاط مع أوراق النعناع الطازج", "نضيف رشة ملح وبرهة كمون إن أردنا", "نخلط لثوانٍ قليلة حتى يخضر اللون قليلاً", "نصب في كأس مع قطع الثلج", "نزين بورقة نعناع ونقدم مباشرةً"],
    stepsEn: ["Place laban in blender with fresh mint leaves", "Add a pinch of salt and optionally cumin", "Blend briefly until slightly green", "Pour into glass with ice cubes", "Garnish with a mint leaf and serve immediately"],
    time: 5,
    servings: 2,
    image: "images/recipes/pexels-18142603-800.jpeg",
    nutrition: { calories: 60, protein: 4, carbs: 6, fat: 2, fiber: 0, sodium: 200, calcium: 160 },
  },
  {
    id: "tamarind_cooler",
    nameAr: "مشروب التمر الهندي",
    nameEn: "Tamarind Cooler",
    nameDe: "Tamarinden-Kühler",
    nameRu: "Прохладительный напиток из тамаринда",
    namePt: "Refresco de tamarindo",
    category: "juices",
    requiredIngredients: ["tamarind_juice", "water", "sugar"],
    optionalIngredients: ["salt", "lemon_juice"],
    ingredientQuantities: { tamarind_juice: { amount: 100, unit: "جرام عجينة" }, water: { amount: 1, unit: "لتر" }, sugar: { amount: 4, unit: "ملعقة ك." } },
    stepsAr: ["نذيب عجينة التمر الهندي في الماء الدافئ ونصفيها", "نضيف السكر ونحرك حتى يذوب تماماً", "نضغط على اللب المتبقي لاستخراج أكبر قدر من النكهة", "نضيف قليلاً من الملح وعصير الليمون", "نبرد في الثلاجة ونقدم مع كثير من الثلج"],
    stepsEn: ["Dissolve tamarind paste in warm water and strain", "Add sugar and stir until fully dissolved", "Press on remaining pulp to extract maximum flavor", "Add a pinch of salt and lemon juice", "Refrigerate and serve with plenty of ice"],
    time: 15,
    servings: 4,
    image: "images/recipes/pexels-34381588-800.jpeg",
    nutrition: { calories: 80, protein: 1, carbs: 20, fat: 0, fiber: 1, sodium: 80, calcium: 15 },
  },
  {
    id: "date_shake",
    nameAr: "عصير التمر بالحليب",
    nameEn: "Date Milk Shake",
    nameDe: "Dattel-Milchshake",
    nameRu: "Молочный коктейль с финиками",
    namePt: "Milk shake de tâmaras",
    category: "juices",
    requiredIngredients: ["date_fruit", "milk_drink"],
    optionalIngredients: ["honey", "cinnamon", "condensed_milk"],
    ingredientQuantities: { date_fruit: { amount: 10, unit: "حبة" }, milk_drink: { amount: 1.5, unit: "كوب" }, cinnamon: { amount: 0.25, unit: "ملعقة صغ." } },
    stepsAr: ["ننزع نوى التمر وننقعه في الحليب لمدة ١٥ دقيقة", "نضع التمر المنقوع مع الحليب في الخلاط", "نضيف رشة قرفة حسب الرغبة", "نخلط جيداً حتى يصبح ناعماً وكثيفاً", "نقدم بارداً مزيناً بقطعة تمر وقرفة"],
    stepsEn: ["Remove date pits and soak in milk for 15 minutes", "Place soaked dates with milk in blender", "Add a pinch of cinnamon to taste", "Blend well until smooth and thick", "Serve cold garnished with a date piece and cinnamon"],
    time: 20,
    servings: 2,
    image: "images/recipes/pexels-3407778-800.jpeg",
    nutrition: { calories: 200, protein: 5, carbs: 40, fat: 3, fiber: 3, sodium: 55, calcium: 160 },
  },
  {
    id: "green_detox",
    nameAr: "عصير الديتوكس الأخضر",
    nameEn: "Green Detox Juice",
    nameDe: "Grüner Detox-Saft",
    nameRu: "Зелёный детокс-сок",
    namePt: "Suco verde detox",
    category: "juices",
    requiredIngredients: ["spinach", "apple", "lemon_juice", "water"],
    optionalIngredients: ["ginger", "cucumber", "mint"],
    ingredientQuantities: { spinach: { amount: 100, unit: "جرام" }, apple: { amount: 2, unit: "حبة" }, lemon_juice: { amount: 2, unit: "ملعقة ك." }, ginger: { amount: 1, unit: "قطعة صغيرة" } },
    stepsAr: ["نغسل السبانخ والتفاح جيداً", "نقطع التفاح ونزيل بذوره", "نضع السبانخ والتفاح وعصير الليمون والزنجبيل في الخلاط", "نضيف كوب ماء ونخلط جيداً", "نصفي ونقدم فوراً مع الثلج"],
    stepsEn: ["Wash spinach and apples well", "Core and chop apples", "Place spinach, apple, lemon juice, and ginger in blender", "Add a cup of water and blend well", "Strain and serve immediately with ice"],
    time: 8,
    servings: 2,
    image: "images/recipes/pexels-8169572-800.jpeg",
    nutrition: { calories: 70, protein: 2, carbs: 16, fat: 0, fiber: 4, sodium: 40, calcium: 60 },
  },

  // DESSERTS
  {
    id: "umm_ali",
    nameAr: "أم علي",
    nameEn: "Umm Ali",
    category: "desserts",
    requiredIngredients: ["milk", "cream", "bread", "sugar"],
    optionalIngredients: ["coconut", "raisins", "nuts"],
    stepsAr: ["نفتت الخبز في صينية الفرن", "نضيف المكسرات وجوز الهند والزبيب", "نسكب خليط الحليب والكريمة والسكر فوقه", "ندخله الفرن على 200 درجة حتى يذهب", "نقدم ساخناً"],
    stepsEn: ["Crumble bread into baking tray", "Add nuts, coconut and raisins", "Pour milk, cream and sugar mixture over", "Bake at 200°C until golden", "Serve hot"],
    time: 30,
    servings: 6,
    image: "",
    nutrition: { calories: 420, protein: 8, carbs: 52, fat: 20, fiber: 2, sodium: 180, calcium: 150 },
  },
  {
    id: "baklava",
    nameAr: "بقلاوة",
    nameEn: "Baklava",
    category: "desserts",
    requiredIngredients: ["flour", "butter", "sugar", "honey"],
    optionalIngredients: ["nuts", "rose_water", "cinnamon"],
    stepsAr: ["نذيب الزبدة ونرش بين طبقات عجينة الفيلو", "نضع حشوة المكسرات المطحونة والقرفة", "نقطع بشكل معين قبل الخبز", "ندخل الفرن على 180 درجة 35 دقيقة", "نسكب القطر الدافئ فوراً بعد الإخراج"],
    stepsEn: ["Brush melted butter between phyllo layers", "Add ground nut filling with cinnamon", "Cut in diamond shapes before baking", "Bake at 180°C for 35 minutes", "Pour warm syrup immediately after baking"],
    time: 70,
    servings: 20,
    image: "",
    nutrition: { calories: 280, protein: 4, carbs: 34, fat: 15, fiber: 1, sodium: 90, calcium: 25 },
  },
  {
    id: "kunafa",
    nameAr: "كنافة",
    nameEn: "Kunafa",
    category: "desserts",
    requiredIngredients: ["kunafa_dough", "butter", "sugar", "cheese"],
    optionalIngredients: ["rose_water", "cream", "nuts"],
    ingredientCompleteness: "unverified",
    stepsAr: ["نفرد عجينة الكنافة ونبللها بالسمن", "نضع طبقة جبن كريمية أو قشطة في الوسط", "نغطيها بباقي العجينة", "نخبز على 190 درجة حتى تحمر من الأسفل", "نقلب على الصحن ونسكب القطر"],
    stepsEn: ["Spread kunafa dough and mix with ghee", "Add cream cheese or ashta filling in middle", "Cover with remaining dough", "Bake at 190°C until bottom is golden", "Flip onto plate and pour syrup"],
    time: 45,
    servings: 8,
    image: "",
    nutrition: { calories: 380, protein: 7, carbs: 48, fat: 19, fiber: 1, sodium: 240, calcium: 120 },
  },
  {
    id: "basbousa",
    nameAr: "بسبوسة",
    nameEn: "Basbousa",
    category: "desserts",
    requiredIngredients: ["semolina", "sugar", "butter", "yogurt"],
    optionalIngredients: ["coconut", "rose_water", "almonds"],
    stepsAr: ["نخلط السميد والسكر وجوز الهند والسمن", "نضيف الزبادي وماء الورد", "نفرد في صينية مدهونة بالسمن", "نقطع مربعات ونضع لوز على كل قطعة", "نخبز 25 دقيقة ثم نسكب القطر"],
    stepsEn: ["Mix semolina, sugar, coconut and ghee", "Add yogurt and rose water", "Spread in greased tray", "Cut into squares, place almond on each", "Bake 25 minutes then pour syrup"],
    time: 40,
    servings: 16,
    image: "",
    nutrition: { calories: 220, protein: 3, carbs: 32, fat: 9, fiber: 1, sodium: 60, calcium: 35 },
  },
  {
    id: "muhallabia",
    nameAr: "مهلبية",
    nameEn: "Muhallabia",
    category: "desserts",
    requiredIngredients: ["milk", "sugar", "cornmeal"],
    optionalIngredients: ["rose_water", "nuts", "cinnamon"],
    stepsAr: ["نخلط النشا مع قليل من الحليب البارد", "نسخن بقية الحليب مع السكر", "نضيف خليط النشا ونحرك باستمرار حتى يثخن", "نضيف ماء الورد ونسكب في أوعية", "نبرد في الثلاجة ساعتين ونزين بالمكسرات"],
    stepsEn: ["Mix starch with cold milk", "Heat remaining milk with sugar", "Add starch mixture, stir until thick", "Add rose water and pour in bowls", "Refrigerate 2 hours and top with nuts"],
    time: 20,
    servings: 6,
    image: "",
    nutrition: { calories: 180, protein: 4, carbs: 30, fat: 5, fiber: 0, sodium: 55, calcium: 130 },
  },
  {
    id: "qatayef",
    nameAr: "قطايف",
    nameEn: "Qatayef",
    category: "desserts",
    requiredIngredients: ["flour", "sugar", "milk", "baking_powder"],
    optionalIngredients: ["nuts", "cheese", "cream"],
    stepsAr: ["نحضر عجينة القطايف بالطحين والحليب والخميرة", "نصب دوائر صغيرة على المقلاة الجافة", "ننتظر حتى تتشكل فقاعات وتنضج من طرف واحد", "نحشوها بالمكسرات أو الجبن", "نقليها في الزيت أو نخبزها ونسكب القطر"],
    stepsEn: ["Prepare batter with flour, milk and yeast", "Pour small circles on dry pan", "Wait until bubbles form, cooked one side", "Fill with nuts or cheese", "Fry or bake and pour syrup"],
    time: 45,
    servings: 12,
    image: "",
    nutrition: { calories: 195, protein: 4, carbs: 28, fat: 8, fiber: 1, sodium: 85, calcium: 40 },
  },
  {
    id: "luqaimat",
    nameAr: "لقيمات",
    nameEn: "Luqaimat",
    category: "desserts",
    requiredIngredients: ["flour", "sugar", "baking_powder"],
    optionalIngredients: ["honey", "cinnamon", "veg_oil"],
    stepsAr: ["نخلط الطحين والسكر والخميرة والماء الدافئ", "نترك العجينة تختمر 30 دقيقة", "نقلي كرات صغيرة في زيت ساخن", "نرفع حين تصبح ذهبية", "نسكب العسل والقرفة فوقها"],
    stepsEn: ["Mix flour, sugar, yeast and warm water", "Let dough ferment 30 minutes", "Fry small balls in hot oil", "Remove when golden", "Drizzle honey and cinnamon"],
    time: 50,
    servings: 6,
    image: "",
    nutrition: { calories: 310, protein: 4, carbs: 42, fat: 14, fiber: 1, sodium: 70, calcium: 20 },
  },
  {
    id: "halawet_jibn",
    nameAr: "حلاوة الجبن",
    nameEn: "Halawet el Jibn",
    category: "desserts",
    requiredIngredients: ["semolina", "cheese", "sugar"],
    optionalIngredients: ["rose_water", "cream", "nuts"],
    stepsAr: ["نذيب الجبن على نار هادئة", "نضيف السميد والسكر ونحرك حتى تتشكل عجينة", "نفرد العجينة على ورق زبدة", "نحشو بالقشطة أو الكريمة", "نلف ونقطع ونزين بماء الورد"],
    stepsEn: ["Melt cheese on low heat", "Add semolina and sugar, stir until dough forms", "Spread on butter paper", "Fill with ashta or cream", "Roll, cut and garnish with rose water"],
    time: 30,
    servings: 8,
    image: "",
    nutrition: { calories: 290, protein: 8, carbs: 35, fat: 14, fiber: 0, sodium: 200, calcium: 180 },
  },
  {
    id: "rice_pudding",
    nameAr: "أرز بلبن",
    nameEn: "Rice Pudding",
    category: "desserts",
    requiredIngredients: ["rice", "milk", "sugar"],
    optionalIngredients: ["rose_water", "cinnamon", "nuts"],
    stepsAr: ["نغلي الأرز مع الماء حتى يشرب الماء", "نضيف الحليب الساخن تدريجياً ونحرك", "نضيف السكر ونكمل الطهي على نار هادئة", "نضيف ماء الورد ونسكب في أوعية", "نزين بالقرفة والمكسرات"],
    stepsEn: ["Boil rice with water until absorbed", "Gradually add hot milk while stirring", "Add sugar, continue cooking on low heat", "Add rose water and pour into bowls", "Garnish with cinnamon and nuts"],
    time: 40,
    servings: 6,
    image: "",
    nutrition: { calories: 200, protein: 5, carbs: 36, fat: 4, fiber: 0, sodium: 60, calcium: 140 },
  },
  {
    id: "bread_pudding",
    nameAr: "بودينغ الخبز",
    nameEn: "Bread Pudding",
    category: "desserts",
    requiredIngredients: ["bread", "milk", "eggs", "sugar"],
    optionalIngredients: ["vanilla", "cinnamon", "raisins"],
    stepsAr: ["نقطع الخبز مكعبات ونضعه في صينية", "نخلط البيض والحليب والسكر والفانيليا", "نسكب الخليط فوق الخبز وننقعه 15 دقيقة", "نخبز في الفرن 35 دقيقة على 180 درجة", "نقدم دافئاً مع الكريمة"],
    stepsEn: ["Cut bread into cubes and place in tray", "Mix eggs, milk, sugar and vanilla", "Pour over bread, soak 15 minutes", "Bake at 180°C for 35 minutes", "Serve warm with cream"],
    time: 55,
    servings: 8,
    image: "",
    nutrition: { calories: 250, protein: 7, carbs: 38, fat: 8, fiber: 1, sodium: 200, calcium: 110 },
  },
  {
    id: "chocolate_cake",
    nameAr: "كيكة الشوكولاتة",
    nameEn: "Chocolate Cake",
    category: "desserts",
    requiredIngredients: ["flour", "sugar", "eggs", "butter", "chocolate"],
    optionalIngredients: ["milk", "baking_powder", "vanilla"],
    stepsAr: ["نذيب الشوكولاتة والزبدة", "نخفق البيض والسكر جيداً", "نضيف الطحين ومسحوق الخبز والشوكولاتة المذابة", "نسكب في قالب مدهون ونخبز 30 دقيقة على 175 درجة", "نزين بصوص الشوكولاتة"],
    stepsEn: ["Melt chocolate and butter", "Beat eggs and sugar well", "Add flour, baking powder and melted chocolate", "Pour in greased pan, bake 30 min at 175°C", "Decorate with chocolate sauce"],
    time: 50,
    servings: 10,
    image: "",
    nutrition: { calories: 380, protein: 5, carbs: 50, fat: 19, fiber: 2, sodium: 150, calcium: 40 },
  },
  {
    id: "caramel_custard",
    nameAr: "كريم كراميل",
    nameEn: "Crème Caramel",
    category: "desserts",
    requiredIngredients: ["milk", "eggs", "sugar"],
    optionalIngredients: ["vanilla", "cream"],
    stepsAr: ["نذوب السكر على النار حتى يصبح كراميل ذهبياً", "نسكب الكراميل في قوالب", "نخفق البيض مع الحليب والسكر والفانيليا", "نصفي الخليط فوق الكراميل", "نخبز بالبان ماري 45 دقيقة ثم نبرد"],
    stepsEn: ["Melt sugar until golden caramel", "Pour caramel into molds", "Whisk eggs with milk, sugar and vanilla", "Strain mixture over caramel", "Bake in bain-marie 45 min then cool"],
    time: 75,
    servings: 6,
    image: "",
    nutrition: { calories: 200, protein: 6, carbs: 30, fat: 6, fiber: 0, sodium: 80, calcium: 130 },
  },
  {
    id: "maamoul",
    nameAr: "معمول",
    nameEn: "Maamoul",
    category: "desserts",
    requiredIngredients: ["semolina", "butter", "sugar"],
    optionalIngredients: ["rose_water", "dates_fruit", "nuts"],
    stepsAr: ["نعجن السميد مع السمن وماء الورد وينام ليلة", "نحضر حشوة التمر أو المكسرات", "نشكل كرات ونحشوها ونضعها في قوالب معمول", "نخبز على 180 درجة 20 دقيقة حتى تتلون خفيفاً", "نبرد ونرش بالسكر الناعم"],
    stepsEn: ["Knead semolina with ghee and rose water, rest overnight", "Prepare date or nut filling", "Shape balls, fill, and press in maamoul mold", "Bake at 180°C for 20 minutes", "Cool and dust with powdered sugar"],
    time: 90,
    servings: 24,
    image: "",
    nutrition: { calories: 160, protein: 2, carbs: 22, fat: 7, fiber: 1, sodium: 30, calcium: 15 },
  },
  {
    id: "zalabia",
    nameAr: "زلابية",
    nameEn: "Zalabia",
    category: "desserts",
    requiredIngredients: ["flour", "baking_powder", "sugar", "veg_oil"],
    optionalIngredients: ["honey", "rose_water", "cinnamon"],
    stepsAr: ["نحضر عجينة سائلة بالطحين والخميرة والماء", "نترك العجينة 30 دقيقة لتختمر", "نقلي الزلابية في زيت ساخن بأشكال دائرية", "نرفعها حين تصبح ذهبية وهشة", "نغطسها في القطر ونقدمها"],
    stepsEn: ["Prepare liquid batter with flour, yeast and water", "Rest 30 minutes to ferment", "Fry in hot oil making round shapes", "Remove when golden and crispy", "Dip in syrup and serve"],
    time: 45,
    servings: 8,
    image: "",
    nutrition: { calories: 270, protein: 3, carbs: 40, fat: 12, fiber: 1, sodium: 65, calcium: 15 },
  },
  {
    id: "harissa_sweet",
    nameAr: "هريسة (حلوى)",
    nameEn: "Harissa Cake",
    category: "desserts",
    requiredIngredients: ["semolina", "sugar", "butter", "yogurt"],
    optionalIngredients: ["coconut", "nuts", "rose_water"],
    stepsAr: ["نخلط السميد الخشن مع السكر والسمن والزبادي", "نضيف جوز الهند إن أردنا", "نفرد في صينية ونقطع مربعات", "نضع حبة مكسرات على كل قطعة", "نخبز 30 دقيقة ونسكب القطر بعد الخبز"],
    stepsEn: ["Mix coarse semolina with sugar, ghee and yogurt", "Add coconut if desired", "Spread in tray and cut into squares", "Place nut on each piece", "Bake 30 minutes and pour syrup after"],
    time: 45,
    servings: 16,
    image: "",
    nutrition: { calories: 230, protein: 3, carbs: 35, fat: 9, fiber: 1, sodium: 55, calcium: 30 },
  },
  {
    id: "hareeseh",
    nameAr: "هريسة التمر",
    nameEn: "Date Hareeseh",
    category: "desserts",
    requiredIngredients: ["semolina", "date_fruit", "butter"],
    optionalIngredients: ["nuts", "cinnamon", "honey"],
    stepsAr: ["نخلط السميد مع السمن المذاب ونتركه يرتاح", "نعجن التمر المنزوع النوى", "نضع طبقة سميد ثم تمر ثم سميد", "نضغط جيداً ونقطع مربعات", "نخبز 25 دقيقة على 180 درجة"],
    stepsEn: ["Mix semolina with melted ghee and rest", "Knead pitted dates", "Layer semolina then dates then semolina", "Press well and cut into squares", "Bake 25 minutes at 180°C"],
    time: 40,
    servings: 12,
    image: "",
    nutrition: { calories: 210, protein: 2, carbs: 34, fat: 8, fiber: 3, sodium: 25, calcium: 20 },
  },
  {
    id: "sago_pudding",
    nameAr: "بودينج الساغو",
    nameEn: "Sago Pudding",
    category: "desserts",
    requiredIngredients: ["milk", "sugar", "cornmeal"],
    optionalIngredients: ["vanilla", "rose_water", "coconut"],
    stepsAr: ["ننقع حبوب الساغو في ماء بارد 30 دقيقة", "نسخن الحليب مع السكر", "نضيف الساغو ونحرك على نار هادئة حتى يصبح شفافاً", "نضيف الفانيليا وجوز الهند", "نسكب في أكواب ونبرد"],
    stepsEn: ["Soak sago in cold water 30 minutes", "Heat milk with sugar", "Add sago, stir on low heat until transparent", "Add vanilla and coconut", "Pour in cups and refrigerate"],
    time: 50,
    servings: 6,
    image: "",
    nutrition: { calories: 190, protein: 3, carbs: 38, fat: 3, fiber: 0, sodium: 45, calcium: 110 },
  },
  {
    id: "chocolate_mousse",
    nameAr: "موس الشوكولاتة",
    nameEn: "Chocolate Mousse",
    category: "desserts",
    requiredIngredients: ["chocolate", "cream", "eggs", "sugar"],
    optionalIngredients: ["vanilla", "butter"],
    stepsAr: ["نذيب الشوكولاتة بالبان ماري", "نخفق الكريمة حتى تتماسك", "نخفق البيض مع السكر حتى يبيض ويرتفع حجمه", "ندمج الشوكولاتة مع البيض ثم الكريمة", "نسكب في أكواب ونبرد 3 ساعات"],
    stepsEn: ["Melt chocolate in bain-marie", "Whip cream until firm", "Beat eggs with sugar until pale and doubled", "Fold chocolate into eggs then cream", "Pour into cups and refrigerate 3 hours"],
    time: 30,
    servings: 6,
    image: "",
    nutrition: { calories: 340, protein: 5, carbs: 28, fat: 24, fiber: 2, sodium: 60, calcium: 60 },
  },
  {
    id: "atayef_ashta",
    nameAr: "قطايف بالقشطة",
    nameEn: "Qatayef with Ashta",
    category: "desserts",
    requiredIngredients: ["flour", "milk", "sugar", "cream"],
    optionalIngredients: ["rose_water", "nuts", "cinnamon"],
    stepsAr: ["نحضر عجينة القطايف الرقيقة", "نقلي القطايف من طرف واحد فقط", "نحضر القشطة بالكريمة والحليب والنشا", "نحشو القطايف بالقشطة ونضغط الحواف", "نزين بالمكسرات والقطر"],
    stepsEn: ["Prepare thin qatayef batter", "Cook one side only", "Prepare ashta with cream, milk and starch", "Fill qatayef with ashta and seal edges", "Garnish with nuts and syrup"],
    time: 50,
    servings: 10,
    image: "",
    nutrition: { calories: 220, protein: 5, carbs: 30, fat: 9, fiber: 1, sodium: 75, calcium: 90 },
  },
  {
    id: "coconut_balls",
    nameAr: "كرات جوز الهند",
    nameEn: "Coconut Balls",
    category: "desserts",
    requiredIngredients: ["coconut", "sugar", "milk"],
    optionalIngredients: ["chocolate", "vanilla", "butter"],
    stepsAr: ["نخلط جوز الهند المبشور مع الحليب المكثف والسكر", "نضيف الفانيليا ونخلط جيداً", "نشكل كرات صغيرة ونضعها في الثلاجة 30 دقيقة", "نغطسها في الشوكولاتة المذابة اختيارياً", "نبرد حتى تتماسك"],
    stepsEn: ["Mix shredded coconut with condensed milk and sugar", "Add vanilla and mix well", "Shape into small balls, refrigerate 30 minutes", "Optionally dip in melted chocolate", "Refrigerate until set"],
    time: 20,
    servings: 20,
    image: "",
    nutrition: { calories: 140, protein: 1, carbs: 18, fat: 8, fiber: 1, sodium: 20, calcium: 10 },
  },
  {
    id: "date_truffles",
    nameAr: "كرات التمر",
    nameEn: "Date Truffles",
    category: "desserts",
    requiredIngredients: ["date_fruit", "nuts"],
    optionalIngredients: ["coconut", "chocolate", "cinnamon"],
    stepsAr: ["ننزع نوى التمر ونعجنه حتى يصبح عجينة", "نضيف مكسرات مفرومة ناعمة", "نشكل كرات صغيرة", "نغلف كل كرة بجوز الهند أو الشوكولاتة أو المكسرات", "نقدم مباشرة أو نبرد"],
    stepsEn: ["Remove pits and knead dates into paste", "Add finely chopped nuts", "Shape into small balls", "Roll each ball in coconut, chocolate or nuts", "Serve directly or refrigerate"],
    time: 20,
    servings: 15,
    image: "",
    nutrition: { calories: 95, protein: 1, carbs: 20, fat: 3, fiber: 2, sodium: 5, calcium: 15 },
  },
  {
    id: "strawberry_cheesecake",
    nameAr: "تشيز كيك الفراولة",
    nameEn: "Strawberry Cheesecake",
    category: "desserts",
    requiredIngredients: ["cheese", "cream", "sugar", "eggs"],
    optionalIngredients: ["strawberry", "butter", "vanilla"],
    stepsAr: ["نحضر القاعدة ببسكويت وزبدة مطحونة", "نخلط الجبن الكريمي والسكر والبيض والفانيليا", "نصب فوق القاعدة ونخبز 50 دقيقة على 160 درجة", "نبرد في الثلاجة ليلة كاملة", "نزين بالفراولة الطازجة"],
    stepsEn: ["Make base with crushed biscuits and butter", "Mix cream cheese, sugar, eggs and vanilla", "Pour over base, bake 50 min at 160°C", "Refrigerate overnight", "Top with fresh strawberries"],
    time: 90,
    servings: 10,
    image: "",
    nutrition: { calories: 350, protein: 6, carbs: 30, fat: 23, fiber: 1, sodium: 200, calcium: 80 },
  },
  {
    id: "mango_pudding",
    nameAr: "بودينج المانجو",
    nameEn: "Mango Pudding",
    category: "desserts",
    requiredIngredients: ["mango", "milk", "sugar", "cornmeal"],
    optionalIngredients: ["cream", "vanilla"],
    stepsAr: ["نخلط لب المانجو في الخلاط حتى يصبح ناعماً", "نسخن الحليب مع السكر والنشا", "نضيف بيوريه المانجو ونحرك حتى يثخن", "نضيف الفانيليا ونسكب في أكواب", "نبرد ساعتين ونزين بشرائح المانجو"],
    stepsEn: ["Blend mango flesh until smooth", "Heat milk with sugar and starch", "Add mango puree, stir until thick", "Add vanilla and pour into cups", "Refrigerate 2 hours, top with mango slices"],
    time: 25,
    servings: 6,
    image: "",
    nutrition: { calories: 170, protein: 3, carbs: 35, fat: 3, fiber: 1, sodium: 40, calcium: 100 },
  },
  {
    id: "halva",
    nameAr: "حلاوة طحينية",
    nameEn: "Tahini Halva",
    category: "desserts",
    requiredIngredients: ["tahini", "sugar", "honey"],
    optionalIngredients: ["nuts", "chocolate", "vanilla"],
    stepsAr: ["نطبخ السكر مع الماء حتى يصل درجة الكرة اللينة 118 درجة", "نسخن الطحينة قليلاً", "نسكب القطر على الطحينة ونخلط سريعاً", "نضيف المكسرات ونفرد في قالب مدهون", "نبرد 4 ساعات ثم نقطع"],
    stepsEn: ["Cook sugar with water to soft ball stage 118°C", "Warm tahini slightly", "Pour syrup over tahini and mix quickly", "Add nuts and spread in greased mold", "Cool 4 hours then cut"],
    time: 30,
    servings: 12,
    image: "",
    nutrition: { calories: 260, protein: 5, carbs: 28, fat: 16, fiber: 2, sodium: 20, calcium: 50 },
  },
  {
    id: "tiramisu",
    nameAr: "تيراميسو",
    nameEn: "Tiramisu",
    category: "desserts",
    requiredIngredients: ["cream", "eggs", "sugar", "chocolate"],
    optionalIngredients: ["vanilla", "bread"],
    stepsAr: ["نخفق الكريمة الثقيلة حتى تتماسك", "نخلط الجبن الكريمي مع السكر والبيض", "نغمس البسكويت في القهوة ونرتبه في الصينية", "نضع طبقة كريمة ثم بسكويت وهكذا", "نبرد ليلة ونرش بمسحوق الكاكاو"],
    stepsEn: ["Whip heavy cream until stiff", "Mix cream cheese with sugar and eggs", "Dip biscuits in coffee and layer in tray", "Layer cream then biscuits and repeat", "Refrigerate overnight and dust with cocoa"],
    time: 40,
    servings: 8,
    image: "",
    nutrition: { calories: 380, protein: 6, carbs: 32, fat: 26, fiber: 1, sodium: 120, calcium: 70 },
  },
  {
    id: "banana_bread",
    nameAr: "خبز الموز",
    nameEn: "Banana Bread",
    category: "desserts",
    requiredIngredients: ["banana", "flour", "eggs", "sugar", "butter"],
    optionalIngredients: ["nuts", "chocolate", "vanilla"],
    stepsAr: ["نهرس الموز الناضج جيداً", "نخفق البيض مع السكر والزبدة المذابة", "نضيف الموز المهروس والطحين ومسحوق الخبز", "نسكب في قالب الكيكة ونضيف المكسرات", "نخبز 50 دقيقة على 175 درجة"],
    stepsEn: ["Mash ripe bananas well", "Beat eggs with sugar and melted butter", "Add mashed banana, flour and baking powder", "Pour in loaf pan and add nuts", "Bake 50 minutes at 175°C"],
    time: 65,
    servings: 8,
    image: "",
    nutrition: { calories: 240, protein: 4, carbs: 38, fat: 9, fiber: 2, sodium: 130, calcium: 25 },
  },
  {
    id: "panna_cotta",
    nameAr: "بانا كوتا",
    nameEn: "Panna Cotta",
    category: "desserts",
    requiredIngredients: ["cream", "milk", "sugar"],
    optionalIngredients: ["vanilla", "strawberry", "honey"],
    stepsAr: ["ننقع الجيلاتين في ماء بارد", "نسخن الكريمة والحليب مع السكر والفانيليا", "نضيف الجيلاتين المنقوع ونحرك حتى يذوب", "نسكب في قوالب ونبرد في الثلاجة 4 ساعات", "نقلب على الصحن ونزين بالفراولة"],
    stepsEn: ["Soak gelatin in cold water", "Heat cream and milk with sugar and vanilla", "Add soaked gelatin, stir until dissolved", "Pour in molds, refrigerate 4 hours", "Unmold and garnish with strawberries"],
    time: 20,
    servings: 6,
    image: "",
    nutrition: { calories: 280, protein: 3, carbs: 22, fat: 20, fiber: 0, sodium: 45, calcium: 90 },
  },
  {
    id: "saffron_rice_pudding",
    nameAr: "رز بلبن بالزعفران",
    nameEn: "Saffron Rice Pudding",
    category: "desserts",
    requiredIngredients: ["rice", "milk", "sugar", "saffron"],
    optionalIngredients: ["cardamom", "rose_water", "nuts"],
    stepsAr: ["ننقع الزعفران في ماء ورد دافئ", "نطبخ الأرز في الحليب مع السكر على نار هادئة", "نضيف ماء الزعفران والهيل", "نحرك باستمرار حتى يصبح كريمياً", "نسكب في أوعية ونزين بالمكسرات والزعفران"],
    stepsEn: ["Soak saffron in warm rose water", "Cook rice in milk with sugar on low heat", "Add saffron water and cardamom", "Stir continuously until creamy", "Pour in bowls, garnish with nuts and saffron"],
    time: 45,
    servings: 6,
    image: "",
    nutrition: { calories: 210, protein: 5, carbs: 38, fat: 4, fiber: 0, sodium: 55, calcium: 145 },
  },
  {
    id: "kazandibi",
    nameAr: "كازانديبي",
    nameEn: "Kazandibi",
    category: "desserts",
    requiredIngredients: ["milk", "sugar", "cornmeal", "butter"],
    optionalIngredients: ["vanilla", "cinnamon", "rose_water"],
    stepsAr: ["نحضر مزيج الحليب والنشا والسكر على النار ونحرك حتى يثخن", "نضيف الفانيليا", "ندهن قدر ثقيلة بالسكر ونسخنها حتى يتكرمل السكر", "نسكب الخليط فوق الكراميل وندخل الفرن 15 دقيقة", "نقلب ونبرد ثم نقطع شرائح ونلفها"],
    stepsEn: ["Prepare milk, starch and sugar mixture, stir until thick", "Add vanilla", "Coat heavy pan with sugar, heat until caramelized", "Pour mixture over caramel, bake 15 minutes", "Flip, cool, cut into slices and roll"],
    time: 40,
    servings: 8,
    image: "",
    nutrition: { calories: 195, protein: 4, carbs: 34, fat: 5, fiber: 0, sodium: 65, calcium: 130 },
  },
  {
    id: "warbat",
    nameAr: "وربات",
    nameEn: "Warbat",
    category: "desserts",
    requiredIngredients: ["flour", "butter", "cream", "sugar"],
    optionalIngredients: ["rose_water", "nuts", "powdered_sugar"],
    stepsAr: ["نفرد عجينة الفيلو ونبللها بالسمن", "نضع حشوة القشطة في المنتصف", "نطوي الجوانب على شكل مربع أو مثلث", "ندهن بالسمن ونخبز 20 دقيقة على 190 درجة", "نسكب القطر ونرش السكر الناعم"],
    stepsEn: ["Spread phyllo dough and brush with ghee", "Place ashta filling in center", "Fold sides into square or triangle shape", "Brush with ghee, bake 20 min at 190°C", "Pour syrup and dust with powdered sugar"],
    time: 40,
    servings: 12,
    image: "",
    nutrition: { calories: 240, protein: 4, carbs: 28, fat: 13, fiber: 0, sodium: 95, calcium: 55 },
  },
  {
    id: "kaak_cookies",
    nameAr: "كعك العيد",
    nameEn: "Kaak Cookies",
    category: "desserts",
    requiredIngredients: ["flour", "butter", "sugar", "eggs"],
    optionalIngredients: ["vanilla", "cinnamon", "powdered_sugar"],
    stepsAr: ["نخلط الطحين والسكر والفانيليا والزبدة", "نضيف البيض وكمية كافية من الحليب", "نعجن حتى تتشكل عجينة طرية", "نشكل الكعك ونضعه في صينية", "نخبز 15 دقيقة على 180 درجة ونبرد قبل التقديم"],
    stepsEn: ["Mix flour, sugar, vanilla and butter", "Add eggs and enough milk", "Knead until soft dough forms", "Shape cookies and place on tray", "Bake 15 minutes at 180°C and cool before serving"],
    time: 45,
    servings: 24,
    image: "",
    nutrition: { calories: 130, protein: 2, carbs: 18, fat: 6, fiber: 0, sodium: 50, calcium: 15 },
  },

  // ATHLETES MEALS
  // --- Muscle Building & High Protein (15) ---
  {
    id: "grilled_chicken_brown_rice",
    nameAr: "صدر دجاج مشوي مع الأرز البني والخضار",
    nameEn: "Grilled Chicken Breast with Brown Rice & Vegetables",
    category: "athletes",
    requiredIngredients: ["chicken", "rice", "broccoli"],
    optionalIngredients: ["olive_oil", "garlic", "lemon_juice"],
    ingredientQuantities: { chicken: { amount: 200, unit: "جرام" }, rice: { amount: 1, unit: "كوب" }, broccoli: { amount: 150, unit: "جرام" } },
    stepsAr: ["نتبّل صدر الدجاج بالليمون والثوم وزيت الزيتون", "نشوي الدجاج على النار أو الفرن 25 دقيقة", "نسلق الأرز البني مع قليل من الملح", "نطبخ البروكلي على البخار 5 دقائق", "نرتب الوجبة ونقدمها ساخنة"],
    stepsEn: ["Marinate chicken breast with lemon, garlic, and olive oil", "Grill chicken for 25 minutes", "Cook brown rice with a pinch of salt", "Steam broccoli for 5 minutes", "Plate and serve hot"],
    time: 35,
    servings: 1,
    image: "images/recipes/pexels-6210747-600.jpeg",
    nutrition: { calories: 520, protein: 48, carbs: 52, fat: 10, fiber: 6, sodium: 320, calcium: 60 },
  },
  {
    id: "lean_steak_sweet_potato",
    nameAr: "ستيك لحم قليل الدهون مع البطاطا الحلوة",
    nameEn: "Lean Beef Steak with Sweet Potato",
    category: "athletes",
    requiredIngredients: ["beef", "sweet_potato"],
    optionalIngredients: ["olive_oil", "garlic", "pepper"],
    ingredientQuantities: { beef: { amount: 200, unit: "جرام" }, sweet_potato: { amount: 200, unit: "جرام" } },
    stepsAr: ["نتبّل اللحم بالثوم والفلفل وزيت الزيتون", "نشوي اللحم على درجة حرارة عالية 4 دقائق من كل جهة", "نخبز البطاطا الحلوة في الفرن 30 دقيقة على 200 درجة", "نقطع البطاطا ونرش عليها القرفة اختيارياً", "نقدم اللحم مع البطاطا الحلوة"],
    stepsEn: ["Season beef with garlic, pepper, and olive oil", "Grill steak on high heat 4 minutes each side", "Bake sweet potato in oven 30 min at 200°C", "Slice sweet potato and optionally sprinkle cinnamon", "Serve steak with sweet potato"],
    time: 40,
    servings: 1,
    image: "images/recipes/pexels-3535383-600.jpeg",
    nutrition: { calories: 580, protein: 50, carbs: 45, fat: 14, fiber: 5, sodium: 280, calcium: 45 },
  },
  {
    id: "grilled_salmon_quinoa",
    nameAr: "سلمون مشوي مع الكينوا",
    nameEn: "Grilled Salmon with Quinoa",
    category: "athletes",
    requiredIngredients: ["salmon", "quinoa", "lemon_juice"],
    optionalIngredients: ["olive_oil", "garlic", "spinach"],
    ingredientQuantities: { salmon: { amount: 200, unit: "جرام" }, quinoa: { amount: 1, unit: "كوب" }, lemon_juice: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نتبّل السلمون بعصير الليمون والثوم وزيت الزيتون", "نشوي السلمون على الشواية 4-5 دقائق من كل جهة", "نطبخ الكينوا في ماء مملح 15 دقيقة", "نقدم السلمون فوق الكينوا مع السبانخ المطبوخ"],
    stepsEn: ["Marinate salmon with lemon juice, garlic, and olive oil", "Grill salmon 4-5 minutes each side", "Cook quinoa in salted water for 15 minutes", "Serve salmon over quinoa with sautéed spinach"],
    time: 30,
    servings: 1,
    image: "images/recipes/pexels-3655916-600.jpeg",
    nutrition: { calories: 560, protein: 52, carbs: 40, fat: 18, fiber: 4, sodium: 260, calcium: 55 },
  },
  {
    id: "tuna_egg_avocado",
    nameAr: "تونة مع البيض والأفوكادو",
    nameEn: "Tuna with Eggs and Avocado",
    category: "athletes",
    requiredIngredients: ["tuna", "eggs", "avocado"],
    optionalIngredients: ["lemon_juice", "olive_oil", "tomato"],
    ingredientQuantities: { tuna: { amount: 150, unit: "جرام" }, eggs: { amount: 2, unit: "حبة" }, avocado: { amount: 1, unit: "حبة" } },
    stepsAr: ["نسلق البيض 8 دقائق حتى ينضج", "نقطع الأفوكادو ونهرسه مع الليمون", "نضيف التونة المصفاة على الأفوكادو", "نقطع البيض ونضيفه للطبق", "نرش قليل من الفلفل والليمون ونقدم"],
    stepsEn: ["Boil eggs for 8 minutes until hard-cooked", "Mash avocado with lemon juice", "Add drained tuna to avocado", "Slice eggs and add to plate", "Sprinkle pepper and lemon, serve"],
    time: 15,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 450, protein: 42, carbs: 12, fat: 28, fiber: 8, sodium: 380, calcium: 80 },
  },
  {
    id: "chicken_kebab_rice",
    nameAr: "كباب دجاج صحي مع الأرز",
    nameEn: "Healthy Chicken Kebab with Rice",
    category: "athletes",
    requiredIngredients: ["chicken", "rice", "onion", "garlic"],
    optionalIngredients: ["pepper", "olive_oil", "lemon_juice"],
    ingredientQuantities: { chicken: { amount: 250, unit: "جرام" }, rice: { amount: 1, unit: "كوب" }, onion: { amount: 1, unit: "حبة" }, garlic: { amount: 3, unit: "فص" } },
    stepsAr: ["نفرم الدجاج ناعماً مع البصل والثوم والبهارات", "نشكل الكباب على أعواد الشواء", "نشوي الكباب على نار متوسطة 15 دقيقة", "نطبخ الأرز الأبيض أو البني", "نقدم الكباب مع الأرز وسلطة خضراء"],
    stepsEn: ["Grind chicken with onion, garlic, and spices", "Shape kebabs on skewers", "Grill kebabs on medium heat for 15 minutes", "Cook white or brown rice", "Serve kebabs with rice and green salad"],
    time: 30,
    servings: 2,
    image: "images/recipes/pexels-1640772-600.jpeg",
    nutrition: { calories: 490, protein: 46, carbs: 50, fat: 9, fiber: 2, sodium: 310, calcium: 40 },
  },
  {
    id: "shrimp_veggie_rice",
    nameAr: "روبيان مع الخضار والأرز",
    nameEn: "Shrimp with Vegetables and Rice",
    category: "athletes",
    requiredIngredients: ["shrimp", "rice", "broccoli"],
    optionalIngredients: ["olive_oil", "garlic", "lemon_juice", "carrot"],
    ingredientQuantities: { shrimp: { amount: 200, unit: "جرام" }, rice: { amount: 1, unit: "كوب" }, broccoli: { amount: 100, unit: "جرام" } },
    stepsAr: ["نتبّل الروبيان بالثوم والليمون وزيت الزيتون", "نطبخ الروبيان في المقلاة 3 دقائق من كل جهة", "نطبخ الأرز وعلى الجانب نقلي الخضار", "نجمع الروبيان مع الخضار ونقدم فوق الأرز"],
    stepsEn: ["Marinate shrimp with garlic, lemon, and olive oil", "Cook shrimp in pan 3 minutes each side", "Cook rice and separately stir-fry vegetables", "Combine shrimp with vegetables and serve over rice"],
    time: 25,
    servings: 2,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 420, protein: 40, carbs: 48, fat: 7, fiber: 4, sodium: 420, calcium: 90 },
  },
  {
    id: "spinach_egg_white_omelette",
    nameAr: "أومليت البيض مع السبانخ والجبن قليل الدسم",
    nameEn: "Egg White Omelette with Spinach and Low-Fat Cheese",
    category: "athletes",
    requiredIngredients: ["eggs", "spinach", "cheese"],
    optionalIngredients: ["olive_oil", "onion", "pepper"],
    ingredientQuantities: { eggs: { amount: 4, unit: "حبة" }, spinach: { amount: 80, unit: "جرام" }, cheese: { amount: 30, unit: "جرام" } },
    stepsAr: ["نفصل بياض البيض عن الصفار", "نخفق البياض مع الملح والفلفل", "نذبل السبانخ في مقلاة بزيت الزيتون", "نضيف البياض ونطبخ على نار هادئة", "نضيف الجبن قليل الدسم ونطوي الأومليت"],
    stepsEn: ["Separate egg whites from yolks", "Whisk whites with salt and pepper", "Wilt spinach in pan with olive oil", "Add egg whites and cook on low heat", "Add low-fat cheese and fold omelette"],
    time: 12,
    servings: 1,
    image: "images/recipes/pexels-566566-600.jpeg",
    nutrition: { calories: 280, protein: 34, carbs: 5, fat: 12, fiber: 2, sodium: 380, calcium: 160 },
  },
  {
    id: "greek_yogurt_oats_nuts",
    nameAr: "زبادي يوناني مع الشوفان والمكسرات",
    nameEn: "Greek Yogurt with Oats and Nuts",
    category: "athletes",
    requiredIngredients: ["greek_yogurt", "oats", "nuts"],
    optionalIngredients: ["honey", "banana", "berries"],
    ingredientQuantities: { greek_yogurt: { amount: 200, unit: "جرام" }, oats: { amount: 50, unit: "جرام" }, nuts: { amount: 30, unit: "جرام" } },
    stepsAr: ["نضع الزبادي اليوناني في وعاء", "نضيف الشوفان المطبوخ أو النيئ", "نرش المكسرات المطحونة أو الكاملة", "نضيف العسل حسب الرغبة", "نقدم مباشرة أو نبرد في الثلاجة"],
    stepsEn: ["Place Greek yogurt in a bowl", "Add cooked or raw oats", "Sprinkle crushed or whole nuts", "Add honey to taste", "Serve immediately or chill"],
    time: 5,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 380, protein: 28, carbs: 38, fat: 14, fiber: 5, sodium: 80, calcium: 280 },
  },
  {
    id: "chicken_whole_pasta",
    nameAr: "دجاج مع المعكرونة الكاملة",
    nameEn: "Chicken with Whole Wheat Pasta",
    category: "athletes",
    requiredIngredients: ["chicken", "pasta", "tomato"],
    optionalIngredients: ["olive_oil", "garlic", "spinach"],
    ingredientQuantities: { chicken: { amount: 200, unit: "جرام" }, pasta: { amount: 100, unit: "جرام" }, tomato: { amount: 2, unit: "حبة" } },
    stepsAr: ["نطبخ المعكرونة الكاملة في ماء مملح", "نطبخ الدجاج المقطع مع الثوم وزيت الزيتون", "نضيف الطماطم المهروسة ونطبخ 10 دقائق", "نخلط المعكرونة مع الصوص والدجاج", "نقدم مع رشة باسيليكو أو سبانخ"],
    stepsEn: ["Cook whole wheat pasta in salted water", "Cook diced chicken with garlic and olive oil", "Add crushed tomatoes and cook 10 minutes", "Mix pasta with sauce and chicken", "Serve topped with basil or spinach"],
    time: 30,
    servings: 2,
    image: "images/recipes/pexels-1527603-600.jpeg",
    nutrition: { calories: 540, protein: 44, carbs: 58, fat: 11, fiber: 8, sodium: 340, calcium: 55 },
  },
  {
    id: "healthy_ground_beef_potato",
    nameAr: "لحم مفروم صحي مع البطاطا",
    nameEn: "Healthy Ground Beef with Potatoes",
    category: "athletes",
    requiredIngredients: ["beef", "potato", "tomato", "onion"],
    optionalIngredients: ["olive_oil", "garlic", "pepper"],
    ingredientQuantities: { beef: { amount: 200, unit: "جرام" }, potato: { amount: 200, unit: "جرام" }, tomato: { amount: 1, unit: "حبة" } },
    stepsAr: ["نقلي البصل والثوم في زيت الزيتون", "نضيف اللحم المفروم ونطبخ حتى يتغير لونه", "نضيف الطماطم المقطعة والبهارات", "نسلق البطاطا أو نخبزها", "نقدم اللحم مع البطاطا"],
    stepsEn: ["Sauté onion and garlic in olive oil", "Add ground beef and cook until browned", "Add diced tomatoes and spices", "Boil or bake potatoes", "Serve beef mixture with potatoes"],
    time: 35,
    servings: 2,
    image: "images/recipes/pexels-3616956-600.jpeg",
    nutrition: { calories: 500, protein: 42, carbs: 38, fat: 16, fiber: 4, sodium: 350, calcium: 40 },
  },
  {
    id: "lentil_egg_veggies",
    nameAr: "عدس مع البيض والخضار",
    nameEn: "Lentils with Eggs and Vegetables",
    category: "athletes",
    requiredIngredients: ["lentils", "eggs", "spinach"],
    optionalIngredients: ["olive_oil", "garlic", "lemon_juice"],
    ingredientQuantities: { lentils: { amount: 150, unit: "جرام" }, eggs: { amount: 2, unit: "حبة" }, spinach: { amount: 80, unit: "جرام" } },
    stepsAr: ["نسلق العدس في ماء حتى يطرى", "نقلي الثوم والبصل ثم نضيف السبانخ", "نضيف العدس المسلوق ونتبّل", "نقلي البيض أو نسلقه كما نشاء", "نقدم العدس مع البيض والخضار"],
    stepsEn: ["Boil lentils until tender", "Sauté garlic and onion, add spinach", "Add cooked lentils and season", "Fry or boil eggs as preferred", "Serve lentils with eggs and vegetables"],
    time: 30,
    servings: 2,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 380, protein: 30, carbs: 42, fat: 10, fiber: 14, sodium: 200, calcium: 120 },
  },
  {
    id: "chicken_protein_sandwich",
    nameAr: "ساندويتش دجاج بروتين بخبز الحبوب الكاملة",
    nameEn: "High-Protein Chicken Sandwich on Whole Grain Bread",
    category: "athletes",
    requiredIngredients: ["chicken", "bread", "lettuce"],
    optionalIngredients: ["tomato", "cheese", "mustard"],
    ingredientQuantities: { chicken: { amount: 150, unit: "جرام" }, bread: { amount: 2, unit: "شريحة" } },
    stepsAr: ["نشوي صدر الدجاج وتقطعه شرائح", "نحمص خبز الحبوب الكاملة قليلاً", "نضيف الخس والطماطم والخردل", "نضع شرائح الدجاج ونضيف الجبن", "نغلق الساندويتش ونقدم مع خضار"],
    stepsEn: ["Grill chicken breast and slice it", "Lightly toast whole grain bread", "Add lettuce, tomato, and mustard", "Place chicken slices and add cheese", "Close sandwich and serve with vegetables"],
    time: 20,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 420, protein: 40, carbs: 35, fat: 11, fiber: 5, sodium: 480, calcium: 70 },
  },
  {
    id: "chicken_quinoa_salad",
    nameAr: "سلطة دجاج وكينوا",
    nameEn: "Chicken and Quinoa Salad",
    category: "athletes",
    requiredIngredients: ["chicken", "quinoa", "tomato", "lettuce"],
    optionalIngredients: ["olive_oil", "lemon_juice", "cucumber"],
    ingredientQuantities: { chicken: { amount: 180, unit: "جرام" }, quinoa: { amount: 80, unit: "جرام" } },
    stepsAr: ["نشوي الدجاج ونقطعه مكعبات", "نطبخ الكينوا ونتركها تبرد", "نقطع الخضار الطازجة", "نخلط الكينوا مع الخضار والدجاج", "نتبّل بزيت الزيتون وعصير الليمون"],
    stepsEn: ["Grill chicken and dice it", "Cook quinoa and let it cool", "Chop fresh vegetables", "Mix quinoa with vegetables and chicken", "Dress with olive oil and lemon juice"],
    time: 25,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 450, protein: 44, carbs: 38, fat: 10, fiber: 6, sodium: 260, calcium: 55 },
  },
  {
    id: "white_fish_grilled_veggies",
    nameAr: "سمك أبيض مع الخضار المشوية",
    nameEn: "White Fish with Grilled Vegetables",
    category: "athletes",
    requiredIngredients: ["fish_fillet", "broccoli", "carrot"],
    optionalIngredients: ["olive_oil", "lemon_juice", "garlic"],
    ingredientQuantities: { fish_fillet: { amount: 200, unit: "جرام" }, broccoli: { amount: 100, unit: "جرام" }, carrot: { amount: 1, unit: "حبة" } },
    stepsAr: ["نتبّل السمك بالليمون والثوم وزيت الزيتون", "نشوي السمك على الشواية 15 دقيقة", "نشوي الخضار بزيت الزيتون والملح والفلفل", "نقدم السمك مع الخضار المشوية"],
    stepsEn: ["Marinate fish with lemon, garlic, and olive oil", "Grill fish for 15 minutes", "Grill vegetables with olive oil, salt, and pepper", "Serve fish with grilled vegetables"],
    time: 25,
    servings: 1,
    image: "images/recipes/pexels-3655916-600.jpeg",
    nutrition: { calories: 360, protein: 46, carbs: 14, fat: 12, fiber: 5, sodium: 290, calcium: 80 },
  },
  {
    id: "homemade_healthy_burger",
    nameAr: "برغر منزلي صحي عالي البروتين",
    nameEn: "Healthy Homemade High-Protein Burger",
    category: "athletes",
    requiredIngredients: ["beef", "bread", "lettuce", "tomato"],
    optionalIngredients: ["cheese", "mustard", "onion"],
    ingredientQuantities: { beef: { amount: 200, unit: "جرام" }, bread: { amount: 1, unit: "خبزة" } },
    stepsAr: ["نعجن اللحم المفروم مع البهارات والثوم", "نشكل كبة البرغر ونشويها 5 دقائق من كل جهة", "نحمص الخبز ونضيف الخس والطماطم", "نضع كبة البرغر ونضيف الجبن", "نقدم مع سلطة خضراء بدلاً من البطاطس"],
    stepsEn: ["Mix ground beef with spices and garlic", "Form burger patty and grill 5 minutes each side", "Toast bun and add lettuce and tomato", "Place burger patty and add cheese", "Serve with green salad instead of fries"],
    time: 20,
    servings: 1,
    image: "images/recipes/pexels-1639557-600.jpeg",
    nutrition: { calories: 520, protein: 50, carbs: 28, fat: 22, fiber: 3, sodium: 460, calcium: 80 },
  },

  // --- Pre-Workout Meals (8) ---
  {
    id: "oats_banana_peanut",
    nameAr: "شوفان مع الموز وزبدة الفول السوداني",
    nameEn: "Oats with Banana and Peanut Butter",
    category: "athletes",
    requiredIngredients: ["oats", "banana", "peanut_butter"],
    optionalIngredients: ["honey", "milk"],
    ingredientQuantities: { oats: { amount: 80, unit: "جرام" }, banana: { amount: 1, unit: "حبة" }, peanut_butter: { amount: 2, unit: "ملعقة ك." } },
    stepsAr: ["نطبخ الشوفان في الحليب أو الماء حتى يغلظ", "نقطع الموز ونضعه فوق الشوفان", "نضيف زبدة الفول السوداني", "نرش قليل من العسل أو القرفة", "نقدم دافئاً قبل التمرين بساعة"],
    stepsEn: ["Cook oats in milk or water until thick", "Slice banana and place on oats", "Add peanut butter on top", "Drizzle honey or cinnamon", "Serve warm 1 hour before workout"],
    time: 10,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 480, protein: 16, carbs: 72, fat: 16, fiber: 9, sodium: 100, calcium: 120 },
  },
  {
    id: "whole_grain_toast_egg",
    nameAr: "توست الحبوب الكاملة مع البيض",
    nameEn: "Whole Grain Toast with Eggs",
    category: "athletes",
    requiredIngredients: ["bread", "eggs", "tomato"],
    optionalIngredients: ["olive_oil", "cheese", "spinach"],
    ingredientQuantities: { bread: { amount: 2, unit: "شريحة" }, eggs: { amount: 2, unit: "حبة" } },
    stepsAr: ["نحمص خبز الحبوب الكاملة في المحمصة", "نقلي البيض أو نسلقه حسب الرغبة", "نقطع الطماطم وندهن الخبز بزيت الزيتون", "نضع البيض فوق الخبز مع الطماطم", "نقدم فوراً قبل التمرين"],
    stepsEn: ["Toast whole grain bread in toaster", "Fry or boil eggs as preferred", "Slice tomatoes and brush bread with olive oil", "Place eggs on toast with tomatoes", "Serve immediately before workout"],
    time: 10,
    servings: 1,
    image: "images/recipes/pexels-566566-600.jpeg",
    nutrition: { calories: 340, protein: 20, carbs: 36, fat: 12, fiber: 5, sodium: 380, calcium: 100 },
  },
  {
    id: "banana_milk_oat_smoothie",
    nameAr: "سموذي الموز والحليب والشوفان",
    nameEn: "Banana Milk and Oat Smoothie",
    category: "athletes",
    requiredIngredients: ["banana", "milk", "oats"],
    optionalIngredients: ["honey", "peanut_butter", "cinnamon"],
    ingredientQuantities: { banana: { amount: 2, unit: "حبة" }, milk: { amount: 300, unit: "مل" }, oats: { amount: 50, unit: "جرام" } },
    stepsAr: ["نضع الموز والحليب والشوفان في الخلاط", "نضيف العسل وزبدة الفول السوداني اختيارياً", "نخلط حتى يصبح ناعماً وكريمياً", "نقدم مبرداً قبل التمرين بـ 30-45 دقيقة"],
    stepsEn: ["Place banana, milk, and oats in blender", "Add honey and peanut butter optionally", "Blend until smooth and creamy", "Serve chilled 30-45 minutes before workout"],
    time: 5,
    servings: 1,
    image: "images/recipes/pexels-1435735-600.jpeg",
    nutrition: { calories: 420, protein: 14, carbs: 68, fat: 8, fiber: 6, sodium: 100, calcium: 280 },
  },
  {
    id: "dates_nuts_yogurt",
    nameAr: "تمر مع المكسرات والزبادي",
    nameEn: "Dates with Nuts and Yogurt",
    category: "athletes",
    requiredIngredients: ["date_fruit", "nuts", "greek_yogurt"],
    optionalIngredients: ["honey", "cinnamon"],
    ingredientQuantities: { date_fruit: { amount: 5, unit: "حبة" }, nuts: { amount: 30, unit: "جرام" }, greek_yogurt: { amount: 150, unit: "جرام" } },
    stepsAr: ["نضع الزبادي في وعاء", "نضيف التمور المنزوعة النوى", "نرش المكسرات المفرومة", "نضيف العسل والقرفة حسب الرغبة", "نقدم كوجبة خفيفة قبل التمرين"],
    stepsEn: ["Place yogurt in a bowl", "Add pitted dates", "Sprinkle chopped nuts", "Add honey and cinnamon to taste", "Serve as a pre-workout snack"],
    time: 5,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 360, protein: 15, carbs: 52, fat: 12, fiber: 5, sodium: 55, calcium: 180 },
  },
  {
    id: "light_chicken_rice_preworkout",
    nameAr: "أرز مع الدجاج بكمية خفيفة قبل التمرين",
    nameEn: "Light Chicken Rice Pre-Workout",
    category: "athletes",
    requiredIngredients: ["chicken", "rice"],
    optionalIngredients: ["olive_oil", "lemon_juice"],
    ingredientQuantities: { chicken: { amount: 120, unit: "جرام" }, rice: { amount: 80, unit: "جرام" } },
    stepsAr: ["نشوي أو نسلق الدجاج", "نطبخ الأرز مع قليل من الملح", "نقطع الدجاج ونضيفه للأرز", "نتبّل بعصير الليمون", "نأكل قبل التمرين بـ 90 دقيقة"],
    stepsEn: ["Grill or boil chicken", "Cook rice with a pinch of salt", "Shred chicken and add to rice", "Season with lemon juice", "Eat 90 minutes before workout"],
    time: 20,
    servings: 1,
    image: "images/recipes/pexels-6210747-600.jpeg",
    nutrition: { calories: 340, protein: 28, carbs: 42, fat: 6, fiber: 1, sodium: 200, calcium: 25 },
  },
  {
    id: "fruit_greek_yogurt_preworkout",
    nameAr: "فواكه مع زبادي يوناني قبل التمرين",
    nameEn: "Fruits with Greek Yogurt Pre-Workout",
    category: "athletes",
    requiredIngredients: ["greek_yogurt", "banana", "strawberry"],
    optionalIngredients: ["honey", "oats"],
    ingredientQuantities: { greek_yogurt: { amount: 200, unit: "جرام" }, banana: { amount: 1, unit: "حبة" }, strawberry: { amount: 100, unit: "جرام" } },
    stepsAr: ["نضع الزبادي اليوناني في وعاء", "نقطع الموز والفراولة", "نضيف الفواكه فوق الزبادي", "نرش الشوفان والعسل", "نقدم بارداً قبل التمرين بساعة"],
    stepsEn: ["Place Greek yogurt in a bowl", "Slice banana and strawberries", "Add fruits on top of yogurt", "Sprinkle oats and honey", "Serve cold 1 hour before workout"],
    time: 5,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 300, protein: 20, carbs: 48, fat: 4, fiber: 5, sodium: 70, calcium: 220 },
  },
  {
    id: "sweet_potato_protein",
    nameAr: "بطاطا حلوة مع البروتين",
    nameEn: "Sweet Potato with Protein",
    category: "athletes",
    requiredIngredients: ["sweet_potato", "chicken"],
    optionalIngredients: ["olive_oil", "cinnamon"],
    ingredientQuantities: { sweet_potato: { amount: 200, unit: "جرام" }, chicken: { amount: 100, unit: "جرام" } },
    stepsAr: ["نخبز البطاطا الحلوة في الفرن 30 دقيقة", "نشوي الدجاج ونقطعه مكعبات", "نشق البطاطا ونضع الدجاج بداخلها", "نرش القرفة وزيت الزيتون", "نقدم دافئاً كوجبة قبل التمرين"],
    stepsEn: ["Bake sweet potato in oven for 30 minutes", "Grill chicken and dice it", "Split sweet potato and fill with chicken", "Sprinkle cinnamon and olive oil", "Serve warm as pre-workout meal"],
    time: 35,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 380, protein: 26, carbs: 52, fat: 7, fiber: 7, sodium: 200, calcium: 55 },
  },
  {
    id: "light_tuna_sandwich",
    nameAr: "ساندويتش تونة خفيف قبل التمرين",
    nameEn: "Light Tuna Sandwich Pre-Workout",
    category: "athletes",
    requiredIngredients: ["tuna", "bread", "lettuce"],
    optionalIngredients: ["tomato", "lemon_juice", "mustard"],
    ingredientQuantities: { tuna: { amount: 120, unit: "جرام" }, bread: { amount: 2, unit: "شريحة" } },
    stepsAr: ["نصفي التونة ونضيف عصير الليمون", "نحمص الخبز خفيفاً", "نضيف الخس والطماطم على الخبز", "نضع التونة ونغلق الساندويتش", "نأكل قبل التمرين بـ 60-90 دقيقة"],
    stepsEn: ["Drain tuna and add lemon juice", "Lightly toast the bread", "Add lettuce and tomato on bread", "Place tuna and close sandwich", "Eat 60-90 minutes before workout"],
    time: 8,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 320, protein: 32, carbs: 34, fat: 6, fiber: 4, sodium: 460, calcium: 60 },
  },

  // --- Post-Workout Meals (7) ---
  {
    id: "chicken_rice_veggie_recovery",
    nameAr: "دجاج مع الأرز والخضار لاستعادة الطاقة",
    nameEn: "Chicken Rice and Vegetables for Energy Recovery",
    category: "athletes",
    requiredIngredients: ["chicken", "rice", "broccoli"],
    optionalIngredients: ["olive_oil", "garlic", "carrot"],
    ingredientQuantities: { chicken: { amount: 250, unit: "جرام" }, rice: { amount: 1.5, unit: "كوب" }, broccoli: { amount: 150, unit: "جرام" } },
    stepsAr: ["نشوي الدجاج أو نطبخه بالبخار", "نطبخ الأرز البني", "نطبخ الخضار بالبخار للحفاظ على القيمة الغذائية", "نرتب الوجبة ونتبّل بالملح والليمون", "نأكل خلال 30-60 دقيقة بعد التمرين"],
    stepsEn: ["Grill or steam chicken", "Cook brown rice", "Steam vegetables to preserve nutrition", "Plate meal and season with salt and lemon", "Eat within 30-60 minutes post-workout"],
    time: 35,
    servings: 1,
    image: "images/recipes/pexels-6210747-600.jpeg",
    nutrition: { calories: 600, protein: 52, carbs: 66, fat: 10, fiber: 7, sodium: 340, calcium: 70 },
  },
  {
    id: "fish_potato_recovery",
    nameAr: "سمك مع البطاطا بعد التمرين",
    nameEn: "Fish with Potatoes Post-Workout",
    category: "athletes",
    requiredIngredients: ["fish_fillet", "potato"],
    optionalIngredients: ["olive_oil", "lemon_juice", "garlic"],
    ingredientQuantities: { fish_fillet: { amount: 200, unit: "جرام" }, potato: { amount: 200, unit: "جرام" } },
    stepsAr: ["نتبّل السمك بالليمون والثوم", "نشوي السمك في الفرن 20 دقيقة", "نسلق البطاطا أو نخبزها", "نقدم السمك مع البطاطا والسلطة", "نأكل مباشرة بعد التمرين"],
    stepsEn: ["Season fish with lemon and garlic", "Bake fish in oven for 20 minutes", "Boil or bake potatoes", "Serve fish with potatoes and salad", "Eat right after workout"],
    time: 30,
    servings: 1,
    image: "images/recipes/pexels-3655916-600.jpeg",
    nutrition: { calories: 480, protein: 48, carbs: 42, fat: 12, fiber: 4, sodium: 280, calcium: 75 },
  },
  {
    id: "natural_protein_fruit_smoothie",
    nameAr: "سموذي بروتين طبيعي بالفواكه",
    nameEn: "Natural Protein Fruit Smoothie",
    category: "athletes",
    requiredIngredients: ["banana", "greek_yogurt", "strawberry"],
    optionalIngredients: ["milk", "oats", "honey"],
    ingredientQuantities: { banana: { amount: 1, unit: "حبة" }, greek_yogurt: { amount: 200, unit: "جرام" }, strawberry: { amount: 100, unit: "جرام" } },
    stepsAr: ["نضع جميع المكونات في الخلاط", "نضيف الحليب أو الماء للتخفيف", "نخلط حتى يصبح ناعماً", "نشرب مباشرة بعد التمرين"],
    stepsEn: ["Place all ingredients in blender", "Add milk or water to thin", "Blend until smooth", "Drink immediately after workout"],
    time: 5,
    servings: 1,
    image: "images/recipes/pexels-1435735-600.jpeg",
    nutrition: { calories: 340, protein: 22, carbs: 54, fat: 4, fiber: 6, sodium: 90, calcium: 250 },
  },
  {
    id: "whole_eggs_egg_whites_veggies",
    nameAr: "بيض كامل مع بياض البيض والخضار",
    nameEn: "Whole Eggs with Egg Whites and Vegetables",
    category: "athletes",
    requiredIngredients: ["eggs", "spinach", "tomato"],
    optionalIngredients: ["olive_oil", "pepper", "cheese"],
    ingredientQuantities: { eggs: { amount: 3, unit: "حبة" } },
    stepsAr: ["نخفق 1 بيضة كاملة مع 3 بياضات بيض", "نقلي البصل والطماطم والسبانخ", "نضيف البيض ونطبخه على نار هادئة", "نضيف الملح والفلفل", "نقدم مباشرة بعد التمرين"],
    stepsEn: ["Whisk 1 whole egg with 3 egg whites", "Sauté onion, tomato, and spinach", "Add eggs and cook on low heat", "Season with salt and pepper", "Serve right after workout"],
    time: 12,
    servings: 1,
    image: "images/recipes/pexels-566566-600.jpeg",
    nutrition: { calories: 240, protein: 30, carbs: 8, fat: 9, fiber: 2, sodium: 310, calcium: 80 },
  },
  {
    id: "quinoa_chicken_postworkout",
    nameAr: "كينوا مع الدجاج بعد التمرين",
    nameEn: "Quinoa with Chicken Post-Workout",
    category: "athletes",
    requiredIngredients: ["quinoa", "chicken", "spinach"],
    optionalIngredients: ["olive_oil", "lemon_juice", "garlic"],
    ingredientQuantities: { quinoa: { amount: 100, unit: "جرام" }, chicken: { amount: 200, unit: "جرام" } },
    stepsAr: ["نطبخ الكينوا في ماء مملح 15 دقيقة", "نشوي الدجاج ونقطعه مكعبات", "نقلي الثوم والسبانخ سريعاً", "نخلط الكينوا مع الدجاج والسبانخ", "نتبّل بالليمون ونقدم"],
    stepsEn: ["Cook quinoa in salted water 15 minutes", "Grill chicken and dice it", "Quickly sauté garlic and spinach", "Mix quinoa with chicken and spinach", "Season with lemon and serve"],
    time: 25,
    servings: 1,
    image: "images/recipes/pexels-6210747-600.jpeg",
    nutrition: { calories: 520, protein: 50, carbs: 44, fat: 12, fiber: 6, sodium: 280, calcium: 65 },
  },
  {
    id: "greek_yogurt_fruit_nuts_postworkout",
    nameAr: "لبن يوناني مع الفواكه والمكسرات بعد التمرين",
    nameEn: "Greek Yogurt with Fruits and Nuts Post-Workout",
    category: "athletes",
    requiredIngredients: ["greek_yogurt", "banana", "nuts"],
    optionalIngredients: ["honey", "strawberry", "oats"],
    ingredientQuantities: { greek_yogurt: { amount: 250, unit: "جرام" }, banana: { amount: 1, unit: "حبة" }, nuts: { amount: 25, unit: "جرام" } },
    stepsAr: ["نضع الزبادي اليوناني في وعاء", "نقطع الموز وأي فاكهة أخرى", "نضيف الفواكه فوق الزبادي", "نرش المكسرات والعسل", "نأكل خلال 45 دقيقة من التمرين"],
    stepsEn: ["Place Greek yogurt in a bowl", "Slice banana and other fruits", "Add fruits on top of yogurt", "Sprinkle nuts and honey", "Eat within 45 minutes of workout"],
    time: 5,
    servings: 1,
    image: "images/recipes/pexels-1640777-600.jpeg",
    nutrition: { calories: 390, protein: 25, carbs: 48, fat: 14, fiber: 5, sodium: 75, calcium: 300 },
  },
  {
    id: "complete_protein_meal",
    nameAr: "وجبة بروتين متكاملة (لحم + كربوهيدرات + خضار)",
    nameEn: "Complete Protein Meal (Meat + Carbs + Vegetables)",
    category: "athletes",
    requiredIngredients: ["beef", "rice", "broccoli", "carrot"],
    optionalIngredients: ["olive_oil", "garlic", "lemon_juice"],
    ingredientQuantities: { beef: { amount: 200, unit: "جرام" }, rice: { amount: 1, unit: "كوب" }, broccoli: { amount: 100, unit: "جرام" }, carrot: { amount: 1, unit: "حبة" } },
    stepsAr: ["نشوي اللحم مع التوابل", "نطبخ الأرز البني", "نطبخ البروكلي والجزر بالبخار", "نرتب الوجبة على طبق", "نتبّل بزيت الزيتون والليمون ونقدم"],
    stepsEn: ["Grill beef with spices", "Cook brown rice", "Steam broccoli and carrots", "Plate the meal", "Dress with olive oil and lemon, serve"],
    time: 40,
    servings: 1,
    image: "images/recipes/pexels-3535383-600.jpeg",
    nutrition: { calories: 640, protein: 56, carbs: 62, fat: 16, fiber: 8, sodium: 360, calcium: 70 },
  },
];

export const nutritionTableData = [
];

export type Allergen = "gluten" | "dairy" | "lactose" | "eggs" | "peanuts" | "tree_nuts" | "soy" | "fish" | "shellfish" | "sesame" | "mustard" | "celery" | "sulfites" | "lupin" | "mollusks";
export type DietaryPreference = "standard" | "vegetarian" | "vegan" | "keto" | "low_carb" | "mediterranean" | "halal" | "gluten_free" | "dairy_free";

export const ALLERGEN_LIST: Allergen[] = [
  "gluten", "dairy", "lactose", "eggs", "peanuts", "tree_nuts",
  "soy", "fish", "shellfish", "sesame", "mustard", "celery",
  "sulfites", "lupin", "mollusks",
];

export const DIETARY_PREFS: DietaryPreference[] = [
  "standard", "vegetarian", "vegan", "keto", "low_carb",
  "mediterranean", "halal", "gluten_free", "dairy_free",
];

export const ALLERGEN_INGREDIENT_MAP: Record<string, string[]> = {
  dairy:     ["milk", "yogurt", "cheese", "butter", "cream", "ghee", "labneh", "mozzarella", "feta", "halloumi", "cream_cheese", "qashta", "condensed_milk", "powdered_milk"],
  lactose:   ["milk", "yogurt", "cheese", "butter", "cream", "ghee", "labneh", "mozzarella", "feta", "halloumi", "cream_cheese", "qashta", "condensed_milk", "powdered_milk"],
  gluten:    ["pasta", "bread", "flour"],
  eggs:      ["eggs"],
  soy:       ["soy_sauce"],
  fish:      ["salmon", "tuna", "fish", "sea_bass", "sea_bream", "sardine", "mackerel", "cod", "halibut", "red_mullet", "anchovy", "swordfish", "snapper", "grouper", "pomfret", "tilapia", "carp", "catfish", "trout", "perch", "mullet", "sobour", "byakh"],
  shellfish: ["shrimp"],
  sesame:    ["tahini", "sesame"],
  celery:    ["celery"],
};

export const ALLERGEN_KEYWORDS: Record<string, string[]> = {
  dairy:     ["milk", "cheese", "cream", "butter", "yogurt", "lactose", "dairy", "whey", "casein", "ghee", "labneh", "mozzarella", "feta", "halloumi"],
  lactose:   ["milk", "cheese", "cream", "butter", "yogurt", "lactose", "dairy", "whey", "casein", "ghee", "labneh"],
  gluten:    ["wheat", "flour", "bread", "pasta", "gluten", "barley", "rye", "semolina"],
  eggs:      ["egg", "yolk", "albumen"],
  peanuts:   ["peanut", "groundnut"],
  tree_nuts: ["almond", "walnut", "cashew", "pecan", "hazelnut", "pistachio", "macadamia", "pine nut"],
  soy:       ["soy", "tofu", "edamame", "miso", "tempeh"],
  fish:      ["fish", "salmon", "tuna", "cod", "sardine", "anchovy", "tilapia", "bass", "halibut"],
  shellfish: ["shrimp", "prawn", "crayfish", "barnacle"],
  sesame:    ["sesame", "tahini"],
  mustard:   ["mustard"],
  celery:    ["celery", "celeriac"],
  sulfites:  ["wine", "vinegar", "dried fruit", "preserved"],
  lupin:     ["lupin", "lupine"],
  mollusks:  ["clam", "oyster", "mussel", "scallop", "snail"],
};

export const INGREDIENT_SUBSTITUTES: Record<string, { name: string; reason: string }[]> = {
  milk:       [{ name: "Oat milk", reason: "dairy-free" }, { name: "Almond milk", reason: "dairy-free" }, { name: "Soy milk", reason: "dairy-free" }],
  butter:     [{ name: "Coconut oil", reason: "dairy-free" }, { name: "Olive oil", reason: "dairy-free" }],
  cream:      [{ name: "Coconut cream", reason: "dairy-free" }, { name: "Cashew cream", reason: "dairy-free" }],
  cheese:     [{ name: "Nutritional yeast", reason: "dairy-free" }, { name: "Vegan cheese", reason: "dairy-free" }],
  yogurt:     [{ name: "Coconut yogurt", reason: "dairy-free" }, { name: "Soy yogurt", reason: "dairy-free" }],
  eggs:       [{ name: "Flax egg (1 tbsp flaxseed + 3 tbsp water)", reason: "egg-free" }, { name: "Chia egg", reason: "egg-free" }],
  flour:      [{ name: "Almond flour", reason: "gluten-free" }, { name: "Rice flour", reason: "gluten-free" }, { name: "Oat flour (GF)", reason: "gluten-free" }],
  bread:      [{ name: "Gluten-free bread", reason: "gluten-free" }, { name: "Lettuce wraps", reason: "gluten-free" }],
  pasta:      [{ name: "Rice pasta", reason: "gluten-free" }, { name: "Zucchini noodles", reason: "gluten-free, low-carb" }],
  soy_sauce:  [{ name: "Coconut aminos", reason: "soy-free, gluten-free" }, { name: "Tamari (GF)", reason: "gluten-free" }],
  tahini:     [{ name: "Sunflower seed butter", reason: "sesame-free" }, { name: "Almond butter", reason: "sesame-free" }],
  shrimp:     [{ name: "Hearts of palm", reason: "shellfish-free" }, { name: "Mushrooms", reason: "shellfish-free" }],
  salmon:     [{ name: "Tofu (marinated)", reason: "fish-free" }, { name: "Jackfruit", reason: "fish-free" }],
};

